function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("clipPath", {
  id: "b09ed15fb0"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 0 111.734375 L 449.910156 111.734375 L 449.910156 188.234375 L 0 188.234375 Z M 0 111.734375 "
}));

var _ref2 = /*#__PURE__*/React.createElement("clipPath", {
  id: "5e5447b013"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 30 136 L 75 136 L 75 166 L 30 166 Z M 30 136 "
}));

var _ref3 = /*#__PURE__*/React.createElement("clipPath", {
  id: "3d6f053119"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 60.941406 139.582031 C 60.785156 139.890625 59.5625 142.949219 57.117188 148.914062 C 56.964844 149.21875 56.65625 149.371094 56.199219 149.371094 L 51.304688 149.371094 C 50.996094 149.371094 50.996094 149.371094 50.996094 149.371094 C 51.152344 149.066406 51.761719 147.382812 54.820312 140.195312 C 54.972656 139.886719 55.128906 139.734375 55.738281 139.734375 L 60.632812 139.734375 C 60.941406 139.582031 60.941406 139.582031 60.941406 139.582031 M 55.585938 152.890625 C 55.433594 153.351562 53.445312 158.398438 51.914062 162.070312 C 51.761719 162.527344 51.457031 162.679688 50.996094 162.679688 L 46.101562 162.679688 C 45.796875 162.679688 45.796875 162.679688 45.796875 162.679688 C 45.949219 162.375 46.714844 160.539062 49.46875 153.503906 C 49.621094 153.195312 49.773438 153.042969 50.386719 153.042969 L 55.28125 153.042969 C 55.433594 152.738281 55.585938 152.738281 55.585938 152.890625 C 55.585938 152.738281 55.585938 152.890625 55.585938 152.890625 M 72.257812 147.230469 C 72.257812 147.230469 74.398438 141.878906 74.398438 141.878906 C 74.554688 141.417969 74.707031 141.113281 74.707031 140.652344 C 74.859375 139.277344 74.398438 138.207031 73.480469 137.289062 C 72.566406 136.371094 71.1875 136.0625 69.503906 136.0625 L 40.136719 136.0625 C 39.371094 136.0625 39.21875 136.523438 39.21875 136.675781 C 39.21875 136.675781 39.21875 136.675781 39.21875 136.828125 C 39.21875 136.980469 39.371094 137.289062 40.136719 138.207031 C 40.597656 138.664062 40.902344 139.125 40.902344 139.429688 C 40.902344 139.429688 40.902344 139.429688 40.902344 139.582031 C 40.902344 139.582031 40.902344 139.734375 40.902344 139.890625 C 40.902344 140.042969 30.65625 164.824219 30.65625 164.824219 L 30.65625 164.976562 C 30.65625 164.976562 30.65625 165.128906 30.65625 165.128906 C 30.65625 165.433594 30.808594 165.585938 30.808594 165.585938 C 30.960938 165.742188 31.265625 165.894531 31.726562 165.894531 L 57.726562 165.894531 C 59.714844 165.894531 61.550781 165.28125 63.386719 164.363281 C 65.222656 163.292969 66.445312 161.917969 67.058594 160.386719 L 69.199219 155.03125 C 69.351562 154.574219 69.503906 154.269531 69.503906 153.808594 C 69.503906 153.65625 69.503906 153.65625 69.503906 153.503906 C 69.503906 152.738281 69.046875 151.820312 68.128906 150.902344 C 70.269531 149.832031 71.648438 148.609375 72.257812 147.230469 "
}));

var _ref4 = /*#__PURE__*/React.createElement("clipPath", {
  id: "51e6853c6d"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 70 136 L 114 136 L 114 167 L 70 167 Z M 70 136 "
}));

var _ref5 = /*#__PURE__*/React.createElement("clipPath", {
  id: "13271a3d2e"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 84.496094 162.527344 C 84.496094 162.527344 84.496094 162.375 84.496094 162.375 C 84.496094 162.375 93.671875 140.042969 93.671875 140.042969 C 93.824219 139.890625 93.980469 139.582031 94.589844 139.582031 L 99.484375 139.582031 C 99.636719 139.582031 99.789062 139.582031 99.789062 139.582031 C 99.789062 139.582031 99.789062 139.734375 99.789062 139.734375 C 99.789062 139.890625 90.765625 162.070312 90.765625 162.070312 C 90.613281 162.375 90.460938 162.679688 89.847656 162.679688 L 85.105469 162.679688 C 84.648438 162.679688 84.496094 162.527344 84.496094 162.527344 Z M 113.402344 140.804688 C 113.558594 139.429688 113.097656 138.359375 112.179688 137.441406 C 111.261719 136.523438 109.886719 136.21875 108.203125 136.21875 L 88.011719 136.21875 C 86.023438 136.21875 84.1875 136.828125 82.355469 137.898438 C 80.519531 138.972656 79.292969 140.347656 78.683594 141.722656 L 71.1875 160.234375 C 71.035156 160.691406 70.882812 161 70.882812 161.457031 C 70.730469 162.835938 71.1875 163.90625 72.105469 164.824219 C 73.023438 165.585938 74.398438 166.046875 76.082031 166.046875 L 96.273438 166.046875 C 98.261719 166.046875 100.097656 165.433594 101.933594 164.515625 C 103.769531 163.445312 104.992188 162.070312 105.601562 160.539062 L 113.097656 142.03125 C 113.25 141.570312 113.402344 141.113281 113.402344 140.804688 "
}));

var _ref6 = /*#__PURE__*/React.createElement("clipPath", {
  id: "2cb828fedd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 105 136 L 148 136 L 148 167 L 105 167 Z M 105 136 "
}));

var _ref7 = /*#__PURE__*/React.createElement("clipPath", {
  id: "70324f9bad"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 128.851562 157.175781 C 128.851562 157.328125 128.851562 157.480469 128.394531 157.480469 L 120.132812 157.480469 C 120.132812 157.480469 120.132812 157.480469 119.980469 157.480469 C 119.980469 157.480469 119.980469 157.328125 119.980469 157.328125 C 119.980469 157.328125 127.933594 147.84375 127.933594 147.84375 C 128.089844 148.148438 128.851562 157.019531 128.851562 157.175781 M 127.476562 147.078125 Z M 143.535156 136.21875 C 143.535156 136.21875 128.242188 136.371094 128.242188 136.371094 C 127.171875 136.371094 127.015625 136.980469 127.015625 137.289062 C 127.015625 137.59375 127.015625 138.054688 127.171875 138.664062 C 127.324219 139.277344 127.324219 139.734375 127.324219 139.886719 C 127.324219 140.195312 127.171875 140.5 126.863281 140.804688 C 105.601562 164.976562 105.601562 164.976562 105.601562 165.28125 C 105.601562 165.585938 105.601562 165.742188 105.757812 165.742188 C 105.910156 165.894531 106.214844 166.046875 106.519531 166.046875 L 111.261719 166.046875 C 112.027344 166.046875 112.640625 165.742188 113.097656 165.128906 C 113.097656 165.128906 116.464844 161.304688 116.464844 161.304688 C 116.769531 160.84375 117.226562 160.691406 117.839844 160.691406 L 128.546875 160.691406 C 129.160156 160.691406 129.160156 161 129.160156 161.152344 L 129.617188 165.128906 C 129.617188 165.433594 129.921875 166.046875 130.996094 166.046875 L 145.984375 166.046875 C 146.902344 166.046875 147.207031 165.433594 147.207031 165.128906 L 147.207031 164.976562 L 144.609375 137.136719 C 144.914062 136.828125 144.609375 136.21875 143.535156 136.21875 "
}));

var _ref8 = /*#__PURE__*/React.createElement("clipPath", {
  id: "a34f084429"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 149 136 L 187 136 L 187 166 L 149 166 Z M 149 136 "
}));

var _ref9 = /*#__PURE__*/React.createElement("clipPath", {
  id: "aed4fe9ae2"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 186.210938 137.136719 C 186.210938 136.828125 186.210938 136.675781 186.058594 136.523438 C 185.90625 136.371094 185.601562 136.21875 185.140625 136.21875 L 149.960938 136.21875 C 149.195312 136.21875 149.042969 136.523438 149.042969 136.828125 C 149.042969 136.980469 149.042969 137.136719 150.574219 138.972656 C 150.878906 139.429688 151.492188 139.582031 152.253906 139.582031 L 160.515625 139.582031 C 160.820312 139.582031 160.820312 139.582031 160.820312 139.582031 C 160.820312 139.582031 160.820312 139.582031 160.820312 139.734375 C 160.820312 139.886719 150.574219 164.667969 150.574219 164.667969 L 150.574219 164.824219 C 150.574219 164.824219 150.574219 164.976562 150.574219 164.976562 C 150.574219 165.28125 150.726562 165.433594 150.726562 165.433594 C 150.878906 165.585938 151.183594 165.742188 151.644531 165.742188 L 163.269531 165.742188 C 164.1875 165.742188 164.644531 165.28125 164.796875 164.824219 C 164.796875 164.824219 174.894531 139.734375 174.894531 139.734375 C 175.046875 139.582031 175.199219 139.277344 175.8125 139.277344 L 184.070312 139.277344 C 184.835938 139.582031 185.90625 139.125 186.210938 137.136719 "
}));

var _ref10 = /*#__PURE__*/React.createElement("clipPath", {
  id: "b487f8b6f2"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 179 136 L 211 136 L 211 167 L 179 167 Z M 179 136 "
}));

var _ref11 = /*#__PURE__*/React.createElement("clipPath", {
  id: "9058095b13"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 210.683594 163.140625 L 210.53125 162.679688 C 210.378906 162.527344 210.074219 162.527344 209.765625 162.527344 L 194.777344 162.527344 C 194.472656 162.527344 194.472656 162.527344 194.472656 162.527344 C 194.472656 162.527344 194.472656 162.375 194.472656 162.375 C 194.472656 162.222656 204.71875 137.441406 204.71875 137.441406 L 204.71875 137.289062 C 204.71875 137.289062 204.71875 137.136719 204.71875 137.136719 C 204.71875 136.828125 204.566406 136.675781 204.566406 136.523438 C 204.414062 136.371094 204.109375 136.21875 203.648438 136.21875 L 188.660156 136.21875 C 187.894531 136.21875 187.742188 136.675781 187.742188 136.828125 C 187.742188 136.980469 187.742188 137.289062 188.8125 138.359375 C 189.269531 138.816406 189.578125 139.429688 189.578125 139.734375 L 189.578125 139.890625 L 179.328125 164.976562 L 179.328125 165.128906 C 179.328125 165.433594 179.328125 165.585938 179.480469 165.742188 C 179.632812 165.894531 179.941406 166.046875 180.398438 166.046875 L 205.484375 166.046875 C 206.097656 166.046875 206.859375 165.894531 207.472656 165.433594 C 207.472656 165.433594 210.074219 163.90625 210.074219 163.90625 C 210.378906 163.597656 210.683594 163.445312 210.683594 163.140625 "
}));

var _ref12 = /*#__PURE__*/React.createElement("clipPath", {
  id: "801b189420"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 210 136 L 252 136 L 252 166 L 210 166 Z M 210 136 "
}));

var _ref13 = /*#__PURE__*/React.createElement("clipPath", {
  id: "da47b4f212"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 233.476562 157.019531 C 233.476562 157.175781 233.476562 157.328125 233.015625 157.328125 L 224.757812 157.328125 C 224.757812 157.328125 224.757812 157.328125 224.605469 157.328125 C 224.605469 157.328125 224.605469 157.175781 224.605469 157.175781 C 224.605469 157.175781 232.558594 147.691406 232.558594 147.691406 C 232.710938 147.996094 233.476562 157.019531 233.476562 157.019531 M 248.007812 136.0625 L 232.863281 136.21875 C 231.792969 136.21875 231.640625 136.828125 231.640625 137.136719 C 231.640625 137.441406 231.640625 137.898438 231.792969 138.511719 C 231.945312 139.125 231.945312 139.582031 231.945312 139.734375 C 231.945312 140.042969 231.792969 140.347656 231.488281 140.652344 C 210.378906 164.824219 210.378906 164.976562 210.378906 165.128906 C 210.378906 165.433594 210.378906 165.585938 210.53125 165.585938 C 210.683594 165.742188 210.992188 165.894531 211.296875 165.894531 L 216.039062 165.894531 C 216.804688 165.894531 217.414062 165.585938 217.875 164.976562 C 217.875 164.976562 221.238281 161.152344 221.238281 161.152344 C 221.542969 160.691406 222.003906 160.539062 222.617188 160.539062 L 233.324219 160.539062 C 233.933594 160.539062 233.933594 160.84375 233.933594 161 L 234.394531 164.976562 C 234.394531 165.28125 234.699219 165.894531 235.769531 165.894531 L 250.757812 165.894531 C 251.675781 165.894531 251.984375 165.28125 251.984375 164.976562 L 251.984375 164.824219 L 249.382812 136.980469 C 249.382812 136.828125 249.230469 136.0625 248.007812 136.0625 "
}));

var _ref14 = /*#__PURE__*/React.createElement("clipPath", {
  id: "a6910d5dfa"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 254 136 L 301 136 L 301 166 L 254 166 Z M 254 136 "
}));

var _ref15 = /*#__PURE__*/React.createElement("clipPath", {
  id: "28b8425382"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 299.859375 137.441406 L 300.011719 137.136719 C 300.011719 136.828125 300.011719 136.523438 299.859375 136.371094 C 299.707031 136.21875 299.398438 136.0625 298.941406 136.0625 L 294.046875 136.0625 C 292.976562 136.0625 292.671875 136.675781 292.363281 137.136719 C 292.363281 137.136719 286.09375 152.890625 285.175781 155.1875 C 284.410156 152.433594 280.128906 136.980469 280.128906 136.980469 C 279.972656 136.523438 279.667969 136.0625 278.597656 136.0625 L 263.609375 136.0625 C 262.84375 136.0625 262.691406 136.523438 262.691406 136.675781 C 262.691406 136.828125 262.691406 137.136719 263.609375 138.054688 C 264.066406 138.511719 264.371094 138.972656 264.371094 139.277344 C 264.371094 139.277344 264.371094 139.277344 264.371094 139.429688 C 264.371094 139.429688 264.371094 139.582031 264.371094 139.734375 C 264.371094 139.886719 254.125 164.667969 254.125 164.667969 L 254.125 164.824219 C 254.125 164.824219 254.125 164.976562 254.125 164.976562 C 254.125 165.28125 254.277344 165.433594 254.277344 165.433594 C 254.429688 165.585938 254.738281 165.742188 255.195312 165.742188 L 260.089844 165.742188 C 261.007812 165.742188 261.464844 165.28125 261.621094 164.824219 C 261.621094 164.824219 267.890625 148.914062 268.808594 146.621094 C 269.574219 149.371094 273.855469 164.824219 273.855469 164.824219 C 274.007812 165.28125 274.316406 165.742188 275.386719 165.742188 L 287.011719 165.742188 C 288.082031 165.742188 288.386719 165.28125 288.691406 164.824219 Z M 299.859375 137.441406 "
}));

var _ref16 = /*#__PURE__*/React.createElement("clipPath", {
  id: "6145e385b9"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 294 136 L 339 136 L 339 166 L 294 166 Z M 294 136 "
}));

var _ref17 = /*#__PURE__*/React.createElement("clipPath", {
  id: "f584461bc2"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 309.648438 162.527344 C 309.648438 162.527344 309.648438 162.375 309.648438 162.527344 C 309.648438 162.375 318.824219 140.042969 318.824219 140.042969 C 318.980469 139.886719 319.132812 139.582031 319.742188 139.582031 L 324.636719 139.582031 C 324.945312 139.582031 324.945312 139.582031 324.945312 139.582031 L 324.945312 139.734375 L 315.917969 162.070312 C 315.765625 162.375 315.460938 162.679688 315 162.679688 L 310.105469 162.679688 C 309.800781 162.679688 309.648438 162.679688 309.648438 162.527344 Z M 338.558594 140.804688 C 338.710938 139.429688 338.25 138.359375 337.332031 137.441406 C 336.414062 136.523438 335.039062 136.21875 333.355469 136.21875 L 303.988281 136.21875 C 303.222656 136.21875 303.070312 136.675781 303.070312 136.828125 C 303.070312 136.980469 303.070312 137.289062 303.988281 138.207031 C 304.449219 138.664062 304.753906 139.125 304.753906 139.429688 C 304.753906 139.429688 304.753906 139.429688 304.753906 139.582031 C 304.753906 139.582031 304.753906 139.734375 304.753906 139.886719 C 304.753906 140.042969 294.503906 164.824219 294.503906 164.824219 L 294.503906 164.976562 C 294.503906 164.976562 294.503906 165.128906 294.503906 165.128906 C 294.503906 165.433594 294.660156 165.585938 294.660156 165.585938 C 294.8125 165.742188 295.117188 165.894531 295.574219 165.894531 C 295.574219 165.894531 321.578125 165.894531 321.578125 165.894531 C 323.566406 165.894531 325.402344 165.433594 327.238281 164.363281 C 329.074219 163.292969 330.296875 161.917969 330.910156 160.386719 L 338.402344 141.878906 C 338.402344 141.570312 338.558594 141.265625 338.558594 140.804688 "
}));

var _ref18 = /*#__PURE__*/React.createElement("clipPath", {
  id: "ab8afdcead"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 333 160 L 342 160 L 342 167 L 333 167 Z M 333 160 "
}));

var _ref19 = /*#__PURE__*/React.createElement("clipPath", {
  id: "c5692db180"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 338.25 160.234375 C 337.027344 160.234375 335.957031 160.539062 335.039062 161.304688 C 333.96875 162.070312 333.355469 162.835938 333.355469 163.753906 C 333.203125 164.515625 333.355469 165.128906 333.816406 165.433594 C 334.273438 166.046875 335.039062 166.199219 336.261719 166.199219 C 337.332031 166.199219 338.402344 165.894531 339.476562 165.128906 C 340.546875 164.363281 341.15625 163.597656 341.308594 162.527344 C 341.464844 161.761719 341.308594 161.152344 340.851562 160.84375 C 340.238281 160.386719 339.320312 160.234375 338.25 160.234375 "
}));

var _ref20 = /*#__PURE__*/React.createElement("clipPath", {
  id: "3232ad0dd5"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 343 136 L 390 136 L 390 167 L 343 167 Z M 343 136 "
}));

var _ref21 = /*#__PURE__*/React.createElement("clipPath", {
  id: "f0c5dd7ad1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 389.339844 137.59375 L 389.492188 137.289062 C 389.492188 136.980469 389.492188 136.675781 389.339844 136.523438 C 389.1875 136.371094 388.878906 136.21875 388.421875 136.21875 L 383.527344 136.21875 C 382.457031 136.21875 382.148438 136.828125 381.84375 137.289062 C 381.84375 137.289062 375.574219 153.042969 374.65625 155.339844 C 373.890625 152.585938 369.609375 137.289062 369.609375 137.289062 C 369.453125 136.828125 369.148438 136.371094 368.078125 136.371094 L 353.089844 136.371094 C 352.324219 136.371094 352.171875 136.828125 352.171875 136.980469 C 352.171875 137.136719 352.171875 137.441406 353.089844 138.359375 C 353.546875 138.816406 353.851562 139.277344 353.851562 139.582031 C 353.851562 139.582031 353.851562 139.582031 353.851562 139.734375 L 353.851562 140.042969 C 353.851562 140.195312 343.605469 164.976562 343.605469 164.976562 L 343.605469 165.128906 C 343.605469 165.128906 343.605469 165.28125 343.605469 165.28125 C 343.605469 165.585938 343.757812 165.742188 343.757812 165.742188 C 343.910156 165.894531 344.214844 166.046875 344.675781 166.046875 L 349.570312 166.046875 C 350.488281 166.046875 350.945312 165.585938 351.101562 165.128906 C 351.101562 165.128906 357.371094 149.21875 358.289062 147.078125 C 359.054688 149.832031 363.335938 165.128906 363.335938 165.128906 C 363.488281 165.585938 363.796875 166.046875 364.867188 166.046875 L 376.492188 166.046875 C 377.5625 166.046875 377.867188 165.585938 378.019531 165.128906 Z M 389.339844 137.59375 "
}));

var _ref22 = /*#__PURE__*/React.createElement("clipPath", {
  id: "698a7754b8"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 383 136 L 416 136 L 416 166 L 383 166 Z M 383 136 "
}));

var _ref23 = /*#__PURE__*/React.createElement("clipPath", {
  id: "1a0ca03e65"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 415.1875 162.835938 C 415.035156 162.679688 414.730469 162.679688 414.425781 162.679688 L 399.433594 162.679688 C 399.128906 162.679688 399.128906 162.679688 399.128906 162.679688 C 399.128906 162.679688 399.128906 162.679688 399.128906 162.527344 C 399.128906 162.527344 399.128906 162.375 399.128906 162.375 C 399.128906 162.222656 409.375 137.59375 409.375 137.59375 L 409.375 137.441406 C 409.375 137.441406 409.375 137.289062 409.375 137.289062 C 409.375 136.980469 409.222656 136.828125 409.222656 136.675781 C 409.070312 136.523438 408.765625 136.371094 408.304688 136.371094 L 393.316406 136.371094 C 392.550781 136.371094 392.398438 136.828125 392.398438 136.980469 C 392.398438 137.136719 392.398438 137.441406 393.46875 138.359375 C 393.925781 138.816406 394.234375 139.429688 394.234375 139.734375 L 394.234375 139.890625 L 383.832031 164.824219 L 383.832031 164.976562 C 383.832031 165.28125 383.832031 165.433594 383.984375 165.585938 C 384.136719 165.742188 384.445312 165.894531 384.902344 165.894531 L 409.988281 165.894531 C 410.601562 165.894531 411.363281 165.742188 411.976562 165.28125 C 411.976562 165.28125 414.578125 163.753906 414.578125 163.753906 C 414.882812 163.597656 415.1875 163.292969 415.1875 163.140625 Z M 415.1875 162.835938 "
}));

var _ref24 = /*#__PURE__*/React.createElement("clipPath", {
  id: "c7bf9c132b"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 30 126 L 415 126 L 415 165 L 30 165 Z M 30 126 "
}));

var _ref25 = /*#__PURE__*/React.createElement("clipPath", {
  id: "7700d17572"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 60.480469 138.359375 C 60.480469 138.359375 60.480469 138.511719 60.480469 138.359375 C 60.328125 138.664062 59.105469 141.722656 56.65625 147.691406 C 56.503906 147.996094 56.199219 148.148438 55.738281 148.148438 L 50.84375 148.148438 C 50.539062 148.148438 50.539062 148.148438 50.539062 148.148438 C 50.691406 147.84375 51.304688 146.160156 54.363281 138.972656 C 54.515625 138.664062 54.667969 138.511719 55.28125 138.511719 L 60.175781 138.511719 C 60.328125 138.359375 60.480469 138.359375 60.480469 138.359375 M 54.972656 151.667969 C 54.820312 152.125 52.832031 157.175781 51.304688 160.84375 C 51.152344 161.304688 50.84375 161.457031 50.386719 161.457031 L 45.492188 161.457031 C 45.183594 161.457031 45.183594 161.457031 45.183594 161.457031 C 45.339844 161.152344 46.101562 159.316406 48.855469 152.277344 C 49.007812 151.972656 49.164062 151.820312 49.773438 151.820312 L 54.667969 151.820312 C 54.972656 151.667969 54.972656 151.667969 54.972656 151.667969 M 71.648438 146.007812 C 71.648438 146.007812 73.789062 140.652344 73.789062 140.652344 C 73.941406 140.195312 74.09375 139.886719 74.09375 139.429688 C 74.246094 138.054688 73.789062 136.980469 72.871094 136.0625 C 71.953125 135.148438 70.578125 134.839844 68.894531 134.839844 L 39.527344 134.839844 C 38.761719 134.839844 38.609375 135.300781 38.609375 135.453125 C 38.609375 135.453125 38.609375 135.453125 38.609375 135.605469 C 38.609375 135.757812 38.761719 136.0625 39.527344 136.980469 C 39.984375 137.441406 40.289062 137.898438 40.289062 138.207031 C 40.289062 138.207031 40.289062 138.207031 40.289062 138.359375 C 40.289062 138.359375 40.289062 138.511719 40.289062 138.664062 C 40.289062 138.816406 30.042969 163.597656 30.042969 163.597656 L 30.042969 163.753906 C 30.042969 163.753906 30.042969 163.90625 30.042969 163.90625 C 30.042969 164.210938 30.195312 164.363281 30.195312 164.363281 C 30.347656 164.515625 30.65625 164.667969 31.113281 164.667969 L 57.117188 164.667969 C 59.105469 164.667969 60.941406 164.058594 62.773438 163.140625 C 64.609375 162.070312 65.835938 160.691406 66.445312 159.164062 L 68.585938 153.808594 C 68.742188 153.351562 68.894531 153.042969 68.894531 152.585938 C 68.894531 152.433594 68.894531 152.433594 68.894531 152.277344 C 68.894531 151.515625 68.433594 150.597656 67.515625 149.679688 C 69.8125 148.761719 71.1875 147.382812 71.648438 146.007812 M 84.035156 161.304688 C 84.035156 161.304688 84.035156 161.152344 84.035156 161.152344 C 84.035156 161.152344 93.214844 138.816406 93.214844 138.816406 C 93.367188 138.664062 93.519531 138.359375 94.132812 138.359375 L 99.027344 138.359375 C 99.179688 138.359375 99.332031 138.359375 99.332031 138.359375 C 99.332031 138.359375 99.332031 138.511719 99.332031 138.511719 C 99.332031 138.664062 90.308594 160.84375 90.308594 160.84375 C 90.15625 161.152344 90 161.457031 89.390625 161.457031 L 84.648438 161.457031 C 84.035156 161.457031 84.035156 161.457031 84.035156 161.304688 C 84.035156 161.457031 84.035156 161.304688 84.035156 161.304688 Z M 112.945312 139.582031 C 113.097656 138.207031 112.640625 137.136719 111.722656 136.21875 C 110.804688 135.300781 109.425781 134.992188 107.746094 134.992188 L 87.554688 134.992188 C 85.566406 134.992188 83.730469 135.605469 81.894531 136.675781 C 80.058594 137.746094 78.835938 139.125 78.222656 140.5 L 70.730469 159.011719 C 70.578125 159.46875 70.421875 159.773438 70.421875 160.234375 C 70.269531 161.609375 70.730469 162.679688 71.648438 163.597656 C 72.566406 164.363281 73.941406 164.824219 75.625 164.824219 L 95.8125 164.824219 C 97.800781 164.824219 99.636719 164.210938 101.472656 163.292969 C 103.308594 162.222656 104.53125 160.84375 105.144531 159.316406 L 112.640625 140.804688 C 112.792969 140.347656 112.945312 140.042969 112.945312 139.582031 M 128.394531 155.949219 C 128.394531 156.101562 128.394531 156.257812 127.933594 156.257812 L 119.675781 156.257812 C 119.675781 156.257812 119.675781 156.257812 119.523438 156.257812 C 119.523438 156.257812 119.523438 156.101562 119.523438 156.101562 C 119.523438 156.101562 127.476562 146.621094 127.476562 146.621094 C 127.628906 146.925781 128.394531 155.796875 128.394531 155.949219 M 127.015625 146.007812 Z M 142.925781 134.992188 C 142.925781 134.992188 127.628906 135.148438 127.628906 135.148438 C 126.558594 135.148438 126.40625 135.757812 126.40625 136.0625 C 126.40625 136.371094 126.40625 136.828125 126.558594 137.441406 C 126.710938 138.054688 126.710938 138.511719 126.710938 138.664062 C 126.710938 138.972656 126.558594 139.277344 126.253906 139.582031 C 105.144531 163.753906 105.144531 163.90625 105.144531 164.058594 C 105.144531 164.363281 105.144531 164.515625 105.296875 164.515625 C 105.449219 164.667969 105.757812 164.824219 106.0625 164.824219 L 110.804688 164.824219 C 111.570312 164.824219 112.179688 164.515625 112.640625 163.90625 C 112.640625 163.90625 116.003906 160.082031 116.003906 160.082031 C 116.308594 159.621094 116.769531 159.46875 117.382812 159.46875 L 128.089844 159.46875 C 128.699219 159.46875 128.699219 159.773438 128.699219 159.929688 L 129.160156 163.90625 C 129.160156 164.210938 129.464844 164.824219 130.535156 164.824219 L 145.523438 164.824219 C 146.441406 164.824219 146.75 164.210938 146.75 163.90625 L 146.75 163.753906 L 144.148438 135.910156 C 144.300781 135.605469 144.148438 134.992188 142.925781 134.992188 M 185.601562 135.910156 C 185.601562 135.605469 185.601562 135.453125 185.445312 135.300781 C 185.292969 135.148438 184.988281 134.992188 184.527344 134.992188 L 149.347656 134.992188 C 148.585938 134.992188 148.429688 135.300781 148.429688 135.605469 C 148.429688 135.757812 148.429688 135.910156 149.960938 137.746094 C 150.265625 138.207031 150.878906 138.359375 151.644531 138.359375 L 159.902344 138.359375 C 160.210938 138.359375 160.210938 138.359375 160.210938 138.359375 C 160.210938 138.359375 160.210938 138.359375 160.210938 138.511719 C 160.210938 138.664062 149.960938 163.445312 149.960938 163.445312 L 149.960938 163.597656 C 149.960938 163.597656 149.960938 163.753906 149.960938 163.753906 C 149.960938 164.058594 150.113281 164.210938 150.113281 164.210938 C 150.265625 164.363281 150.574219 164.515625 151.03125 164.515625 L 162.65625 164.515625 C 163.574219 164.515625 164.03125 164.058594 164.1875 163.597656 C 164.1875 163.597656 174.28125 138.511719 174.28125 138.511719 C 174.433594 138.359375 174.585938 138.054688 175.199219 138.054688 L 183.457031 138.054688 C 184.222656 138.359375 185.292969 138.054688 185.601562 135.910156 M 210.074219 162.070312 L 209.921875 161.609375 C 209.765625 161.457031 209.460938 161.457031 209.15625 161.457031 L 194.164062 161.457031 C 193.859375 161.457031 193.859375 161.457031 193.859375 161.457031 C 193.859375 161.457031 193.859375 161.304688 193.859375 161.304688 C 193.859375 161.152344 204.109375 136.371094 204.109375 136.371094 L 204.109375 136.21875 C 204.109375 136.21875 204.109375 136.0625 204.109375 136.0625 C 204.109375 135.757812 203.953125 135.605469 203.953125 135.453125 C 203.800781 135.300781 203.496094 135.148438 203.035156 135.148438 L 188.046875 135.148438 C 187.28125 135.148438 187.128906 135.605469 187.128906 135.757812 C 187.128906 135.910156 187.128906 136.21875 188.199219 137.289062 C 188.660156 137.746094 188.964844 138.359375 188.964844 138.664062 L 188.964844 138.816406 L 178.71875 163.90625 L 178.71875 164.058594 C 178.71875 164.363281 178.71875 164.515625 178.871094 164.667969 C 179.023438 164.824219 179.328125 164.976562 179.789062 164.976562 L 204.871094 164.976562 C 205.484375 164.976562 206.25 164.824219 206.859375 164.363281 C 206.859375 164.363281 209.460938 162.835938 209.460938 162.835938 C 209.921875 162.527344 210.074219 162.222656 210.074219 162.070312 M 233.015625 155.949219 C 233.015625 156.101562 233.015625 156.257812 232.558594 156.257812 L 224.296875 156.257812 C 224.296875 156.257812 224.296875 156.257812 224.144531 156.257812 C 224.144531 156.257812 224.144531 156.101562 224.144531 156.101562 C 224.144531 156.101562 232.097656 146.621094 232.097656 146.621094 C 232.25 146.925781 233.015625 155.796875 233.015625 155.949219 M 247.546875 134.992188 L 232.40625 135.148438 C 231.335938 135.148438 231.179688 135.757812 231.179688 136.0625 C 231.179688 136.371094 231.179688 136.828125 231.335938 137.441406 C 231.488281 138.054688 231.488281 138.511719 231.488281 138.664062 C 231.488281 138.972656 231.335938 139.277344 231.027344 139.582031 C 209.921875 163.753906 209.921875 163.90625 209.921875 164.058594 C 209.921875 164.363281 209.921875 164.515625 210.074219 164.515625 C 210.226562 164.667969 210.53125 164.824219 210.839844 164.824219 L 215.578125 164.824219 C 216.34375 164.824219 216.957031 164.515625 217.414062 163.90625 C 217.414062 163.90625 220.78125 160.082031 220.78125 160.082031 C 221.085938 159.621094 221.542969 159.46875 222.15625 159.46875 L 232.863281 159.46875 C 233.476562 159.46875 233.476562 159.773438 233.476562 159.929688 L 233.933594 163.90625 C 233.933594 164.210938 234.242188 164.824219 235.3125 164.824219 L 250.300781 164.824219 C 251.21875 164.824219 251.523438 164.210938 251.523438 163.90625 L 251.523438 163.753906 L 248.925781 135.910156 C 248.925781 135.605469 248.617188 134.992188 247.546875 134.992188 M 299.398438 136.371094 L 299.554688 136.0625 C 299.554688 135.757812 299.554688 135.453125 299.398438 135.300781 C 299.246094 135.148438 298.941406 134.992188 298.480469 134.992188 L 293.585938 134.992188 C 292.515625 134.992188 292.210938 135.605469 291.90625 136.0625 C 291.90625 136.0625 285.632812 151.820312 284.714844 154.113281 C 283.953125 151.363281 279.667969 135.910156 279.667969 135.910156 C 279.515625 135.453125 279.210938 134.992188 278.140625 134.992188 L 263.148438 134.992188 C 262.382812 134.992188 262.230469 135.453125 262.230469 135.605469 C 262.230469 135.757812 262.230469 136.0625 263.148438 136.980469 C 263.609375 137.441406 263.914062 137.898438 263.914062 138.207031 C 263.914062 138.207031 263.914062 138.207031 263.914062 138.359375 C 263.914062 138.359375 263.914062 138.511719 263.914062 138.664062 C 263.914062 138.816406 253.664062 163.597656 253.664062 163.597656 L 253.664062 163.753906 C 253.664062 163.753906 253.664062 163.90625 253.664062 163.90625 C 253.664062 164.210938 253.820312 164.363281 253.820312 164.363281 C 253.972656 164.515625 254.277344 164.667969 254.738281 164.667969 L 259.632812 164.667969 C 260.550781 164.667969 261.007812 164.210938 261.160156 163.753906 C 261.160156 163.753906 267.433594 147.84375 268.351562 145.546875 C 269.113281 148.300781 273.398438 163.753906 273.398438 163.753906 C 273.550781 164.210938 273.855469 164.667969 274.925781 164.667969 L 286.550781 164.667969 C 287.621094 164.667969 287.929688 164.210938 288.234375 163.753906 Z M 309.1875 161.304688 C 309.1875 161.152344 318.367188 138.816406 318.367188 138.816406 C 318.519531 138.664062 318.671875 138.359375 319.285156 138.359375 L 324.179688 138.359375 C 324.484375 138.359375 324.484375 138.359375 324.484375 138.359375 L 324.332031 138.511719 L 315.308594 160.84375 C 315.15625 161.152344 314.847656 161.457031 314.390625 161.457031 L 309.496094 161.457031 C 309.1875 161.457031 309.1875 161.457031 309.1875 161.304688 C 309.1875 161.457031 309.1875 161.457031 309.1875 161.304688 Z M 338.097656 139.734375 C 338.25 138.359375 337.792969 137.289062 336.875 136.371094 C 335.957031 135.453125 334.582031 135.148438 332.898438 135.148438 L 303.53125 135.148438 C 302.765625 135.148438 302.613281 135.605469 302.613281 135.757812 C 302.613281 135.910156 302.613281 136.21875 303.53125 137.136719 C 303.988281 137.59375 304.292969 138.054688 304.292969 138.359375 C 304.292969 138.359375 304.292969 138.359375 304.292969 138.511719 C 304.292969 138.511719 304.292969 138.664062 304.292969 138.816406 C 304.292969 138.972656 294.046875 163.753906 294.046875 163.753906 L 294.046875 163.90625 C 294.046875 163.90625 294.046875 164.058594 294.046875 164.058594 C 294.046875 164.363281 294.199219 164.515625 294.199219 164.515625 C 294.351562 164.667969 294.660156 164.824219 295.117188 164.824219 C 295.117188 164.824219 321.121094 164.824219 321.121094 164.824219 C 323.109375 164.824219 324.945312 164.363281 326.78125 163.292969 C 328.613281 162.222656 329.839844 160.84375 330.449219 159.316406 L 337.945312 140.804688 C 337.945312 140.5 337.945312 140.042969 338.097656 139.734375 M 337.640625 159.011719 C 336.414062 159.011719 335.34375 159.316406 334.425781 160.082031 C 333.355469 160.84375 332.746094 161.609375 332.746094 162.527344 C 332.589844 163.292969 332.746094 163.90625 333.203125 164.210938 C 333.664062 164.824219 334.425781 164.976562 335.652344 164.976562 C 336.722656 164.976562 337.792969 164.667969 338.863281 163.90625 C 339.933594 163.140625 340.546875 162.375 340.699219 161.304688 C 340.851562 160.539062 340.699219 159.929688 340.238281 159.621094 C 339.628906 159.316406 338.863281 159.011719 337.640625 159.011719 M 388.726562 136.371094 L 388.878906 136.0625 C 388.878906 135.757812 388.878906 135.453125 388.726562 135.300781 C 388.574219 135.148438 388.269531 134.992188 387.808594 134.992188 L 382.914062 134.992188 C 381.84375 134.992188 381.539062 135.605469 381.230469 136.0625 C 381.230469 136.0625 374.960938 151.820312 374.042969 154.113281 C 373.277344 151.363281 368.996094 136.0625 368.996094 136.0625 C 368.84375 135.605469 368.535156 135.148438 367.464844 135.148438 L 352.476562 135.148438 C 351.710938 135.148438 351.558594 135.605469 351.558594 135.757812 C 351.558594 135.910156 351.558594 136.21875 352.476562 137.136719 C 352.933594 137.59375 353.242188 138.054688 353.242188 138.359375 C 353.242188 138.359375 353.242188 138.359375 353.242188 138.511719 L 353.242188 138.816406 C 353.242188 138.972656 342.992188 163.753906 342.992188 163.753906 L 342.992188 163.90625 C 342.992188 163.90625 342.992188 164.058594 342.992188 164.058594 C 342.992188 164.363281 343.144531 164.515625 343.144531 164.515625 C 343.296875 164.667969 343.605469 164.824219 344.0625 164.824219 L 348.957031 164.824219 C 349.875 164.824219 350.335938 164.363281 350.488281 163.90625 C 350.488281 163.90625 356.757812 147.996094 357.675781 145.855469 C 358.441406 148.609375 362.722656 163.90625 362.722656 163.90625 C 362.878906 164.363281 363.183594 164.824219 364.253906 164.824219 L 375.878906 164.824219 C 376.949219 164.824219 377.253906 164.363281 377.410156 163.90625 Z M 414.578125 161.609375 C 414.425781 161.457031 414.117188 161.457031 413.8125 161.457031 L 398.824219 161.457031 C 398.515625 161.457031 398.515625 161.457031 398.515625 161.457031 C 398.515625 161.457031 398.515625 161.457031 398.515625 161.304688 C 398.515625 161.304688 398.515625 161.152344 398.515625 161.152344 C 398.515625 161 408.765625 136.371094 408.765625 136.371094 L 408.765625 136.21875 C 408.765625 136.21875 408.765625 136.0625 408.765625 136.0625 C 408.765625 135.757812 408.613281 135.605469 408.613281 135.453125 C 408.457031 135.300781 408.152344 135.148438 407.695312 135.148438 L 392.703125 135.148438 C 391.9375 135.148438 391.785156 135.605469 391.785156 135.757812 C 391.785156 135.910156 391.785156 136.21875 392.855469 137.136719 C 393.316406 137.59375 393.621094 138.207031 393.621094 138.511719 L 393.621094 138.664062 L 383.375 163.597656 L 383.375 163.753906 C 383.375 164.058594 383.375 164.210938 383.527344 164.363281 C 383.679688 164.515625 383.984375 164.667969 384.445312 164.667969 L 409.53125 164.667969 C 410.140625 164.667969 410.90625 164.515625 411.519531 164.058594 C 411.519531 164.058594 414.117188 162.527344 414.117188 162.527344 C 414.425781 162.375 414.730469 162.070312 414.730469 161.917969 Z M 235.769531 126.582031 Z M 235.769531 126.582031 "
}));

function SvgBusiness2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 600,
    zoomAndPan: "magnify",
    viewBox: "0 0 450 299.999988",
    height: 400,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, _ref, /*#__PURE__*/React.createElement("linearGradient", {
    x1: 7.1615,
    gradientTransform: "matrix(1,0,0,-1,-0.000000000491314,52)",
    y1: 26.063,
    x2: 287.138498,
    gradientUnits: "userSpaceOnUse",
    y2: 26.063,
    id: "3bcd24afde"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#bbbcbe",
      stopOpacity: 1
    },
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#babbbd",
      stopOpacity: 1
    },
    offset: 0.00390625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#b9babc",
      stopOpacity: 1
    },
    offset: 0.0078125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#b7b8ba",
      stopOpacity: 1
    },
    offset: 0.0117187
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#b6b7b9",
      stopOpacity: 1
    },
    offset: 0.015625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#b4b5b7",
      stopOpacity: 1
    },
    offset: 0.0195312
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#b3b4b6",
      stopOpacity: 1
    },
    offset: 0.0234375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#b1b2b4",
      stopOpacity: 1
    },
    offset: 0.0273437
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#b0b1b3",
      stopOpacity: 1
    },
    offset: 0.03125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#aeafb1",
      stopOpacity: 1
    },
    offset: 0.0351562
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#acaeb0",
      stopOpacity: 1
    },
    offset: 0.0390625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#abacae",
      stopOpacity: 1
    },
    offset: 0.0429687
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#a9aaac",
      stopOpacity: 1
    },
    offset: 0.046875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#a8a9ab",
      stopOpacity: 1
    },
    offset: 0.0507812
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#a6a7a9",
      stopOpacity: 1
    },
    offset: 0.0546875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#a5a6a8",
      stopOpacity: 1
    },
    offset: 0.0585937
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#a3a4a6",
      stopOpacity: 1
    },
    offset: 0.0625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#a2a3a5",
      stopOpacity: 1
    },
    offset: 0.0664062
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#a0a1a3",
      stopOpacity: 1
    },
    offset: 0.0703125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#9fa0a2",
      stopOpacity: 1
    },
    offset: 0.0742187
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#9d9ea0",
      stopOpacity: 1
    },
    offset: 0.078125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#9b9c9e",
      stopOpacity: 1
    },
    offset: 0.0820312
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#9a9b9d",
      stopOpacity: 1
    },
    offset: 0.0859375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#98999b",
      stopOpacity: 1
    },
    offset: 0.0898437
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#97989a",
      stopOpacity: 1
    },
    offset: 0.09375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#959698",
      stopOpacity: 1
    },
    offset: 0.0976562
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#949597",
      stopOpacity: 1
    },
    offset: 0.101562
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#929395",
      stopOpacity: 1
    },
    offset: 0.105469
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#919294",
      stopOpacity: 1
    },
    offset: 0.109375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#8f9092",
      stopOpacity: 1
    },
    offset: 0.113281
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#8d8e90",
      stopOpacity: 1
    },
    offset: 0.117187
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#8c8d8f",
      stopOpacity: 1
    },
    offset: 0.121094
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#8a8b8d",
      stopOpacity: 1
    },
    offset: 0.125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#898a8c",
      stopOpacity: 1
    },
    offset: 0.128906
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#87888a",
      stopOpacity: 1
    },
    offset: 0.132812
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#868789",
      stopOpacity: 1
    },
    offset: 0.136719
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#848587",
      stopOpacity: 1
    },
    offset: 0.140625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#838486",
      stopOpacity: 1
    },
    offset: 0.144531
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#818284",
      stopOpacity: 1
    },
    offset: 0.148437
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#838486",
      stopOpacity: 1
    },
    offset: 0.152344
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#848587",
      stopOpacity: 1
    },
    offset: 0.15625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#87888a",
      stopOpacity: 1
    },
    offset: 0.160156
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#8b8b8d",
      stopOpacity: 1
    },
    offset: 0.164062
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#8e8f90",
      stopOpacity: 1
    },
    offset: 0.167969
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#919293",
      stopOpacity: 1
    },
    offset: 0.171875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#949596",
      stopOpacity: 1
    },
    offset: 0.175781
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#979899",
      stopOpacity: 1
    },
    offset: 0.179687
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#9a9b9d",
      stopOpacity: 1
    },
    offset: 0.183594
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#9d9ea0",
      stopOpacity: 1
    },
    offset: 0.1875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#a0a1a3",
      stopOpacity: 1
    },
    offset: 0.191406
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#a3a4a6",
      stopOpacity: 1
    },
    offset: 0.195312
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#a7a7a9",
      stopOpacity: 1
    },
    offset: 0.199219
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#aaaaac",
      stopOpacity: 1
    },
    offset: 0.203125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#adadaf",
      stopOpacity: 1
    },
    offset: 0.207031
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#b0b1b2",
      stopOpacity: 1
    },
    offset: 0.210937
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#b3b4b5",
      stopOpacity: 1
    },
    offset: 0.214844
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#b6b7b8",
      stopOpacity: 1
    },
    offset: 0.21875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#b9babb",
      stopOpacity: 1
    },
    offset: 0.222656
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#bcbdbe",
      stopOpacity: 1
    },
    offset: 0.226562
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c0c0c1",
      stopOpacity: 1
    },
    offset: 0.230469
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c3c3c4",
      stopOpacity: 1
    },
    offset: 0.234375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c6c6c7",
      stopOpacity: 1
    },
    offset: 0.238281
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c9c9ca",
      stopOpacity: 1
    },
    offset: 0.242187
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#cccccd",
      stopOpacity: 1
    },
    offset: 0.246094
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#cfd0d0",
      stopOpacity: 1
    },
    offset: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d2d3d3",
      stopOpacity: 1
    },
    offset: 0.253906
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d5d6d6",
      stopOpacity: 1
    },
    offset: 0.257812
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d8d9d9",
      stopOpacity: 1
    },
    offset: 0.261719
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#dcdcdc",
      stopOpacity: 1
    },
    offset: 0.265625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#dfdfdf",
      stopOpacity: 1
    },
    offset: 0.269531
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e2e2e3",
      stopOpacity: 1
    },
    offset: 0.273437
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e5e5e6",
      stopOpacity: 1
    },
    offset: 0.277344
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e8e8e9",
      stopOpacity: 1
    },
    offset: 0.28125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ebebec",
      stopOpacity: 1
    },
    offset: 0.285156
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#eeeeef",
      stopOpacity: 1
    },
    offset: 0.289062
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f1f2f2",
      stopOpacity: 1
    },
    offset: 0.292969
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f5f5f5",
      stopOpacity: 1
    },
    offset: 0.296875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f8f8f8",
      stopOpacity: 1
    },
    offset: 0.300781
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fbfbfb",
      stopOpacity: 1
    },
    offset: 0.304687
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fdfdfd",
      stopOpacity: 1
    },
    offset: 0.308594
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ffffff",
      stopOpacity: 1
    },
    offset: 0.3125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ffffff",
      stopOpacity: 1
    },
    offset: 0.375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ffffff",
      stopOpacity: 1
    },
    offset: 0.4375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ffffff",
      stopOpacity: 1
    },
    offset: 0.46875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ffffff",
      stopOpacity: 1
    },
    offset: 0.484375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fefefe",
      stopOpacity: 1
    },
    offset: 0.488281
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fefefe",
      stopOpacity: 1
    },
    offset: 0.492187
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fcfcfc",
      stopOpacity: 1
    },
    offset: 0.496094
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fafafa",
      stopOpacity: 1
    },
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f8f8f8",
      stopOpacity: 1
    },
    offset: 0.503906
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f6f6f6",
      stopOpacity: 1
    },
    offset: 0.507812
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f4f4f5",
      stopOpacity: 1
    },
    offset: 0.511719
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f2f2f3",
      stopOpacity: 1
    },
    offset: 0.515625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f0f0f1",
      stopOpacity: 1
    },
    offset: 0.519531
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#eeeeef",
      stopOpacity: 1
    },
    offset: 0.523437
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ececed",
      stopOpacity: 1
    },
    offset: 0.527344
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#eaeaeb",
      stopOpacity: 1
    },
    offset: 0.53125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e8e9e9",
      stopOpacity: 1
    },
    offset: 0.535156
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e6e7e7",
      stopOpacity: 1
    },
    offset: 0.539062
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e4e5e5",
      stopOpacity: 1
    },
    offset: 0.542969
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e2e3e4",
      stopOpacity: 1
    },
    offset: 0.546875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e0e1e2",
      stopOpacity: 1
    },
    offset: 0.550781
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#dedfe0",
      stopOpacity: 1
    },
    offset: 0.554687
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#dcddde",
      stopOpacity: 1
    },
    offset: 0.558594
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#dadbdc",
      stopOpacity: 1
    },
    offset: 0.5625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d8d9da",
      stopOpacity: 1
    },
    offset: 0.566406
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d6d7d8",
      stopOpacity: 1
    },
    offset: 0.570312
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d4d5d6",
      stopOpacity: 1
    },
    offset: 0.574219
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d2d3d5",
      stopOpacity: 1
    },
    offset: 0.578125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d0d1d3",
      stopOpacity: 1
    },
    offset: 0.582031
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#cecfd1",
      stopOpacity: 1
    },
    offset: 0.585937
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#cccdcf",
      stopOpacity: 1
    },
    offset: 0.589844
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#cacbcd",
      stopOpacity: 1
    },
    offset: 0.59375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c8cacb",
      stopOpacity: 1
    },
    offset: 0.597656
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c6c8c9",
      stopOpacity: 1
    },
    offset: 0.601562
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c4c6c7",
      stopOpacity: 1
    },
    offset: 0.605469
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c2c4c6",
      stopOpacity: 1
    },
    offset: 0.609375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c0c2c4",
      stopOpacity: 1
    },
    offset: 0.613281
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#bec0c2",
      stopOpacity: 1
    },
    offset: 0.617187
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#bcbec0",
      stopOpacity: 1
    },
    offset: 0.621094
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#bbbdbf",
      stopOpacity: 1
    },
    offset: 0.625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#bbbdbf",
      stopOpacity: 1
    },
    offset: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#bbbcbe",
      stopOpacity: 1
    },
    offset: 0.8125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#b9bbbd",
      stopOpacity: 1
    },
    offset: 0.816406
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#b8b9bb",
      stopOpacity: 1
    },
    offset: 0.820312
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#b7b8ba",
      stopOpacity: 1
    },
    offset: 0.824219
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#b6b7b9",
      stopOpacity: 1
    },
    offset: 0.828125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#b5b6b8",
      stopOpacity: 1
    },
    offset: 0.832031
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#b3b4b6",
      stopOpacity: 1
    },
    offset: 0.835937
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#b2b3b5",
      stopOpacity: 1
    },
    offset: 0.839844
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#b1b2b4",
      stopOpacity: 1
    },
    offset: 0.84375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#b0b1b3",
      stopOpacity: 1
    },
    offset: 0.847656
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#aeafb1",
      stopOpacity: 1
    },
    offset: 0.851562
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#adaeb0",
      stopOpacity: 1
    },
    offset: 0.855469
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#acadaf",
      stopOpacity: 1
    },
    offset: 0.859375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#abacae",
      stopOpacity: 1
    },
    offset: 0.863281
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#a9aaac",
      stopOpacity: 1
    },
    offset: 0.867187
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#a8a9ab",
      stopOpacity: 1
    },
    offset: 0.871094
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#a7a8aa",
      stopOpacity: 1
    },
    offset: 0.875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#a6a7a9",
      stopOpacity: 1
    },
    offset: 0.878906
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#a4a5a7",
      stopOpacity: 1
    },
    offset: 0.882812
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#a3a4a6",
      stopOpacity: 1
    },
    offset: 0.886719
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#a2a3a5",
      stopOpacity: 1
    },
    offset: 0.890625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#a1a2a4",
      stopOpacity: 1
    },
    offset: 0.894531
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#9fa0a2",
      stopOpacity: 1
    },
    offset: 0.898437
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#9e9fa1",
      stopOpacity: 1
    },
    offset: 0.902344
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#9d9ea0",
      stopOpacity: 1
    },
    offset: 0.90625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#9c9d9f",
      stopOpacity: 1
    },
    offset: 0.910156
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#9a9b9d",
      stopOpacity: 1
    },
    offset: 0.914062
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#999a9c",
      stopOpacity: 1
    },
    offset: 0.917969
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#98999b",
      stopOpacity: 1
    },
    offset: 0.921875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#97989a",
      stopOpacity: 1
    },
    offset: 0.925781
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#959698",
      stopOpacity: 1
    },
    offset: 0.929687
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#949597",
      stopOpacity: 1
    },
    offset: 0.933594
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#939496",
      stopOpacity: 1
    },
    offset: 0.9375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#929395",
      stopOpacity: 1
    },
    offset: 0.941406
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#909193",
      stopOpacity: 1
    },
    offset: 0.945312
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#8f9092",
      stopOpacity: 1
    },
    offset: 0.949219
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#8e8f91",
      stopOpacity: 1
    },
    offset: 0.953125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#8d8e90",
      stopOpacity: 1
    },
    offset: 0.957031
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#8b8c8f",
      stopOpacity: 1
    },
    offset: 0.960937
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#8a8b8d",
      stopOpacity: 1
    },
    offset: 0.964844
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#898a8c",
      stopOpacity: 1
    },
    offset: 0.96875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#88898b",
      stopOpacity: 1
    },
    offset: 0.972656
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#86878a",
      stopOpacity: 1
    },
    offset: 0.976562
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#858688",
      stopOpacity: 1
    },
    offset: 0.980469
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#848587",
      stopOpacity: 1
    },
    offset: 0.984375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#838486",
      stopOpacity: 1
    },
    offset: 0.988281
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#818385",
      stopOpacity: 1
    },
    offset: 0.992187
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#818284",
      stopOpacity: 1
    },
    offset: 0.996094
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#808183",
      stopOpacity: 1
    },
    offset: 1
  })), _ref2, _ref3, /*#__PURE__*/React.createElement("linearGradient", {
    x1: 20.100001,
    gradientTransform: "matrix(1.529572,0,0,-1.5297,-0.090027,191.286603)",
    y1: 26.326,
    x2: 48.999998,
    gradientUnits: "userSpaceOnUse",
    y2: 26.326,
    id: "6aea4d3e9e"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#bcbdbf",
      stopOpacity: 1
    },
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#bdbec0",
      stopOpacity: 1
    },
    offset: 0.00390625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#bebfc1",
      stopOpacity: 1
    },
    offset: 0.0078125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#bfc0c2",
      stopOpacity: 1
    },
    offset: 0.0117188
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#bfc0c2",
      stopOpacity: 1
    },
    offset: 0.015625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c0c1c3",
      stopOpacity: 1
    },
    offset: 0.0195312
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c1c2c4",
      stopOpacity: 1
    },
    offset: 0.0234375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c2c3c5",
      stopOpacity: 1
    },
    offset: 0.0273437
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c3c4c6",
      stopOpacity: 1
    },
    offset: 0.03125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c4c5c6",
      stopOpacity: 1
    },
    offset: 0.0351562
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c5c6c7",
      stopOpacity: 1
    },
    offset: 0.0390625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c6c6c8",
      stopOpacity: 1
    },
    offset: 0.0429688
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c6c7c9",
      stopOpacity: 1
    },
    offset: 0.046875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c7c8ca",
      stopOpacity: 1
    },
    offset: 0.0507812
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c8c9cb",
      stopOpacity: 1
    },
    offset: 0.0546875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c9cacb",
      stopOpacity: 1
    },
    offset: 0.0585938
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#cacbcc",
      stopOpacity: 1
    },
    offset: 0.0625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#cbcbcd",
      stopOpacity: 1
    },
    offset: 0.0664063
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ccccce",
      stopOpacity: 1
    },
    offset: 0.0703125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#cccdcf",
      stopOpacity: 1
    },
    offset: 0.0742188
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#cdcecf",
      stopOpacity: 1
    },
    offset: 0.078125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#cecfd0",
      stopOpacity: 1
    },
    offset: 0.0820312
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#cfd0d1",
      stopOpacity: 1
    },
    offset: 0.0859375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d0d1d2",
      stopOpacity: 1
    },
    offset: 0.0898438
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d1d1d3",
      stopOpacity: 1
    },
    offset: 0.09375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d2d2d4",
      stopOpacity: 1
    },
    offset: 0.0976562
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d2d3d4",
      stopOpacity: 1
    },
    offset: 0.101562
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d3d4d5",
      stopOpacity: 1
    },
    offset: 0.105469
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d4d5d6",
      stopOpacity: 1
    },
    offset: 0.109375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d5d6d7",
      stopOpacity: 1
    },
    offset: 0.113281
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d6d6d8",
      stopOpacity: 1
    },
    offset: 0.117188
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d7d7d9",
      stopOpacity: 1
    },
    offset: 0.121094
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d8d8d9",
      stopOpacity: 1
    },
    offset: 0.125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d8d9da",
      stopOpacity: 1
    },
    offset: 0.128906
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d9dadb",
      stopOpacity: 1
    },
    offset: 0.132812
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#dadbdc",
      stopOpacity: 1
    },
    offset: 0.136719
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#dbdcdd",
      stopOpacity: 1
    },
    offset: 0.140625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#dcdcdd",
      stopOpacity: 1
    },
    offset: 0.144531
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ddddde",
      stopOpacity: 1
    },
    offset: 0.148437
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#dededf",
      stopOpacity: 1
    },
    offset: 0.152344
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#dedfe0",
      stopOpacity: 1
    },
    offset: 0.15625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#dfe0e1",
      stopOpacity: 1
    },
    offset: 0.160156
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e0e1e2",
      stopOpacity: 1
    },
    offset: 0.164062
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e1e1e2",
      stopOpacity: 1
    },
    offset: 0.167969
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e2e2e3",
      stopOpacity: 1
    },
    offset: 0.171875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e3e3e4",
      stopOpacity: 1
    },
    offset: 0.175781
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e4e4e5",
      stopOpacity: 1
    },
    offset: 0.179688
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e4e5e6",
      stopOpacity: 1
    },
    offset: 0.183594
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e5e6e6",
      stopOpacity: 1
    },
    offset: 0.1875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e6e7e7",
      stopOpacity: 1
    },
    offset: 0.191406
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e7e7e8",
      stopOpacity: 1
    },
    offset: 0.195312
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e8e8e9",
      stopOpacity: 1
    },
    offset: 0.199219
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e9e9ea",
      stopOpacity: 1
    },
    offset: 0.203125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#eaeaeb",
      stopOpacity: 1
    },
    offset: 0.207031
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#eaebeb",
      stopOpacity: 1
    },
    offset: 0.210937
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ebecec",
      stopOpacity: 1
    },
    offset: 0.214844
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ececed",
      stopOpacity: 1
    },
    offset: 0.21875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ededee",
      stopOpacity: 1
    },
    offset: 0.222656
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#eeeeef",
      stopOpacity: 1
    },
    offset: 0.226562
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#efefef",
      stopOpacity: 1
    },
    offset: 0.230469
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f0f0f0",
      stopOpacity: 1
    },
    offset: 0.234375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f0f1f1",
      stopOpacity: 1
    },
    offset: 0.238281
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f1f2f2",
      stopOpacity: 1
    },
    offset: 0.242187
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f2f2f3",
      stopOpacity: 1
    },
    offset: 0.246094
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f3f3f4",
      stopOpacity: 1
    },
    offset: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f4f4f4",
      stopOpacity: 1
    },
    offset: 0.253906
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f5f5f5",
      stopOpacity: 1
    },
    offset: 0.257813
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f6f6f6",
      stopOpacity: 1
    },
    offset: 0.261719
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f6f7f7",
      stopOpacity: 1
    },
    offset: 0.265625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f7f7f8",
      stopOpacity: 1
    },
    offset: 0.269531
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f8f8f9",
      stopOpacity: 1
    },
    offset: 0.273438
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f9f9f9",
      stopOpacity: 1
    },
    offset: 0.277344
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fafafa",
      stopOpacity: 1
    },
    offset: 0.28125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fbfbfb",
      stopOpacity: 1
    },
    offset: 0.285156
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fcfcfc",
      stopOpacity: 1
    },
    offset: 0.289062
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fcfdfd",
      stopOpacity: 1
    },
    offset: 0.292969
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fdfdfd",
      stopOpacity: 1
    },
    offset: 0.296875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fefefe",
      stopOpacity: 1
    },
    offset: 0.300781
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ffffff",
      stopOpacity: 1
    },
    offset: 0.304688
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ffffff",
      stopOpacity: 1
    },
    offset: 0.3125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ffffff",
      stopOpacity: 1
    },
    offset: 0.375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ffffff",
      stopOpacity: 1
    },
    offset: 0.4375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ffffff",
      stopOpacity: 1
    },
    offset: 0.46875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ffffff",
      stopOpacity: 1
    },
    offset: 0.484375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fdfdfd",
      stopOpacity: 1
    },
    offset: 0.488281
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fcfcfc",
      stopOpacity: 1
    },
    offset: 0.492188
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fafafa",
      stopOpacity: 1
    },
    offset: 0.496094
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f8f8f8",
      stopOpacity: 1
    },
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f6f6f6",
      stopOpacity: 1
    },
    offset: 0.503906
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f4f4f4",
      stopOpacity: 1
    },
    offset: 0.507812
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f2f2f3",
      stopOpacity: 1
    },
    offset: 0.511719
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f0f0f1",
      stopOpacity: 1
    },
    offset: 0.515625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#eeeeef",
      stopOpacity: 1
    },
    offset: 0.519531
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ececed",
      stopOpacity: 1
    },
    offset: 0.523438
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#eaebeb",
      stopOpacity: 1
    },
    offset: 0.527344
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e8e9e9",
      stopOpacity: 1
    },
    offset: 0.53125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e6e7e7",
      stopOpacity: 1
    },
    offset: 0.535156
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e4e5e6",
      stopOpacity: 1
    },
    offset: 0.539063
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e2e3e4",
      stopOpacity: 1
    },
    offset: 0.542969
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e0e1e2",
      stopOpacity: 1
    },
    offset: 0.546875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#dedfe0",
      stopOpacity: 1
    },
    offset: 0.550781
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#dcddde",
      stopOpacity: 1
    },
    offset: 0.554688
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#dadbdc",
      stopOpacity: 1
    },
    offset: 0.558594
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d8d9da",
      stopOpacity: 1
    },
    offset: 0.5625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d6d7d9",
      stopOpacity: 1
    },
    offset: 0.566406
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d4d5d7",
      stopOpacity: 1
    },
    offset: 0.570312
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d2d3d5",
      stopOpacity: 1
    },
    offset: 0.574219
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d0d2d3",
      stopOpacity: 1
    },
    offset: 0.578125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ced0d1",
      stopOpacity: 1
    },
    offset: 0.582031
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#cccecf",
      stopOpacity: 1
    },
    offset: 0.585938
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#cacccd",
      stopOpacity: 1
    },
    offset: 0.589844
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c8cacb",
      stopOpacity: 1
    },
    offset: 0.59375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c6c8ca",
      stopOpacity: 1
    },
    offset: 0.597656
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c4c6c8",
      stopOpacity: 1
    },
    offset: 0.601562
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c2c4c6",
      stopOpacity: 1
    },
    offset: 0.605469
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c0c2c4",
      stopOpacity: 1
    },
    offset: 0.609375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#bec0c2",
      stopOpacity: 1
    },
    offset: 0.613281
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#bcbec0",
      stopOpacity: 1
    },
    offset: 0.617188
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#bdbfc0",
      stopOpacity: 1
    },
    offset: 0.621094
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#bdbfc1",
      stopOpacity: 1
    },
    offset: 0.625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#bec0c2",
      stopOpacity: 1
    },
    offset: 0.628906
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c0c1c3",
      stopOpacity: 1
    },
    offset: 0.632812
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c1c3c5",
      stopOpacity: 1
    },
    offset: 0.636719
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c2c4c6",
      stopOpacity: 1
    },
    offset: 0.640625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c4c5c7",
      stopOpacity: 1
    },
    offset: 0.644531
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c5c7c9",
      stopOpacity: 1
    },
    offset: 0.648438
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c6c8ca",
      stopOpacity: 1
    },
    offset: 0.652344
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c8cacb",
      stopOpacity: 1
    },
    offset: 0.65625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c9cbcd",
      stopOpacity: 1
    },
    offset: 0.660156
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#cbccce",
      stopOpacity: 1
    },
    offset: 0.664062
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#cccecf",
      stopOpacity: 1
    },
    offset: 0.667969
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#cdcfd0",
      stopOpacity: 1
    },
    offset: 0.671875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#cfd0d2",
      stopOpacity: 1
    },
    offset: 0.675781
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d0d2d3",
      stopOpacity: 1
    },
    offset: 0.679688
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d2d3d4",
      stopOpacity: 1
    },
    offset: 0.683594
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d3d4d6",
      stopOpacity: 1
    },
    offset: 0.6875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d4d6d7",
      stopOpacity: 1
    },
    offset: 0.691406
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d6d7d8",
      stopOpacity: 1
    },
    offset: 0.695312
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d7d8da",
      stopOpacity: 1
    },
    offset: 0.699219
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d9dadb",
      stopOpacity: 1
    },
    offset: 0.703125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#dadbdc",
      stopOpacity: 1
    },
    offset: 0.707031
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#dbddde",
      stopOpacity: 1
    },
    offset: 0.710938
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#dddedf",
      stopOpacity: 1
    },
    offset: 0.714844
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#dedfe0",
      stopOpacity: 1
    },
    offset: 0.71875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e0e1e2",
      stopOpacity: 1
    },
    offset: 0.722656
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e1e2e3",
      stopOpacity: 1
    },
    offset: 0.726563
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e2e3e4",
      stopOpacity: 1
    },
    offset: 0.730469
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e4e5e5",
      stopOpacity: 1
    },
    offset: 0.734375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e5e6e7",
      stopOpacity: 1
    },
    offset: 0.738281
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e7e7e8",
      stopOpacity: 1
    },
    offset: 0.742188
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e8e9e9",
      stopOpacity: 1
    },
    offset: 0.746094
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e9eaeb",
      stopOpacity: 1
    },
    offset: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ebebec",
      stopOpacity: 1
    },
    offset: 0.753906
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#eceded",
      stopOpacity: 1
    },
    offset: 0.757812
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#eeeeef",
      stopOpacity: 1
    },
    offset: 0.761719
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#efeff0",
      stopOpacity: 1
    },
    offset: 0.765625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f0f1f1",
      stopOpacity: 1
    },
    offset: 0.769531
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f2f2f3",
      stopOpacity: 1
    },
    offset: 0.773438
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f3f4f4",
      stopOpacity: 1
    },
    offset: 0.777344
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f5f5f5",
      stopOpacity: 1
    },
    offset: 0.78125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f6f6f7",
      stopOpacity: 1
    },
    offset: 0.785156
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f7f8f8",
      stopOpacity: 1
    },
    offset: 0.789062
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f9f9f9",
      stopOpacity: 1
    },
    offset: 0.792969
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fafafa",
      stopOpacity: 1
    },
    offset: 0.796875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fcfcfc",
      stopOpacity: 1
    },
    offset: 0.800781
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fdfdfd",
      stopOpacity: 1
    },
    offset: 0.804688
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fdfdfd",
      stopOpacity: 1
    },
    offset: 0.808594
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fefefe",
      stopOpacity: 1
    },
    offset: 0.8125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fbfbfb",
      stopOpacity: 1
    },
    offset: 0.816406
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f8f8f8",
      stopOpacity: 1
    },
    offset: 0.820312
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f6f6f6",
      stopOpacity: 1
    },
    offset: 0.824219
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f3f3f3",
      stopOpacity: 1
    },
    offset: 0.828125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f0f0f1",
      stopOpacity: 1
    },
    offset: 0.832031
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#eeeeee",
      stopOpacity: 1
    },
    offset: 0.835938
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ebebeb",
      stopOpacity: 1
    },
    offset: 0.839844
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e8e8e9",
      stopOpacity: 1
    },
    offset: 0.84375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e6e6e6",
      stopOpacity: 1
    },
    offset: 0.847656
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e3e3e4",
      stopOpacity: 1
    },
    offset: 0.851562
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e0e0e1",
      stopOpacity: 1
    },
    offset: 0.855469
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#dedede",
      stopOpacity: 1
    },
    offset: 0.859375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#dbdbdc",
      stopOpacity: 1
    },
    offset: 0.863281
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d8d9d9",
      stopOpacity: 1
    },
    offset: 0.867188
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d6d6d7",
      stopOpacity: 1
    },
    offset: 0.871094
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d3d3d4",
      stopOpacity: 1
    },
    offset: 0.875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d0d1d1",
      stopOpacity: 1
    },
    offset: 0.878906
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#cececf",
      stopOpacity: 1
    },
    offset: 0.882812
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#cbcbcc",
      stopOpacity: 1
    },
    offset: 0.886719
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c8c9ca",
      stopOpacity: 1
    },
    offset: 0.890625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c6c6c7",
      stopOpacity: 1
    },
    offset: 0.894531
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c3c3c4",
      stopOpacity: 1
    },
    offset: 0.898438
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c0c1c2",
      stopOpacity: 1
    },
    offset: 0.902344
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#bebebf",
      stopOpacity: 1
    },
    offset: 0.90625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#bbbcbd",
      stopOpacity: 1
    },
    offset: 0.910156
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#b8b9ba",
      stopOpacity: 1
    },
    offset: 0.914063
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#b6b6b7",
      stopOpacity: 1
    },
    offset: 0.917969
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#b3b4b5",
      stopOpacity: 1
    },
    offset: 0.921875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#b0b1b2",
      stopOpacity: 1
    },
    offset: 0.925781
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#aeaeb0",
      stopOpacity: 1
    },
    offset: 0.929688
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#abacad",
      stopOpacity: 1
    },
    offset: 0.933594
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#a8a9aa",
      stopOpacity: 1
    },
    offset: 0.9375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#a6a6a8",
      stopOpacity: 1
    },
    offset: 0.941406
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#a3a4a5",
      stopOpacity: 1
    },
    offset: 0.945313
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#a0a1a3",
      stopOpacity: 1
    },
    offset: 0.949219
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#9e9ea0",
      stopOpacity: 1
    },
    offset: 0.953125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#9b9c9d",
      stopOpacity: 1
    },
    offset: 0.957031
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#98999b",
      stopOpacity: 1
    },
    offset: 0.960938
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#969798",
      stopOpacity: 1
    },
    offset: 0.964844
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#939496",
      stopOpacity: 1
    },
    offset: 0.96875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#909193",
      stopOpacity: 1
    },
    offset: 0.972656
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#8e8f90",
      stopOpacity: 1
    },
    offset: 0.976562
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#8b8c8e",
      stopOpacity: 1
    },
    offset: 0.980469
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#88898b",
      stopOpacity: 1
    },
    offset: 0.984375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#868789",
      stopOpacity: 1
    },
    offset: 0.988281
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#838486",
      stopOpacity: 1
    },
    offset: 0.992188
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#828385",
      stopOpacity: 1
    },
    offset: 0.996094
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#808183",
      stopOpacity: 1
    },
    offset: 1
  })), _ref4, _ref5, /*#__PURE__*/React.createElement("linearGradient", {
    x1: 46.29999,
    gradientTransform: "matrix(1.529572,0,0,-1.5297,-0.090027,191.286603)",
    y1: 26.299999,
    x2: 74.299992,
    gradientUnits: "userSpaceOnUse",
    y2: 26.299999,
    id: "74c834b79e"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#bbbcbe",
      stopOpacity: 1
    },
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#bcbdbf",
      stopOpacity: 1
    },
    offset: 0.00390625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#bcbdbf",
      stopOpacity: 1
    },
    offset: 0.0078125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#bdbec0",
      stopOpacity: 1
    },
    offset: 0.0117188
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#bebfc1",
      stopOpacity: 1
    },
    offset: 0.015625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#bfc0c2",
      stopOpacity: 1
    },
    offset: 0.0195312
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c0c1c3",
      stopOpacity: 1
    },
    offset: 0.0234375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c1c2c4",
      stopOpacity: 1
    },
    offset: 0.0273438
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c2c3c4",
      stopOpacity: 1
    },
    offset: 0.03125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c3c3c5",
      stopOpacity: 1
    },
    offset: 0.0351563
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c3c4c6",
      stopOpacity: 1
    },
    offset: 0.0390625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c4c5c7",
      stopOpacity: 1
    },
    offset: 0.0429688
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c5c6c8",
      stopOpacity: 1
    },
    offset: 0.046875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c6c7c9",
      stopOpacity: 1
    },
    offset: 0.0507813
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c7c8c9",
      stopOpacity: 1
    },
    offset: 0.0546875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c8c9ca",
      stopOpacity: 1
    },
    offset: 0.0585938
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c9c9cb",
      stopOpacity: 1
    },
    offset: 0.0625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c9cacc",
      stopOpacity: 1
    },
    offset: 0.0664063
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#cacbcd",
      stopOpacity: 1
    },
    offset: 0.0703125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#cbcccd",
      stopOpacity: 1
    },
    offset: 0.0742188
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#cccdce",
      stopOpacity: 1
    },
    offset: 0.078125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#cdcecf",
      stopOpacity: 1
    },
    offset: 0.0820312
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ceced0",
      stopOpacity: 1
    },
    offset: 0.0859375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#cfcfd1",
      stopOpacity: 1
    },
    offset: 0.0898438
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#cfd0d2",
      stopOpacity: 1
    },
    offset: 0.09375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d0d1d2",
      stopOpacity: 1
    },
    offset: 0.0976563
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d1d2d3",
      stopOpacity: 1
    },
    offset: 0.101563
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d2d3d4",
      stopOpacity: 1
    },
    offset: 0.105469
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d3d4d5",
      stopOpacity: 1
    },
    offset: 0.109375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d4d4d6",
      stopOpacity: 1
    },
    offset: 0.113281
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d5d5d7",
      stopOpacity: 1
    },
    offset: 0.117188
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d5d6d7",
      stopOpacity: 1
    },
    offset: 0.121094
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d6d7d8",
      stopOpacity: 1
    },
    offset: 0.125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d7d8d9",
      stopOpacity: 1
    },
    offset: 0.128906
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d8d9da",
      stopOpacity: 1
    },
    offset: 0.132813
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d9dadb",
      stopOpacity: 1
    },
    offset: 0.136719
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#dadadb",
      stopOpacity: 1
    },
    offset: 0.140625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#dbdbdc",
      stopOpacity: 1
    },
    offset: 0.144531
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#dcdcdd",
      stopOpacity: 1
    },
    offset: 0.148438
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#dcddde",
      stopOpacity: 1
    },
    offset: 0.152344
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#dddedf",
      stopOpacity: 1
    },
    offset: 0.15625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#dedfe0",
      stopOpacity: 1
    },
    offset: 0.160156
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#dfdfe0",
      stopOpacity: 1
    },
    offset: 0.164062
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e0e0e1",
      stopOpacity: 1
    },
    offset: 0.167969
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e1e1e2",
      stopOpacity: 1
    },
    offset: 0.171875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e2e2e3",
      stopOpacity: 1
    },
    offset: 0.175781
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e2e3e4",
      stopOpacity: 1
    },
    offset: 0.179688
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e3e4e5",
      stopOpacity: 1
    },
    offset: 0.183594
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e4e5e5",
      stopOpacity: 1
    },
    offset: 0.1875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e5e5e6",
      stopOpacity: 1
    },
    offset: 0.191406
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e6e6e7",
      stopOpacity: 1
    },
    offset: 0.195313
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e7e7e8",
      stopOpacity: 1
    },
    offset: 0.199219
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e8e8e9",
      stopOpacity: 1
    },
    offset: 0.203125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e8e9e9",
      stopOpacity: 1
    },
    offset: 0.207031
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e9eaea",
      stopOpacity: 1
    },
    offset: 0.210938
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#eaebeb",
      stopOpacity: 1
    },
    offset: 0.214844
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ebebec",
      stopOpacity: 1
    },
    offset: 0.21875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ececed",
      stopOpacity: 1
    },
    offset: 0.222656
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ededee",
      stopOpacity: 1
    },
    offset: 0.226563
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#eeeeee",
      stopOpacity: 1
    },
    offset: 0.230469
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#efefef",
      stopOpacity: 1
    },
    offset: 0.234375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#eff0f0",
      stopOpacity: 1
    },
    offset: 0.238281
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f0f0f1",
      stopOpacity: 1
    },
    offset: 0.242188
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f1f1f2",
      stopOpacity: 1
    },
    offset: 0.246094
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f2f2f3",
      stopOpacity: 1
    },
    offset: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f3f3f3",
      stopOpacity: 1
    },
    offset: 0.253906
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f4f4f4",
      stopOpacity: 1
    },
    offset: 0.257813
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f5f5f5",
      stopOpacity: 1
    },
    offset: 0.261719
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f5f6f6",
      stopOpacity: 1
    },
    offset: 0.265625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f6f6f7",
      stopOpacity: 1
    },
    offset: 0.269531
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f7f7f7",
      stopOpacity: 1
    },
    offset: 0.273438
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f8f8f8",
      stopOpacity: 1
    },
    offset: 0.277344
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f9f9f9",
      stopOpacity: 1
    },
    offset: 0.28125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fafafa",
      stopOpacity: 1
    },
    offset: 0.285156
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fbfbfb",
      stopOpacity: 1
    },
    offset: 0.289063
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fbfbfc",
      stopOpacity: 1
    },
    offset: 0.292969
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fcfcfc",
      stopOpacity: 1
    },
    offset: 0.296875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fdfdfd",
      stopOpacity: 1
    },
    offset: 0.300781
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fefefe",
      stopOpacity: 1
    },
    offset: 0.304688
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ffffff",
      stopOpacity: 1
    },
    offset: 0.3125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ffffff",
      stopOpacity: 1
    },
    offset: 0.375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ffffff",
      stopOpacity: 1
    },
    offset: 0.4375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ffffff",
      stopOpacity: 1
    },
    offset: 0.46875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ffffff",
      stopOpacity: 1
    },
    offset: 0.484375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fefefe",
      stopOpacity: 1
    },
    offset: 0.488281
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fefefe",
      stopOpacity: 1
    },
    offset: 0.492188
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fcfcfc",
      stopOpacity: 1
    },
    offset: 0.496094
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fafafa",
      stopOpacity: 1
    },
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f8f8f8",
      stopOpacity: 1
    },
    offset: 0.503906
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f6f6f6",
      stopOpacity: 1
    },
    offset: 0.507812
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f4f4f4",
      stopOpacity: 1
    },
    offset: 0.511719
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f2f2f3",
      stopOpacity: 1
    },
    offset: 0.515625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f0f0f1",
      stopOpacity: 1
    },
    offset: 0.519531
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#eeeeef",
      stopOpacity: 1
    },
    offset: 0.523438
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ececed",
      stopOpacity: 1
    },
    offset: 0.527344
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#eaeaeb",
      stopOpacity: 1
    },
    offset: 0.53125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e8e9e9",
      stopOpacity: 1
    },
    offset: 0.535156
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e6e7e7",
      stopOpacity: 1
    },
    offset: 0.539063
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e4e5e5",
      stopOpacity: 1
    },
    offset: 0.542969
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e2e3e4",
      stopOpacity: 1
    },
    offset: 0.546875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e0e1e2",
      stopOpacity: 1
    },
    offset: 0.550781
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#dedfe0",
      stopOpacity: 1
    },
    offset: 0.554688
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#dcddde",
      stopOpacity: 1
    },
    offset: 0.558594
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#dadbdc",
      stopOpacity: 1
    },
    offset: 0.5625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d8d9da",
      stopOpacity: 1
    },
    offset: 0.566406
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d6d7d8",
      stopOpacity: 1
    },
    offset: 0.570313
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d4d5d7",
      stopOpacity: 1
    },
    offset: 0.574219
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d2d3d5",
      stopOpacity: 1
    },
    offset: 0.578125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d0d1d3",
      stopOpacity: 1
    },
    offset: 0.582031
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#cecfd1",
      stopOpacity: 1
    },
    offset: 0.585938
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#cccecf",
      stopOpacity: 1
    },
    offset: 0.589844
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#cacccd",
      stopOpacity: 1
    },
    offset: 0.59375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c8cacb",
      stopOpacity: 1
    },
    offset: 0.597656
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c6c8c9",
      stopOpacity: 1
    },
    offset: 0.601563
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c4c6c8",
      stopOpacity: 1
    },
    offset: 0.605469
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c2c4c6",
      stopOpacity: 1
    },
    offset: 0.609375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c0c2c4",
      stopOpacity: 1
    },
    offset: 0.613281
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#bec0c2",
      stopOpacity: 1
    },
    offset: 0.617188
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#bdbfc1",
      stopOpacity: 1
    },
    offset: 0.621094
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#bbbec0",
      stopOpacity: 1
    },
    offset: 0.625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#bdbfc1",
      stopOpacity: 1
    },
    offset: 0.628906
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#bec0c2",
      stopOpacity: 1
    },
    offset: 0.632813
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c0c2c3",
      stopOpacity: 1
    },
    offset: 0.636719
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c1c3c5",
      stopOpacity: 1
    },
    offset: 0.640625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c3c4c6",
      stopOpacity: 1
    },
    offset: 0.644531
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c4c6c7",
      stopOpacity: 1
    },
    offset: 0.648438
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c5c7c9",
      stopOpacity: 1
    },
    offset: 0.652344
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c7c8ca",
      stopOpacity: 1
    },
    offset: 0.65625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c8cacb",
      stopOpacity: 1
    },
    offset: 0.660156
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#cacbcd",
      stopOpacity: 1
    },
    offset: 0.664063
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#cbccce",
      stopOpacity: 1
    },
    offset: 0.667969
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#cccecf",
      stopOpacity: 1
    },
    offset: 0.671875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#cecfd1",
      stopOpacity: 1
    },
    offset: 0.675781
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#cfd1d2",
      stopOpacity: 1
    },
    offset: 0.679687
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d1d2d3",
      stopOpacity: 1
    },
    offset: 0.683594
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d2d3d5",
      stopOpacity: 1
    },
    offset: 0.6875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d3d5d6",
      stopOpacity: 1
    },
    offset: 0.691406
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d5d6d7",
      stopOpacity: 1
    },
    offset: 0.695312
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d6d7d9",
      stopOpacity: 1
    },
    offset: 0.699219
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d8d9da",
      stopOpacity: 1
    },
    offset: 0.703125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d9dadb",
      stopOpacity: 1
    },
    offset: 0.707031
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#dadbdd",
      stopOpacity: 1
    },
    offset: 0.710937
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#dcddde",
      stopOpacity: 1
    },
    offset: 0.714844
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#dddedf",
      stopOpacity: 1
    },
    offset: 0.71875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#dfe0e1",
      stopOpacity: 1
    },
    offset: 0.722656
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e0e1e2",
      stopOpacity: 1
    },
    offset: 0.726562
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e1e2e3",
      stopOpacity: 1
    },
    offset: 0.730469
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e3e4e4",
      stopOpacity: 1
    },
    offset: 0.734375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e4e5e6",
      stopOpacity: 1
    },
    offset: 0.738281
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e6e6e7",
      stopOpacity: 1
    },
    offset: 0.742187
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e7e8e8",
      stopOpacity: 1
    },
    offset: 0.746094
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e8e9ea",
      stopOpacity: 1
    },
    offset: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#eaeaeb",
      stopOpacity: 1
    },
    offset: 0.753906
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ebecec",
      stopOpacity: 1
    },
    offset: 0.757812
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ededee",
      stopOpacity: 1
    },
    offset: 0.761719
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#eeefef",
      stopOpacity: 1
    },
    offset: 0.765625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#eff0f0",
      stopOpacity: 1
    },
    offset: 0.769531
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f1f1f2",
      stopOpacity: 1
    },
    offset: 0.773437
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f2f3f3",
      stopOpacity: 1
    },
    offset: 0.777344
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f4f4f4",
      stopOpacity: 1
    },
    offset: 0.78125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f5f5f6",
      stopOpacity: 1
    },
    offset: 0.785156
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f6f7f7",
      stopOpacity: 1
    },
    offset: 0.789062
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f8f8f8",
      stopOpacity: 1
    },
    offset: 0.792969
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f9f9fa",
      stopOpacity: 1
    },
    offset: 0.796875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fbfbfb",
      stopOpacity: 1
    },
    offset: 0.800781
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fcfcfc",
      stopOpacity: 1
    },
    offset: 0.804687
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fdfdfe",
      stopOpacity: 1
    },
    offset: 0.808594
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ffffff",
      stopOpacity: 1
    },
    offset: 0.8125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fcfcfc",
      stopOpacity: 1
    },
    offset: 0.816406
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fafafa",
      stopOpacity: 1
    },
    offset: 0.820312
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f7f7f7",
      stopOpacity: 1
    },
    offset: 0.824219
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f5f5f5",
      stopOpacity: 1
    },
    offset: 0.828125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f2f2f2",
      stopOpacity: 1
    },
    offset: 0.832031
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#efeff0",
      stopOpacity: 1
    },
    offset: 0.835937
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ededed",
      stopOpacity: 1
    },
    offset: 0.839844
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#eaeaea",
      stopOpacity: 1
    },
    offset: 0.84375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e7e7e8",
      stopOpacity: 1
    },
    offset: 0.847656
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e5e5e5",
      stopOpacity: 1
    },
    offset: 0.851562
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e2e2e3",
      stopOpacity: 1
    },
    offset: 0.855469
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#dfdfe0",
      stopOpacity: 1
    },
    offset: 0.859375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#dddddd",
      stopOpacity: 1
    },
    offset: 0.863281
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#dadadb",
      stopOpacity: 1
    },
    offset: 0.867188
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d7d8d8",
      stopOpacity: 1
    },
    offset: 0.871094
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d5d5d6",
      stopOpacity: 1
    },
    offset: 0.875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d2d2d3",
      stopOpacity: 1
    },
    offset: 0.878906
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#cfd0d0",
      stopOpacity: 1
    },
    offset: 0.882812
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#cdcdce",
      stopOpacity: 1
    },
    offset: 0.886719
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#cacacb",
      stopOpacity: 1
    },
    offset: 0.890625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c7c8c9",
      stopOpacity: 1
    },
    offset: 0.894531
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c5c5c6",
      stopOpacity: 1
    },
    offset: 0.898438
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c2c2c3",
      stopOpacity: 1
    },
    offset: 0.902344
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#bfc0c1",
      stopOpacity: 1
    },
    offset: 0.90625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#bcbdbe",
      stopOpacity: 1
    },
    offset: 0.910156
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#bababb",
      stopOpacity: 1
    },
    offset: 0.914063
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#b7b8b9",
      stopOpacity: 1
    },
    offset: 0.917969
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#b4b5b6",
      stopOpacity: 1
    },
    offset: 0.921875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#b2b2b4",
      stopOpacity: 1
    },
    offset: 0.925781
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#afb0b1",
      stopOpacity: 1
    },
    offset: 0.929688
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#acadae",
      stopOpacity: 1
    },
    offset: 0.933594
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#aaaaac",
      stopOpacity: 1
    },
    offset: 0.9375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#a7a8a9",
      stopOpacity: 1
    },
    offset: 0.941406
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#a4a5a7",
      stopOpacity: 1
    },
    offset: 0.945313
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#a2a2a4",
      stopOpacity: 1
    },
    offset: 0.949219
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#9fa0a1",
      stopOpacity: 1
    },
    offset: 0.953125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#9c9d9f",
      stopOpacity: 1
    },
    offset: 0.957031
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#9a9b9c",
      stopOpacity: 1
    },
    offset: 0.960938
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#97989a",
      stopOpacity: 1
    },
    offset: 0.964844
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#949597",
      stopOpacity: 1
    },
    offset: 0.96875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#929394",
      stopOpacity: 1
    },
    offset: 0.972656
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#8f9092",
      stopOpacity: 1
    },
    offset: 0.976563
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#8c8d8f",
      stopOpacity: 1
    },
    offset: 0.980469
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#8a8b8d",
      stopOpacity: 1
    },
    offset: 0.984375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#87888a",
      stopOpacity: 1
    },
    offset: 0.988281
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#848587",
      stopOpacity: 1
    },
    offset: 0.992188
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#828385",
      stopOpacity: 1
    },
    offset: 0.996094
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#808183",
      stopOpacity: 1
    },
    offset: 1
  })), _ref6, _ref7, /*#__PURE__*/React.createElement("linearGradient", {
    x1: 69.099995,
    gradientTransform: "matrix(1.529572,0,0,-1.5297,-0.090027,191.286603)",
    y1: 26.264999,
    x2: 96.299999,
    gradientUnits: "userSpaceOnUse",
    y2: 26.264999,
    id: "ebc20216d8"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#bbbcbe",
      stopOpacity: 1
    },
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#bcbdbf",
      stopOpacity: 1
    },
    offset: 0.00390625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#bdbec0",
      stopOpacity: 1
    },
    offset: 0.0078125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#bdbec0",
      stopOpacity: 1
    },
    offset: 0.0117188
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#bebfc1",
      stopOpacity: 1
    },
    offset: 0.015625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#bfc0c2",
      stopOpacity: 1
    },
    offset: 0.0195313
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c0c1c3",
      stopOpacity: 1
    },
    offset: 0.0234375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c1c2c4",
      stopOpacity: 1
    },
    offset: 0.0273438
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c2c3c4",
      stopOpacity: 1
    },
    offset: 0.03125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c3c3c5",
      stopOpacity: 1
    },
    offset: 0.0351563
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c3c4c6",
      stopOpacity: 1
    },
    offset: 0.0390625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c4c5c7",
      stopOpacity: 1
    },
    offset: 0.0429688
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c5c6c8",
      stopOpacity: 1
    },
    offset: 0.046875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c6c7c9",
      stopOpacity: 1
    },
    offset: 0.0507813
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c7c8c9",
      stopOpacity: 1
    },
    offset: 0.0546875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c8c9ca",
      stopOpacity: 1
    },
    offset: 0.0585938
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c9c9cb",
      stopOpacity: 1
    },
    offset: 0.0625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c9cacc",
      stopOpacity: 1
    },
    offset: 0.0664062
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#cacbcd",
      stopOpacity: 1
    },
    offset: 0.0703125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#cbcccd",
      stopOpacity: 1
    },
    offset: 0.0742188
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#cccdce",
      stopOpacity: 1
    },
    offset: 0.078125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#cdcecf",
      stopOpacity: 1
    },
    offset: 0.0820312
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ceced0",
      stopOpacity: 1
    },
    offset: 0.0859375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#cfcfd1",
      stopOpacity: 1
    },
    offset: 0.0898438
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#cfd0d2",
      stopOpacity: 1
    },
    offset: 0.09375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d0d1d2",
      stopOpacity: 1
    },
    offset: 0.0976562
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d1d2d3",
      stopOpacity: 1
    },
    offset: 0.101562
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d2d3d4",
      stopOpacity: 1
    },
    offset: 0.105469
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d3d3d5",
      stopOpacity: 1
    },
    offset: 0.109375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d4d4d6",
      stopOpacity: 1
    },
    offset: 0.113281
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d5d5d6",
      stopOpacity: 1
    },
    offset: 0.117188
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d5d6d7",
      stopOpacity: 1
    },
    offset: 0.121094
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d6d7d8",
      stopOpacity: 1
    },
    offset: 0.125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d7d8d9",
      stopOpacity: 1
    },
    offset: 0.128906
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d8d9da",
      stopOpacity: 1
    },
    offset: 0.132812
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d9d9db",
      stopOpacity: 1
    },
    offset: 0.136719
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#dadadb",
      stopOpacity: 1
    },
    offset: 0.140625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#dbdbdc",
      stopOpacity: 1
    },
    offset: 0.144531
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#dbdcdd",
      stopOpacity: 1
    },
    offset: 0.148438
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#dcddde",
      stopOpacity: 1
    },
    offset: 0.152344
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#dddedf",
      stopOpacity: 1
    },
    offset: 0.15625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#dededf",
      stopOpacity: 1
    },
    offset: 0.160156
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#dfdfe0",
      stopOpacity: 1
    },
    offset: 0.164062
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e0e0e1",
      stopOpacity: 1
    },
    offset: 0.167969
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e1e1e2",
      stopOpacity: 1
    },
    offset: 0.171875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e1e2e3",
      stopOpacity: 1
    },
    offset: 0.175781
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e2e3e4",
      stopOpacity: 1
    },
    offset: 0.179688
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e3e3e4",
      stopOpacity: 1
    },
    offset: 0.183594
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e4e4e5",
      stopOpacity: 1
    },
    offset: 0.1875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e5e5e6",
      stopOpacity: 1
    },
    offset: 0.191406
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e6e6e7",
      stopOpacity: 1
    },
    offset: 0.195312
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e6e7e8",
      stopOpacity: 1
    },
    offset: 0.199219
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e7e8e8",
      stopOpacity: 1
    },
    offset: 0.203125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e8e9e9",
      stopOpacity: 1
    },
    offset: 0.207031
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e9e9ea",
      stopOpacity: 1
    },
    offset: 0.210938
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#eaeaeb",
      stopOpacity: 1
    },
    offset: 0.214844
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ebebec",
      stopOpacity: 1
    },
    offset: 0.21875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ececed",
      stopOpacity: 1
    },
    offset: 0.222656
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#eceded",
      stopOpacity: 1
    },
    offset: 0.226562
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#edeeee",
      stopOpacity: 1
    },
    offset: 0.230469
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#eeeeef",
      stopOpacity: 1
    },
    offset: 0.234375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#efeff0",
      stopOpacity: 1
    },
    offset: 0.238281
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f0f0f1",
      stopOpacity: 1
    },
    offset: 0.242188
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f1f1f1",
      stopOpacity: 1
    },
    offset: 0.246094
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f2f2f2",
      stopOpacity: 1
    },
    offset: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f2f3f3",
      stopOpacity: 1
    },
    offset: 0.253906
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f3f4f4",
      stopOpacity: 1
    },
    offset: 0.257813
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f4f4f5",
      stopOpacity: 1
    },
    offset: 0.261719
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f5f5f5",
      stopOpacity: 1
    },
    offset: 0.265625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f6f6f6",
      stopOpacity: 1
    },
    offset: 0.269531
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f7f7f7",
      stopOpacity: 1
    },
    offset: 0.273438
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f8f8f8",
      stopOpacity: 1
    },
    offset: 0.277344
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f8f9f9",
      stopOpacity: 1
    },
    offset: 0.28125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f9f9fa",
      stopOpacity: 1
    },
    offset: 0.285156
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fafafa",
      stopOpacity: 1
    },
    offset: 0.289063
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fbfbfb",
      stopOpacity: 1
    },
    offset: 0.292969
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fcfcfc",
      stopOpacity: 1
    },
    offset: 0.296875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fdfdfd",
      stopOpacity: 1
    },
    offset: 0.300781
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fefefe",
      stopOpacity: 1
    },
    offset: 0.304688
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fefefe",
      stopOpacity: 1
    },
    offset: 0.308594
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ffffff",
      stopOpacity: 1
    },
    offset: 0.3125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ffffff",
      stopOpacity: 1
    },
    offset: 0.375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ffffff",
      stopOpacity: 1
    },
    offset: 0.4375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ffffff",
      stopOpacity: 1
    },
    offset: 0.46875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ffffff",
      stopOpacity: 1
    },
    offset: 0.484375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ffffff",
      stopOpacity: 1
    },
    offset: 0.492188
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fdfdfd",
      stopOpacity: 1
    },
    offset: 0.496094
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fbfcfc",
      stopOpacity: 1
    },
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f9fafa",
      stopOpacity: 1
    },
    offset: 0.503906
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f8f8f8",
      stopOpacity: 1
    },
    offset: 0.507812
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f6f6f6",
      stopOpacity: 1
    },
    offset: 0.511719
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f4f4f4",
      stopOpacity: 1
    },
    offset: 0.515625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f2f2f2",
      stopOpacity: 1
    },
    offset: 0.519531
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f0f0f1",
      stopOpacity: 1
    },
    offset: 0.523438
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#eeeeef",
      stopOpacity: 1
    },
    offset: 0.527344
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ececed",
      stopOpacity: 1
    },
    offset: 0.53125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#eaeaeb",
      stopOpacity: 1
    },
    offset: 0.535156
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e8e8e9",
      stopOpacity: 1
    },
    offset: 0.539063
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e6e7e7",
      stopOpacity: 1
    },
    offset: 0.542969
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e4e5e5",
      stopOpacity: 1
    },
    offset: 0.546875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e2e3e4",
      stopOpacity: 1
    },
    offset: 0.550781
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e0e1e2",
      stopOpacity: 1
    },
    offset: 0.554688
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#dedfe0",
      stopOpacity: 1
    },
    offset: 0.558594
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#dcddde",
      stopOpacity: 1
    },
    offset: 0.5625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#dadbdc",
      stopOpacity: 1
    },
    offset: 0.566406
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d8d9da",
      stopOpacity: 1
    },
    offset: 0.570313
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d6d7d8",
      stopOpacity: 1
    },
    offset: 0.574219
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d4d5d7",
      stopOpacity: 1
    },
    offset: 0.578125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d2d3d5",
      stopOpacity: 1
    },
    offset: 0.582031
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d0d1d3",
      stopOpacity: 1
    },
    offset: 0.585938
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ced0d1",
      stopOpacity: 1
    },
    offset: 0.589844
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#cccecf",
      stopOpacity: 1
    },
    offset: 0.59375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#cacccd",
      stopOpacity: 1
    },
    offset: 0.597656
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c8cacb",
      stopOpacity: 1
    },
    offset: 0.601563
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c6c8ca",
      stopOpacity: 1
    },
    offset: 0.605469
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c4c6c8",
      stopOpacity: 1
    },
    offset: 0.609375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c2c4c6",
      stopOpacity: 1
    },
    offset: 0.613281
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c0c2c4",
      stopOpacity: 1
    },
    offset: 0.617188
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#bec0c2",
      stopOpacity: 1
    },
    offset: 0.621094
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#bcbec0",
      stopOpacity: 1
    },
    offset: 0.625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#bdbfc0",
      stopOpacity: 1
    },
    offset: 0.632813
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#bec0c2",
      stopOpacity: 1
    },
    offset: 0.636719
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c0c1c3",
      stopOpacity: 1
    },
    offset: 0.640625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c1c3c5",
      stopOpacity: 1
    },
    offset: 0.644531
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c2c4c6",
      stopOpacity: 1
    },
    offset: 0.648438
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c4c5c7",
      stopOpacity: 1
    },
    offset: 0.652344
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c5c7c9",
      stopOpacity: 1
    },
    offset: 0.65625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c6c8ca",
      stopOpacity: 1
    },
    offset: 0.660156
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c8cacb",
      stopOpacity: 1
    },
    offset: 0.664063
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c9cbcc",
      stopOpacity: 1
    },
    offset: 0.667969
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#cbccce",
      stopOpacity: 1
    },
    offset: 0.671875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#cccecf",
      stopOpacity: 1
    },
    offset: 0.675781
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#cdcfd0",
      stopOpacity: 1
    },
    offset: 0.679688
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#cfd0d2",
      stopOpacity: 1
    },
    offset: 0.683594
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d0d2d3",
      stopOpacity: 1
    },
    offset: 0.6875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d2d3d4",
      stopOpacity: 1
    },
    offset: 0.691406
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d3d4d6",
      stopOpacity: 1
    },
    offset: 0.695313
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d4d6d7",
      stopOpacity: 1
    },
    offset: 0.699219
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d6d7d8",
      stopOpacity: 1
    },
    offset: 0.703125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d7d8da",
      stopOpacity: 1
    },
    offset: 0.707031
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d9dadb",
      stopOpacity: 1
    },
    offset: 0.710938
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#dadbdc",
      stopOpacity: 1
    },
    offset: 0.714844
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#dbdcdd",
      stopOpacity: 1
    },
    offset: 0.71875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#dddedf",
      stopOpacity: 1
    },
    offset: 0.722656
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#dedfe0",
      stopOpacity: 1
    },
    offset: 0.726563
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e0e0e1",
      stopOpacity: 1
    },
    offset: 0.730469
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e1e2e3",
      stopOpacity: 1
    },
    offset: 0.734375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e2e3e4",
      stopOpacity: 1
    },
    offset: 0.738281
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e4e5e5",
      stopOpacity: 1
    },
    offset: 0.742188
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e5e6e7",
      stopOpacity: 1
    },
    offset: 0.746094
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e6e7e8",
      stopOpacity: 1
    },
    offset: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e8e9e9",
      stopOpacity: 1
    },
    offset: 0.753906
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e9eaeb",
      stopOpacity: 1
    },
    offset: 0.757812
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ebebec",
      stopOpacity: 1
    },
    offset: 0.761719
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#eceded",
      stopOpacity: 1
    },
    offset: 0.765625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#edeeee",
      stopOpacity: 1
    },
    offset: 0.769531
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#efeff0",
      stopOpacity: 1
    },
    offset: 0.773438
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f0f1f1",
      stopOpacity: 1
    },
    offset: 0.777344
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f2f2f2",
      stopOpacity: 1
    },
    offset: 0.78125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f3f3f4",
      stopOpacity: 1
    },
    offset: 0.785156
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f4f5f5",
      stopOpacity: 1
    },
    offset: 0.789062
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f6f6f6",
      stopOpacity: 1
    },
    offset: 0.792969
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f7f7f8",
      stopOpacity: 1
    },
    offset: 0.796875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f9f9f9",
      stopOpacity: 1
    },
    offset: 0.800781
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fafafa",
      stopOpacity: 1
    },
    offset: 0.804688
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fbfbfc",
      stopOpacity: 1
    },
    offset: 0.808594
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fdfdfd",
      stopOpacity: 1
    },
    offset: 0.8125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fdfdfd",
      stopOpacity: 1
    },
    offset: 0.816406
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fefefe",
      stopOpacity: 1
    },
    offset: 0.820312
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fbfbfb",
      stopOpacity: 1
    },
    offset: 0.824219
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f9f9f9",
      stopOpacity: 1
    },
    offset: 0.828125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f6f6f6",
      stopOpacity: 1
    },
    offset: 0.832031
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f3f3f4",
      stopOpacity: 1
    },
    offset: 0.835938
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f1f1f1",
      stopOpacity: 1
    },
    offset: 0.839844
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#eeeeee",
      stopOpacity: 1
    },
    offset: 0.84375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ebecec",
      stopOpacity: 1
    },
    offset: 0.847656
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e9e9e9",
      stopOpacity: 1
    },
    offset: 0.851562
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e6e6e7",
      stopOpacity: 1
    },
    offset: 0.855469
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e3e4e4",
      stopOpacity: 1
    },
    offset: 0.859375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e1e1e2",
      stopOpacity: 1
    },
    offset: 0.863281
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#dededf",
      stopOpacity: 1
    },
    offset: 0.867188
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#dbdcdc",
      stopOpacity: 1
    },
    offset: 0.871094
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d9d9da",
      stopOpacity: 1
    },
    offset: 0.875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d6d7d7",
      stopOpacity: 1
    },
    offset: 0.878906
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d4d4d5",
      stopOpacity: 1
    },
    offset: 0.882812
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d1d1d2",
      stopOpacity: 1
    },
    offset: 0.886719
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#cecfcf",
      stopOpacity: 1
    },
    offset: 0.890625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#cccccd",
      stopOpacity: 1
    },
    offset: 0.894531
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c9c9ca",
      stopOpacity: 1
    },
    offset: 0.898438
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c6c7c8",
      stopOpacity: 1
    },
    offset: 0.902344
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c4c4c5",
      stopOpacity: 1
    },
    offset: 0.90625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c1c1c2",
      stopOpacity: 1
    },
    offset: 0.910156
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#bebfc0",
      stopOpacity: 1
    },
    offset: 0.914062
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#bcbcbd",
      stopOpacity: 1
    },
    offset: 0.917969
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#b9babb",
      stopOpacity: 1
    },
    offset: 0.921875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#b6b7b8",
      stopOpacity: 1
    },
    offset: 0.925781
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#b4b4b6",
      stopOpacity: 1
    },
    offset: 0.929688
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#b1b2b3",
      stopOpacity: 1
    },
    offset: 0.933594
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#aeafb0",
      stopOpacity: 1
    },
    offset: 0.9375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#acacae",
      stopOpacity: 1
    },
    offset: 0.941406
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#a9aaab",
      stopOpacity: 1
    },
    offset: 0.945312
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#a6a7a9",
      stopOpacity: 1
    },
    offset: 0.949219
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#a4a5a6",
      stopOpacity: 1
    },
    offset: 0.953125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#a1a2a3",
      stopOpacity: 1
    },
    offset: 0.957031
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#9e9fa1",
      stopOpacity: 1
    },
    offset: 0.960938
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#9c9d9e",
      stopOpacity: 1
    },
    offset: 0.964844
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#999a9c",
      stopOpacity: 1
    },
    offset: 0.96875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#979799",
      stopOpacity: 1
    },
    offset: 0.972656
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#949596",
      stopOpacity: 1
    },
    offset: 0.976562
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#919294",
      stopOpacity: 1
    },
    offset: 0.980469
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#8f8f91",
      stopOpacity: 1
    },
    offset: 0.984375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#8c8d8f",
      stopOpacity: 1
    },
    offset: 0.988281
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#898a8c",
      stopOpacity: 1
    },
    offset: 0.992188
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#87888a",
      stopOpacity: 1
    },
    offset: 0.996094
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#848587",
      stopOpacity: 1
    },
    offset: 1
  })), _ref8, _ref9, /*#__PURE__*/React.createElement("linearGradient", {
    x1: 97.500004,
    gradientTransform: "matrix(1.529572,0,0,-1.5297,-0.090027,191.286603)",
    y1: 26.294001,
    x2: 121.799998,
    gradientUnits: "userSpaceOnUse",
    y2: 26.294001,
    id: "4bad9911d6"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#bcbdbf",
      stopOpacity: 1
    },
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#bdbec0",
      stopOpacity: 1
    },
    offset: 0.00390625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#bebfc1",
      stopOpacity: 1
    },
    offset: 0.0078125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#bfc0c2",
      stopOpacity: 1
    },
    offset: 0.0117187
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c0c1c2",
      stopOpacity: 1
    },
    offset: 0.015625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c0c1c3",
      stopOpacity: 1
    },
    offset: 0.0195313
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c1c2c4",
      stopOpacity: 1
    },
    offset: 0.0234375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c2c3c5",
      stopOpacity: 1
    },
    offset: 0.0273438
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c3c4c6",
      stopOpacity: 1
    },
    offset: 0.03125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c4c5c7",
      stopOpacity: 1
    },
    offset: 0.0351563
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c5c6c7",
      stopOpacity: 1
    },
    offset: 0.0390625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c6c6c8",
      stopOpacity: 1
    },
    offset: 0.0429688
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c6c7c9",
      stopOpacity: 1
    },
    offset: 0.046875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c7c8ca",
      stopOpacity: 1
    },
    offset: 0.0507812
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c8c9cb",
      stopOpacity: 1
    },
    offset: 0.0546875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c9cacb",
      stopOpacity: 1
    },
    offset: 0.0585938
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#cacbcc",
      stopOpacity: 1
    },
    offset: 0.0625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#cbcbcd",
      stopOpacity: 1
    },
    offset: 0.0664062
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ccccce",
      stopOpacity: 1
    },
    offset: 0.0703125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#cccdcf",
      stopOpacity: 1
    },
    offset: 0.0742188
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#cdced0",
      stopOpacity: 1
    },
    offset: 0.078125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#cecfd0",
      stopOpacity: 1
    },
    offset: 0.0820312
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#cfd0d1",
      stopOpacity: 1
    },
    offset: 0.0859375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d0d1d2",
      stopOpacity: 1
    },
    offset: 0.0898437
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d1d1d3",
      stopOpacity: 1
    },
    offset: 0.09375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d2d2d4",
      stopOpacity: 1
    },
    offset: 0.0976562
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d2d3d4",
      stopOpacity: 1
    },
    offset: 0.101562
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d3d4d5",
      stopOpacity: 1
    },
    offset: 0.105469
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d4d5d6",
      stopOpacity: 1
    },
    offset: 0.109375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d5d6d7",
      stopOpacity: 1
    },
    offset: 0.113281
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d6d6d8",
      stopOpacity: 1
    },
    offset: 0.117188
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d7d7d9",
      stopOpacity: 1
    },
    offset: 0.121094
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d8d8d9",
      stopOpacity: 1
    },
    offset: 0.125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d8d9da",
      stopOpacity: 1
    },
    offset: 0.128906
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d9dadb",
      stopOpacity: 1
    },
    offset: 0.132812
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#dadbdc",
      stopOpacity: 1
    },
    offset: 0.136719
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#dbdcdd",
      stopOpacity: 1
    },
    offset: 0.140625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#dcdcdd",
      stopOpacity: 1
    },
    offset: 0.144531
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ddddde",
      stopOpacity: 1
    },
    offset: 0.148438
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#dededf",
      stopOpacity: 1
    },
    offset: 0.152344
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#dedfe0",
      stopOpacity: 1
    },
    offset: 0.15625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#dfe0e1",
      stopOpacity: 1
    },
    offset: 0.160156
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e0e1e2",
      stopOpacity: 1
    },
    offset: 0.164063
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e1e1e2",
      stopOpacity: 1
    },
    offset: 0.167969
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e2e2e3",
      stopOpacity: 1
    },
    offset: 0.171875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e3e3e4",
      stopOpacity: 1
    },
    offset: 0.175781
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e4e4e5",
      stopOpacity: 1
    },
    offset: 0.179688
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e4e5e6",
      stopOpacity: 1
    },
    offset: 0.183594
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e5e6e6",
      stopOpacity: 1
    },
    offset: 0.1875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e6e7e7",
      stopOpacity: 1
    },
    offset: 0.191406
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e7e7e8",
      stopOpacity: 1
    },
    offset: 0.195313
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e8e8e9",
      stopOpacity: 1
    },
    offset: 0.199219
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e9e9ea",
      stopOpacity: 1
    },
    offset: 0.203125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#eaeaeb",
      stopOpacity: 1
    },
    offset: 0.207031
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#eaebeb",
      stopOpacity: 1
    },
    offset: 0.210938
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ebecec",
      stopOpacity: 1
    },
    offset: 0.214844
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ececed",
      stopOpacity: 1
    },
    offset: 0.21875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ededee",
      stopOpacity: 1
    },
    offset: 0.222656
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#eeeeef",
      stopOpacity: 1
    },
    offset: 0.226562
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#efefef",
      stopOpacity: 1
    },
    offset: 0.230469
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f0f0f0",
      stopOpacity: 1
    },
    offset: 0.234375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f0f1f1",
      stopOpacity: 1
    },
    offset: 0.238281
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f1f1f2",
      stopOpacity: 1
    },
    offset: 0.242188
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f2f2f3",
      stopOpacity: 1
    },
    offset: 0.246094
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f3f3f4",
      stopOpacity: 1
    },
    offset: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f4f4f4",
      stopOpacity: 1
    },
    offset: 0.253906
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f5f5f5",
      stopOpacity: 1
    },
    offset: 0.257812
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f6f6f6",
      stopOpacity: 1
    },
    offset: 0.261719
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f6f7f7",
      stopOpacity: 1
    },
    offset: 0.265625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f7f7f8",
      stopOpacity: 1
    },
    offset: 0.269531
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f8f8f8",
      stopOpacity: 1
    },
    offset: 0.273438
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f9f9f9",
      stopOpacity: 1
    },
    offset: 0.277344
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fafafa",
      stopOpacity: 1
    },
    offset: 0.28125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fbfbfb",
      stopOpacity: 1
    },
    offset: 0.285156
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fcfcfc",
      stopOpacity: 1
    },
    offset: 0.289063
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fcfcfd",
      stopOpacity: 1
    },
    offset: 0.292969
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fdfdfd",
      stopOpacity: 1
    },
    offset: 0.296875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fefefe",
      stopOpacity: 1
    },
    offset: 0.300781
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ffffff",
      stopOpacity: 1
    },
    offset: 0.304688
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ffffff",
      stopOpacity: 1
    },
    offset: 0.3125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ffffff",
      stopOpacity: 1
    },
    offset: 0.375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ffffff",
      stopOpacity: 1
    },
    offset: 0.4375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ffffff",
      stopOpacity: 1
    },
    offset: 0.46875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ffffff",
      stopOpacity: 1
    },
    offset: 0.484375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fefefe",
      stopOpacity: 1
    },
    offset: 0.488281
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fcfcfc",
      stopOpacity: 1
    },
    offset: 0.492188
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fafafa",
      stopOpacity: 1
    },
    offset: 0.496094
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f8f8f9",
      stopOpacity: 1
    },
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f6f6f7",
      stopOpacity: 1
    },
    offset: 0.503906
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f4f5f5",
      stopOpacity: 1
    },
    offset: 0.507812
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f2f3f3",
      stopOpacity: 1
    },
    offset: 0.511719
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f0f1f1",
      stopOpacity: 1
    },
    offset: 0.515625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#eeefef",
      stopOpacity: 1
    },
    offset: 0.519531
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#eceded",
      stopOpacity: 1
    },
    offset: 0.523438
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#eaebec",
      stopOpacity: 1
    },
    offset: 0.527344
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e8e9ea",
      stopOpacity: 1
    },
    offset: 0.53125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e6e7e8",
      stopOpacity: 1
    },
    offset: 0.535156
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e4e5e6",
      stopOpacity: 1
    },
    offset: 0.539063
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e2e3e4",
      stopOpacity: 1
    },
    offset: 0.542969
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e0e1e2",
      stopOpacity: 1
    },
    offset: 0.546875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#dedfe0",
      stopOpacity: 1
    },
    offset: 0.550781
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#dcdedf",
      stopOpacity: 1
    },
    offset: 0.554688
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#dadcdd",
      stopOpacity: 1
    },
    offset: 0.558594
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d9dadb",
      stopOpacity: 1
    },
    offset: 0.5625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d7d8d9",
      stopOpacity: 1
    },
    offset: 0.566406
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d5d6d7",
      stopOpacity: 1
    },
    offset: 0.570313
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d3d4d5",
      stopOpacity: 1
    },
    offset: 0.574219
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d1d2d3",
      stopOpacity: 1
    },
    offset: 0.578125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#cfd0d2",
      stopOpacity: 1
    },
    offset: 0.582031
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#cdced0",
      stopOpacity: 1
    },
    offset: 0.585938
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#cbccce",
      stopOpacity: 1
    },
    offset: 0.589844
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c9cacc",
      stopOpacity: 1
    },
    offset: 0.59375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c7c8ca",
      stopOpacity: 1
    },
    offset: 0.597656
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c5c6c8",
      stopOpacity: 1
    },
    offset: 0.601563
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c3c5c6",
      stopOpacity: 1
    },
    offset: 0.605469
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c1c3c5",
      stopOpacity: 1
    },
    offset: 0.609375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#bfc1c3",
      stopOpacity: 1
    },
    offset: 0.613281
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#bdbfc1",
      stopOpacity: 1
    },
    offset: 0.617188
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#bdbfc1",
      stopOpacity: 1
    },
    offset: 0.621094
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#bcbec0",
      stopOpacity: 1
    },
    offset: 0.625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#bec0c2",
      stopOpacity: 1
    },
    offset: 0.628906
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#bfc1c3",
      stopOpacity: 1
    },
    offset: 0.632813
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c1c2c4",
      stopOpacity: 1
    },
    offset: 0.636719
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c2c4c6",
      stopOpacity: 1
    },
    offset: 0.640625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c3c5c7",
      stopOpacity: 1
    },
    offset: 0.644531
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c5c6c8",
      stopOpacity: 1
    },
    offset: 0.648437
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c6c8ca",
      stopOpacity: 1
    },
    offset: 0.652344
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c7c9cb",
      stopOpacity: 1
    },
    offset: 0.65625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c9cbcc",
      stopOpacity: 1
    },
    offset: 0.660156
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#cacccd",
      stopOpacity: 1
    },
    offset: 0.664062
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#cccdcf",
      stopOpacity: 1
    },
    offset: 0.667969
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#cdcfd0",
      stopOpacity: 1
    },
    offset: 0.671875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ced0d1",
      stopOpacity: 1
    },
    offset: 0.675781
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d0d1d3",
      stopOpacity: 1
    },
    offset: 0.679688
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d1d3d4",
      stopOpacity: 1
    },
    offset: 0.683594
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d3d4d5",
      stopOpacity: 1
    },
    offset: 0.6875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d4d5d7",
      stopOpacity: 1
    },
    offset: 0.691406
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d5d7d8",
      stopOpacity: 1
    },
    offset: 0.695312
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d7d8d9",
      stopOpacity: 1
    },
    offset: 0.699219
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d8d9db",
      stopOpacity: 1
    },
    offset: 0.703125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#dadbdc",
      stopOpacity: 1
    },
    offset: 0.707031
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#dbdcdd",
      stopOpacity: 1
    },
    offset: 0.710938
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#dcddde",
      stopOpacity: 1
    },
    offset: 0.714844
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#dedfe0",
      stopOpacity: 1
    },
    offset: 0.71875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#dfe0e1",
      stopOpacity: 1
    },
    offset: 0.722656
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e1e1e2",
      stopOpacity: 1
    },
    offset: 0.726563
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e2e3e4",
      stopOpacity: 1
    },
    offset: 0.730469
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e3e4e5",
      stopOpacity: 1
    },
    offset: 0.734375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e5e6e6",
      stopOpacity: 1
    },
    offset: 0.738281
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e6e7e8",
      stopOpacity: 1
    },
    offset: 0.742188
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e8e8e9",
      stopOpacity: 1
    },
    offset: 0.746094
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e9eaea",
      stopOpacity: 1
    },
    offset: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#eaebec",
      stopOpacity: 1
    },
    offset: 0.753906
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ececed",
      stopOpacity: 1
    },
    offset: 0.757813
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#edeeee",
      stopOpacity: 1
    },
    offset: 0.761719
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#efeff0",
      stopOpacity: 1
    },
    offset: 0.765625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f0f0f1",
      stopOpacity: 1
    },
    offset: 0.769531
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f1f2f2",
      stopOpacity: 1
    },
    offset: 0.773438
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f3f3f3",
      stopOpacity: 1
    },
    offset: 0.777344
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f4f4f5",
      stopOpacity: 1
    },
    offset: 0.78125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f5f6f6",
      stopOpacity: 1
    },
    offset: 0.785156
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f7f7f7",
      stopOpacity: 1
    },
    offset: 0.789063
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f8f8f9",
      stopOpacity: 1
    },
    offset: 0.792969
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fafafa",
      stopOpacity: 1
    },
    offset: 0.796875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fbfbfb",
      stopOpacity: 1
    },
    offset: 0.800781
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fcfdfd",
      stopOpacity: 1
    },
    offset: 0.804688
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fdfefe",
      stopOpacity: 1
    },
    offset: 0.808594
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ffffff",
      stopOpacity: 1
    },
    offset: 0.8125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fcfcfc",
      stopOpacity: 1
    },
    offset: 0.816406
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f9f9f9",
      stopOpacity: 1
    },
    offset: 0.820312
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f7f7f7",
      stopOpacity: 1
    },
    offset: 0.824219
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f4f4f4",
      stopOpacity: 1
    },
    offset: 0.828125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f1f1f2",
      stopOpacity: 1
    },
    offset: 0.832031
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#efefef",
      stopOpacity: 1
    },
    offset: 0.835937
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ececec",
      stopOpacity: 1
    },
    offset: 0.839844
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e9e9ea",
      stopOpacity: 1
    },
    offset: 0.84375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e7e7e7",
      stopOpacity: 1
    },
    offset: 0.847656
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e4e4e5",
      stopOpacity: 1
    },
    offset: 0.851562
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e1e2e2",
      stopOpacity: 1
    },
    offset: 0.855469
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#dfdfdf",
      stopOpacity: 1
    },
    offset: 0.859375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#dcdcdd",
      stopOpacity: 1
    },
    offset: 0.863281
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d9dada",
      stopOpacity: 1
    },
    offset: 0.867188
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d7d7d8",
      stopOpacity: 1
    },
    offset: 0.871094
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d4d4d5",
      stopOpacity: 1
    },
    offset: 0.875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d1d2d2",
      stopOpacity: 1
    },
    offset: 0.878906
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#cfcfd0",
      stopOpacity: 1
    },
    offset: 0.882812
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#cccccd",
      stopOpacity: 1
    },
    offset: 0.886719
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c9cacb",
      stopOpacity: 1
    },
    offset: 0.890625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c7c7c8",
      stopOpacity: 1
    },
    offset: 0.894531
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c4c5c6",
      stopOpacity: 1
    },
    offset: 0.898438
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c1c2c3",
      stopOpacity: 1
    },
    offset: 0.902344
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#bfbfc0",
      stopOpacity: 1
    },
    offset: 0.90625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#bcbdbe",
      stopOpacity: 1
    },
    offset: 0.910156
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#b9babb",
      stopOpacity: 1
    },
    offset: 0.914063
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#b7b7b9",
      stopOpacity: 1
    },
    offset: 0.917969
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#b4b5b6",
      stopOpacity: 1
    },
    offset: 0.921875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#b1b2b3",
      stopOpacity: 1
    },
    offset: 0.925781
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#afafb1",
      stopOpacity: 1
    },
    offset: 0.929688
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#acadae",
      stopOpacity: 1
    },
    offset: 0.933594
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#aaaaac",
      stopOpacity: 1
    },
    offset: 0.9375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#a7a8a9",
      stopOpacity: 1
    },
    offset: 0.941406
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#a4a5a6",
      stopOpacity: 1
    },
    offset: 0.945313
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#a2a2a4",
      stopOpacity: 1
    },
    offset: 0.949219
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#9fa0a1",
      stopOpacity: 1
    },
    offset: 0.953125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#9c9d9f",
      stopOpacity: 1
    },
    offset: 0.957031
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#9a9a9c",
      stopOpacity: 1
    },
    offset: 0.960938
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#979899",
      stopOpacity: 1
    },
    offset: 0.964844
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#949597",
      stopOpacity: 1
    },
    offset: 0.96875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#929294",
      stopOpacity: 1
    },
    offset: 0.972656
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#8f9092",
      stopOpacity: 1
    },
    offset: 0.976563
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#8c8d8f",
      stopOpacity: 1
    },
    offset: 0.980469
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#8a8b8c",
      stopOpacity: 1
    },
    offset: 0.984375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#87888a",
      stopOpacity: 1
    },
    offset: 0.988281
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#848587",
      stopOpacity: 1
    },
    offset: 0.992188
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#828385",
      stopOpacity: 1
    },
    offset: 0.996094
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#808183",
      stopOpacity: 1
    },
    offset: 1
  })), _ref10, _ref11, /*#__PURE__*/React.createElement("linearGradient", {
    x1: 117.299975,
    gradientTransform: "matrix(1.529572,0,0,-1.5297,-0.090027,191.286603)",
    y1: 26.313,
    x2: 137.799997,
    gradientUnits: "userSpaceOnUse",
    y2: 26.313,
    id: "d7e46bac44"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#bcbdbf",
      stopOpacity: 1
    },
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#bdbec0",
      stopOpacity: 1
    },
    offset: 0.00390625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#bebfc1",
      stopOpacity: 1
    },
    offset: 0.0078125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#bfc0c1",
      stopOpacity: 1
    },
    offset: 0.0117188
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#bfc0c2",
      stopOpacity: 1
    },
    offset: 0.015625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c0c1c3",
      stopOpacity: 1
    },
    offset: 0.0195312
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c1c2c4",
      stopOpacity: 1
    },
    offset: 0.0234375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c2c3c5",
      stopOpacity: 1
    },
    offset: 0.0273437
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c3c4c6",
      stopOpacity: 1
    },
    offset: 0.03125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c4c5c6",
      stopOpacity: 1
    },
    offset: 0.0351563
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c5c5c7",
      stopOpacity: 1
    },
    offset: 0.0390625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c5c6c8",
      stopOpacity: 1
    },
    offset: 0.0429688
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c6c7c9",
      stopOpacity: 1
    },
    offset: 0.046875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c7c8ca",
      stopOpacity: 1
    },
    offset: 0.0507812
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c8c9ca",
      stopOpacity: 1
    },
    offset: 0.0546875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c9cacb",
      stopOpacity: 1
    },
    offset: 0.0585938
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#cacbcc",
      stopOpacity: 1
    },
    offset: 0.0625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#cbcbcd",
      stopOpacity: 1
    },
    offset: 0.0664063
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#cbccce",
      stopOpacity: 1
    },
    offset: 0.0703125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#cccdcf",
      stopOpacity: 1
    },
    offset: 0.0742188
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#cdcecf",
      stopOpacity: 1
    },
    offset: 0.078125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#cecfd0",
      stopOpacity: 1
    },
    offset: 0.0820312
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#cfd0d1",
      stopOpacity: 1
    },
    offset: 0.0859375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d0d0d2",
      stopOpacity: 1
    },
    offset: 0.0898438
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d1d1d3",
      stopOpacity: 1
    },
    offset: 0.09375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d1d2d3",
      stopOpacity: 1
    },
    offset: 0.0976563
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d2d3d4",
      stopOpacity: 1
    },
    offset: 0.101563
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d3d4d5",
      stopOpacity: 1
    },
    offset: 0.105469
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d4d5d6",
      stopOpacity: 1
    },
    offset: 0.109375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d5d6d7",
      stopOpacity: 1
    },
    offset: 0.113281
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d6d6d8",
      stopOpacity: 1
    },
    offset: 0.117188
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d7d7d8",
      stopOpacity: 1
    },
    offset: 0.121094
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d7d8d9",
      stopOpacity: 1
    },
    offset: 0.125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d8d9da",
      stopOpacity: 1
    },
    offset: 0.128906
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d9dadb",
      stopOpacity: 1
    },
    offset: 0.132812
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#dadbdc",
      stopOpacity: 1
    },
    offset: 0.136719
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#dbdbdd",
      stopOpacity: 1
    },
    offset: 0.140625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#dcdcdd",
      stopOpacity: 1
    },
    offset: 0.144531
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ddddde",
      stopOpacity: 1
    },
    offset: 0.148437
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#dddedf",
      stopOpacity: 1
    },
    offset: 0.152344
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#dedfe0",
      stopOpacity: 1
    },
    offset: 0.15625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#dfe0e1",
      stopOpacity: 1
    },
    offset: 0.160156
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e0e0e1",
      stopOpacity: 1
    },
    offset: 0.164062
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e1e1e2",
      stopOpacity: 1
    },
    offset: 0.167969
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e2e2e3",
      stopOpacity: 1
    },
    offset: 0.171875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e3e3e4",
      stopOpacity: 1
    },
    offset: 0.175781
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e3e4e5",
      stopOpacity: 1
    },
    offset: 0.179688
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e4e5e6",
      stopOpacity: 1
    },
    offset: 0.183594
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e5e6e6",
      stopOpacity: 1
    },
    offset: 0.1875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e6e6e7",
      stopOpacity: 1
    },
    offset: 0.191406
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e7e7e8",
      stopOpacity: 1
    },
    offset: 0.195312
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e8e8e9",
      stopOpacity: 1
    },
    offset: 0.199219
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e9e9ea",
      stopOpacity: 1
    },
    offset: 0.203125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e9eaea",
      stopOpacity: 1
    },
    offset: 0.207031
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#eaebeb",
      stopOpacity: 1
    },
    offset: 0.210937
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ebebec",
      stopOpacity: 1
    },
    offset: 0.214844
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ececed",
      stopOpacity: 1
    },
    offset: 0.21875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ededee",
      stopOpacity: 1
    },
    offset: 0.222656
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#eeeeef",
      stopOpacity: 1
    },
    offset: 0.226562
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#efefef",
      stopOpacity: 1
    },
    offset: 0.230469
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#eff0f0",
      stopOpacity: 1
    },
    offset: 0.234375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f0f1f1",
      stopOpacity: 1
    },
    offset: 0.238281
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f1f1f2",
      stopOpacity: 1
    },
    offset: 0.242187
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f2f2f3",
      stopOpacity: 1
    },
    offset: 0.246094
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f3f3f3",
      stopOpacity: 1
    },
    offset: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f4f4f4",
      stopOpacity: 1
    },
    offset: 0.253906
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f5f5f5",
      stopOpacity: 1
    },
    offset: 0.257812
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f5f6f6",
      stopOpacity: 1
    },
    offset: 0.261719
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f6f6f7",
      stopOpacity: 1
    },
    offset: 0.265625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f7f7f8",
      stopOpacity: 1
    },
    offset: 0.269531
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f8f8f8",
      stopOpacity: 1
    },
    offset: 0.273437
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f9f9f9",
      stopOpacity: 1
    },
    offset: 0.277344
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fafafa",
      stopOpacity: 1
    },
    offset: 0.28125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fbfbfb",
      stopOpacity: 1
    },
    offset: 0.285156
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fbfbfc",
      stopOpacity: 1
    },
    offset: 0.289062
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fcfcfc",
      stopOpacity: 1
    },
    offset: 0.292969
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fdfdfd",
      stopOpacity: 1
    },
    offset: 0.296875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fefefe",
      stopOpacity: 1
    },
    offset: 0.300781
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ffffff",
      stopOpacity: 1
    },
    offset: 0.304688
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ffffff",
      stopOpacity: 1
    },
    offset: 0.3125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ffffff",
      stopOpacity: 1
    },
    offset: 0.375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ffffff",
      stopOpacity: 1
    },
    offset: 0.4375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ffffff",
      stopOpacity: 1
    },
    offset: 0.46875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ffffff",
      stopOpacity: 1
    },
    offset: 0.484375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fefefe",
      stopOpacity: 1
    },
    offset: 0.488281
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fcfcfd",
      stopOpacity: 1
    },
    offset: 0.492187
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fafbfb",
      stopOpacity: 1
    },
    offset: 0.496094
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f8f9f9",
      stopOpacity: 1
    },
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f6f7f7",
      stopOpacity: 1
    },
    offset: 0.503906
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f4f5f5",
      stopOpacity: 1
    },
    offset: 0.507812
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f3f3f3",
      stopOpacity: 1
    },
    offset: 0.511719
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f1f1f1",
      stopOpacity: 1
    },
    offset: 0.515625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#efeff0",
      stopOpacity: 1
    },
    offset: 0.519531
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ededee",
      stopOpacity: 1
    },
    offset: 0.523438
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ebebec",
      stopOpacity: 1
    },
    offset: 0.527344
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e9e9ea",
      stopOpacity: 1
    },
    offset: 0.53125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e7e7e8",
      stopOpacity: 1
    },
    offset: 0.535156
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e5e5e6",
      stopOpacity: 1
    },
    offset: 0.539062
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e3e4e4",
      stopOpacity: 1
    },
    offset: 0.542969
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e1e2e3",
      stopOpacity: 1
    },
    offset: 0.546875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#dfe0e1",
      stopOpacity: 1
    },
    offset: 0.550781
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#dddedf",
      stopOpacity: 1
    },
    offset: 0.554688
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#dbdcdd",
      stopOpacity: 1
    },
    offset: 0.558594
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d9dadb",
      stopOpacity: 1
    },
    offset: 0.5625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d7d8d9",
      stopOpacity: 1
    },
    offset: 0.566406
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d5d6d7",
      stopOpacity: 1
    },
    offset: 0.570312
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d3d4d6",
      stopOpacity: 1
    },
    offset: 0.574219
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d1d2d4",
      stopOpacity: 1
    },
    offset: 0.578125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#cfd0d2",
      stopOpacity: 1
    },
    offset: 0.582031
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#cdced0",
      stopOpacity: 1
    },
    offset: 0.585938
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#cbcdce",
      stopOpacity: 1
    },
    offset: 0.589844
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c9cbcc",
      stopOpacity: 1
    },
    offset: 0.59375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c7c9ca",
      stopOpacity: 1
    },
    offset: 0.597656
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c5c7c9",
      stopOpacity: 1
    },
    offset: 0.601562
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c3c5c7",
      stopOpacity: 1
    },
    offset: 0.605469
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c1c3c5",
      stopOpacity: 1
    },
    offset: 0.609375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#bfc1c3",
      stopOpacity: 1
    },
    offset: 0.613281
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#bdbfc1",
      stopOpacity: 1
    },
    offset: 0.617188
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#bdbfc1",
      stopOpacity: 1
    },
    offset: 0.621094
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#bcbec0",
      stopOpacity: 1
    },
    offset: 0.625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#bebfc1",
      stopOpacity: 1
    },
    offset: 0.628906
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#bfc1c3",
      stopOpacity: 1
    },
    offset: 0.632812
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c0c2c4",
      stopOpacity: 1
    },
    offset: 0.636719
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c2c4c5",
      stopOpacity: 1
    },
    offset: 0.640625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c3c5c7",
      stopOpacity: 1
    },
    offset: 0.644531
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c4c6c8",
      stopOpacity: 1
    },
    offset: 0.648438
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c6c8c9",
      stopOpacity: 1
    },
    offset: 0.652344
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c7c9cb",
      stopOpacity: 1
    },
    offset: 0.65625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c9cacc",
      stopOpacity: 1
    },
    offset: 0.660156
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#cacccd",
      stopOpacity: 1
    },
    offset: 0.664062
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#cbcdcf",
      stopOpacity: 1
    },
    offset: 0.667969
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#cdced0",
      stopOpacity: 1
    },
    offset: 0.671875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ced0d1",
      stopOpacity: 1
    },
    offset: 0.675781
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d0d1d2",
      stopOpacity: 1
    },
    offset: 0.679688
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d1d2d4",
      stopOpacity: 1
    },
    offset: 0.683594
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d2d4d5",
      stopOpacity: 1
    },
    offset: 0.6875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d4d5d6",
      stopOpacity: 1
    },
    offset: 0.691406
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d5d6d8",
      stopOpacity: 1
    },
    offset: 0.695312
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d7d8d9",
      stopOpacity: 1
    },
    offset: 0.699219
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d8d9da",
      stopOpacity: 1
    },
    offset: 0.703125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d9dbdc",
      stopOpacity: 1
    },
    offset: 0.707031
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#dbdcdd",
      stopOpacity: 1
    },
    offset: 0.710938
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#dcddde",
      stopOpacity: 1
    },
    offset: 0.714844
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#dedfe0",
      stopOpacity: 1
    },
    offset: 0.71875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#dfe0e1",
      stopOpacity: 1
    },
    offset: 0.722656
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e0e1e2",
      stopOpacity: 1
    },
    offset: 0.726562
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e2e3e4",
      stopOpacity: 1
    },
    offset: 0.730469
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e3e4e5",
      stopOpacity: 1
    },
    offset: 0.734375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e5e5e6",
      stopOpacity: 1
    },
    offset: 0.738281
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e6e7e7",
      stopOpacity: 1
    },
    offset: 0.742188
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e7e8e9",
      stopOpacity: 1
    },
    offset: 0.746094
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e9e9ea",
      stopOpacity: 1
    },
    offset: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#eaebeb",
      stopOpacity: 1
    },
    offset: 0.753906
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ececed",
      stopOpacity: 1
    },
    offset: 0.757812
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ededee",
      stopOpacity: 1
    },
    offset: 0.761719
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#eeefef",
      stopOpacity: 1
    },
    offset: 0.765625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f0f0f1",
      stopOpacity: 1
    },
    offset: 0.769531
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f1f2f2",
      stopOpacity: 1
    },
    offset: 0.773438
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f2f3f3",
      stopOpacity: 1
    },
    offset: 0.777344
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f4f4f5",
      stopOpacity: 1
    },
    offset: 0.78125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f5f6f6",
      stopOpacity: 1
    },
    offset: 0.785156
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f7f7f7",
      stopOpacity: 1
    },
    offset: 0.789062
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f8f8f8",
      stopOpacity: 1
    },
    offset: 0.792969
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f9fafa",
      stopOpacity: 1
    },
    offset: 0.796875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fbfbfb",
      stopOpacity: 1
    },
    offset: 0.800781
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fcfcfc",
      stopOpacity: 1
    },
    offset: 0.804687
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fefefe",
      stopOpacity: 1
    },
    offset: 0.808594
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ffffff",
      stopOpacity: 1
    },
    offset: 0.8125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fcfcfc",
      stopOpacity: 1
    },
    offset: 0.816406
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fafafa",
      stopOpacity: 1
    },
    offset: 0.820312
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f7f7f7",
      stopOpacity: 1
    },
    offset: 0.824219
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f4f4f5",
      stopOpacity: 1
    },
    offset: 0.828125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f2f2f2",
      stopOpacity: 1
    },
    offset: 0.832031
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#efefef",
      stopOpacity: 1
    },
    offset: 0.835937
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#eceded",
      stopOpacity: 1
    },
    offset: 0.839844
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#eaeaea",
      stopOpacity: 1
    },
    offset: 0.84375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e7e7e8",
      stopOpacity: 1
    },
    offset: 0.847656
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e4e5e5",
      stopOpacity: 1
    },
    offset: 0.851562
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e2e2e2",
      stopOpacity: 1
    },
    offset: 0.855469
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#dfdfe0",
      stopOpacity: 1
    },
    offset: 0.859375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#dcdddd",
      stopOpacity: 1
    },
    offset: 0.863281
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#dadadb",
      stopOpacity: 1
    },
    offset: 0.867188
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d7d7d8",
      stopOpacity: 1
    },
    offset: 0.871094
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d4d5d5",
      stopOpacity: 1
    },
    offset: 0.875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d2d2d3",
      stopOpacity: 1
    },
    offset: 0.878906
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#cfd0d0",
      stopOpacity: 1
    },
    offset: 0.882812
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#cccdce",
      stopOpacity: 1
    },
    offset: 0.886719
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#cacacb",
      stopOpacity: 1
    },
    offset: 0.890625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c7c8c9",
      stopOpacity: 1
    },
    offset: 0.894531
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c5c5c6",
      stopOpacity: 1
    },
    offset: 0.898438
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c2c2c3",
      stopOpacity: 1
    },
    offset: 0.902344
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#bfc0c1",
      stopOpacity: 1
    },
    offset: 0.90625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#bdbdbe",
      stopOpacity: 1
    },
    offset: 0.910156
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#bababc",
      stopOpacity: 1
    },
    offset: 0.914062
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#b7b8b9",
      stopOpacity: 1
    },
    offset: 0.917969
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#b5b5b6",
      stopOpacity: 1
    },
    offset: 0.921875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#b2b3b4",
      stopOpacity: 1
    },
    offset: 0.925781
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#afb0b1",
      stopOpacity: 1
    },
    offset: 0.929688
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#adadaf",
      stopOpacity: 1
    },
    offset: 0.933594
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#aaabac",
      stopOpacity: 1
    },
    offset: 0.9375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#a7a8a9",
      stopOpacity: 1
    },
    offset: 0.941406
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#a5a5a7",
      stopOpacity: 1
    },
    offset: 0.945312
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#a2a3a4",
      stopOpacity: 1
    },
    offset: 0.949219
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#9fa0a2",
      stopOpacity: 1
    },
    offset: 0.953125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#9d9d9f",
      stopOpacity: 1
    },
    offset: 0.957031
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#9a9b9c",
      stopOpacity: 1
    },
    offset: 0.960938
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#97989a",
      stopOpacity: 1
    },
    offset: 0.964844
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#959697",
      stopOpacity: 1
    },
    offset: 0.96875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#929395",
      stopOpacity: 1
    },
    offset: 0.972656
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#8f9092",
      stopOpacity: 1
    },
    offset: 0.976562
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#8d8e90",
      stopOpacity: 1
    },
    offset: 0.980469
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#8a8b8d",
      stopOpacity: 1
    },
    offset: 0.984375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#87888a",
      stopOpacity: 1
    },
    offset: 0.988281
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#858688",
      stopOpacity: 1
    },
    offset: 0.992188
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#828385",
      stopOpacity: 1
    },
    offset: 0.996094
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#808183",
      stopOpacity: 1
    },
    offset: 1
  })), _ref12, _ref13, /*#__PURE__*/React.createElement("linearGradient", {
    x1: 137.6,
    gradientTransform: "matrix(1.529572,0,0,-1.5297,-0.090027,191.286603)",
    y1: 26.306999,
    x2: 164.799996,
    gradientUnits: "userSpaceOnUse",
    y2: 26.306999,
    id: "bc861fd656"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#bcbdbf",
      stopOpacity: 1
    },
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#bdbec0",
      stopOpacity: 1
    },
    offset: 0.00390625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#bdbec0",
      stopOpacity: 1
    },
    offset: 0.0078125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#bebfc1",
      stopOpacity: 1
    },
    offset: 0.0117187
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#bfc0c2",
      stopOpacity: 1
    },
    offset: 0.015625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c0c1c3",
      stopOpacity: 1
    },
    offset: 0.0195312
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c1c2c4",
      stopOpacity: 1
    },
    offset: 0.0234375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c2c3c4",
      stopOpacity: 1
    },
    offset: 0.0273438
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c3c3c5",
      stopOpacity: 1
    },
    offset: 0.03125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c3c4c6",
      stopOpacity: 1
    },
    offset: 0.0351562
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c4c5c7",
      stopOpacity: 1
    },
    offset: 0.0390625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c5c6c8",
      stopOpacity: 1
    },
    offset: 0.0429688
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c6c7c9",
      stopOpacity: 1
    },
    offset: 0.046875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c7c8c9",
      stopOpacity: 1
    },
    offset: 0.0507813
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c8c8ca",
      stopOpacity: 1
    },
    offset: 0.0546875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c9c9cb",
      stopOpacity: 1
    },
    offset: 0.0585938
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c9cacc",
      stopOpacity: 1
    },
    offset: 0.0625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#cacbcd",
      stopOpacity: 1
    },
    offset: 0.0664062
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#cbcccd",
      stopOpacity: 1
    },
    offset: 0.0703125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#cccdce",
      stopOpacity: 1
    },
    offset: 0.0742187
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#cdcecf",
      stopOpacity: 1
    },
    offset: 0.078125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ceced0",
      stopOpacity: 1
    },
    offset: 0.0820312
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#cfcfd1",
      stopOpacity: 1
    },
    offset: 0.0859375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#cfd0d2",
      stopOpacity: 1
    },
    offset: 0.0898437
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d0d1d2",
      stopOpacity: 1
    },
    offset: 0.09375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d1d2d3",
      stopOpacity: 1
    },
    offset: 0.0976562
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d2d3d4",
      stopOpacity: 1
    },
    offset: 0.101562
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d3d3d5",
      stopOpacity: 1
    },
    offset: 0.105469
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d4d4d6",
      stopOpacity: 1
    },
    offset: 0.109375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d4d5d6",
      stopOpacity: 1
    },
    offset: 0.113281
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d5d6d7",
      stopOpacity: 1
    },
    offset: 0.117187
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d6d7d8",
      stopOpacity: 1
    },
    offset: 0.121094
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d7d8d9",
      stopOpacity: 1
    },
    offset: 0.125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d8d9da",
      stopOpacity: 1
    },
    offset: 0.128906
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d9d9da",
      stopOpacity: 1
    },
    offset: 0.132812
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#dadadb",
      stopOpacity: 1
    },
    offset: 0.136719
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#dadbdc",
      stopOpacity: 1
    },
    offset: 0.140625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#dbdcdd",
      stopOpacity: 1
    },
    offset: 0.144531
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#dcddde",
      stopOpacity: 1
    },
    offset: 0.148438
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#dddedf",
      stopOpacity: 1
    },
    offset: 0.152344
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#dededf",
      stopOpacity: 1
    },
    offset: 0.15625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#dfdfe0",
      stopOpacity: 1
    },
    offset: 0.160156
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e0e0e1",
      stopOpacity: 1
    },
    offset: 0.164062
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e0e1e2",
      stopOpacity: 1
    },
    offset: 0.167969
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e1e2e3",
      stopOpacity: 1
    },
    offset: 0.171875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e2e3e3",
      stopOpacity: 1
    },
    offset: 0.175781
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e3e3e4",
      stopOpacity: 1
    },
    offset: 0.179687
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e4e4e5",
      stopOpacity: 1
    },
    offset: 0.183594
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e5e5e6",
      stopOpacity: 1
    },
    offset: 0.1875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e6e6e7",
      stopOpacity: 1
    },
    offset: 0.191406
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e6e7e8",
      stopOpacity: 1
    },
    offset: 0.195312
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e7e8e8",
      stopOpacity: 1
    },
    offset: 0.199219
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e8e9e9",
      stopOpacity: 1
    },
    offset: 0.203125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e9e9ea",
      stopOpacity: 1
    },
    offset: 0.207031
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#eaeaeb",
      stopOpacity: 1
    },
    offset: 0.210938
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ebebec",
      stopOpacity: 1
    },
    offset: 0.214844
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ececec",
      stopOpacity: 1
    },
    offset: 0.21875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#eceded",
      stopOpacity: 1
    },
    offset: 0.222656
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#edeeee",
      stopOpacity: 1
    },
    offset: 0.226562
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#eeeeef",
      stopOpacity: 1
    },
    offset: 0.230469
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#efeff0",
      stopOpacity: 1
    },
    offset: 0.234375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f0f0f1",
      stopOpacity: 1
    },
    offset: 0.238281
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f1f1f1",
      stopOpacity: 1
    },
    offset: 0.242188
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f2f2f2",
      stopOpacity: 1
    },
    offset: 0.246094
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f2f3f3",
      stopOpacity: 1
    },
    offset: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f3f3f4",
      stopOpacity: 1
    },
    offset: 0.253906
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f4f4f5",
      stopOpacity: 1
    },
    offset: 0.257813
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f5f5f5",
      stopOpacity: 1
    },
    offset: 0.261719
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f6f6f6",
      stopOpacity: 1
    },
    offset: 0.265625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f7f7f7",
      stopOpacity: 1
    },
    offset: 0.269531
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f8f8f8",
      stopOpacity: 1
    },
    offset: 0.273438
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f8f9f9",
      stopOpacity: 1
    },
    offset: 0.277344
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f9f9fa",
      stopOpacity: 1
    },
    offset: 0.28125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fafafa",
      stopOpacity: 1
    },
    offset: 0.285156
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fbfbfb",
      stopOpacity: 1
    },
    offset: 0.289063
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fcfcfc",
      stopOpacity: 1
    },
    offset: 0.292969
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fdfdfd",
      stopOpacity: 1
    },
    offset: 0.296875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fefefe",
      stopOpacity: 1
    },
    offset: 0.300781
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fefefe",
      stopOpacity: 1
    },
    offset: 0.304688
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ffffff",
      stopOpacity: 1
    },
    offset: 0.3125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ffffff",
      stopOpacity: 1
    },
    offset: 0.375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ffffff",
      stopOpacity: 1
    },
    offset: 0.4375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ffffff",
      stopOpacity: 1
    },
    offset: 0.46875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ffffff",
      stopOpacity: 1
    },
    offset: 0.484375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fefefe",
      stopOpacity: 1
    },
    offset: 0.488281
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fefefe",
      stopOpacity: 1
    },
    offset: 0.492188
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fcfcfc",
      stopOpacity: 1
    },
    offset: 0.496094
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fafafa",
      stopOpacity: 1
    },
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f8f8f8",
      stopOpacity: 1
    },
    offset: 0.503906
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f6f6f6",
      stopOpacity: 1
    },
    offset: 0.507812
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f4f4f4",
      stopOpacity: 1
    },
    offset: 0.511719
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f2f2f2",
      stopOpacity: 1
    },
    offset: 0.515625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f0f0f1",
      stopOpacity: 1
    },
    offset: 0.519531
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#eeeeef",
      stopOpacity: 1
    },
    offset: 0.523438
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ececed",
      stopOpacity: 1
    },
    offset: 0.527344
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#eaeaeb",
      stopOpacity: 1
    },
    offset: 0.53125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e8e9e9",
      stopOpacity: 1
    },
    offset: 0.535156
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e6e7e7",
      stopOpacity: 1
    },
    offset: 0.539063
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e4e5e5",
      stopOpacity: 1
    },
    offset: 0.542969
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e2e3e4",
      stopOpacity: 1
    },
    offset: 0.546875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e0e1e2",
      stopOpacity: 1
    },
    offset: 0.550781
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#dedfe0",
      stopOpacity: 1
    },
    offset: 0.554688
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#dcddde",
      stopOpacity: 1
    },
    offset: 0.558594
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#dadbdc",
      stopOpacity: 1
    },
    offset: 0.5625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d8d9da",
      stopOpacity: 1
    },
    offset: 0.566406
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d6d7d9",
      stopOpacity: 1
    },
    offset: 0.570313
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d4d5d7",
      stopOpacity: 1
    },
    offset: 0.574219
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d2d3d5",
      stopOpacity: 1
    },
    offset: 0.578125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d0d2d3",
      stopOpacity: 1
    },
    offset: 0.582031
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ced0d1",
      stopOpacity: 1
    },
    offset: 0.585938
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#cccecf",
      stopOpacity: 1
    },
    offset: 0.589844
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#cacccd",
      stopOpacity: 1
    },
    offset: 0.59375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c8cacc",
      stopOpacity: 1
    },
    offset: 0.597656
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c6c8ca",
      stopOpacity: 1
    },
    offset: 0.601563
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c4c6c8",
      stopOpacity: 1
    },
    offset: 0.605469
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c2c4c6",
      stopOpacity: 1
    },
    offset: 0.609375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c0c2c4",
      stopOpacity: 1
    },
    offset: 0.613281
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#bec0c2",
      stopOpacity: 1
    },
    offset: 0.617188
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#bdbfc1",
      stopOpacity: 1
    },
    offset: 0.621094
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#bbbdbf",
      stopOpacity: 1
    },
    offset: 0.625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#bdbfc1",
      stopOpacity: 1
    },
    offset: 0.628906
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#bec0c2",
      stopOpacity: 1
    },
    offset: 0.632813
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#bfc1c3",
      stopOpacity: 1
    },
    offset: 0.636719
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c1c3c5",
      stopOpacity: 1
    },
    offset: 0.640625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c2c4c6",
      stopOpacity: 1
    },
    offset: 0.644531
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c4c5c7",
      stopOpacity: 1
    },
    offset: 0.648438
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c5c7c8",
      stopOpacity: 1
    },
    offset: 0.652344
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c6c8ca",
      stopOpacity: 1
    },
    offset: 0.65625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c8c9cb",
      stopOpacity: 1
    },
    offset: 0.660156
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c9cbcc",
      stopOpacity: 1
    },
    offset: 0.664062
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#cbccce",
      stopOpacity: 1
    },
    offset: 0.667969
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#cccdcf",
      stopOpacity: 1
    },
    offset: 0.671875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#cdcfd0",
      stopOpacity: 1
    },
    offset: 0.675781
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#cfd0d2",
      stopOpacity: 1
    },
    offset: 0.679688
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d0d2d3",
      stopOpacity: 1
    },
    offset: 0.683594
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d2d3d4",
      stopOpacity: 1
    },
    offset: 0.6875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d3d4d6",
      stopOpacity: 1
    },
    offset: 0.691406
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d4d6d7",
      stopOpacity: 1
    },
    offset: 0.695312
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d6d7d8",
      stopOpacity: 1
    },
    offset: 0.699219
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d7d8d9",
      stopOpacity: 1
    },
    offset: 0.703125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d8dadb",
      stopOpacity: 1
    },
    offset: 0.707031
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#dadbdc",
      stopOpacity: 1
    },
    offset: 0.710938
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#dbdcdd",
      stopOpacity: 1
    },
    offset: 0.714844
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#dddedf",
      stopOpacity: 1
    },
    offset: 0.71875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#dedfe0",
      stopOpacity: 1
    },
    offset: 0.722656
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#dfe0e1",
      stopOpacity: 1
    },
    offset: 0.726562
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e1e2e3",
      stopOpacity: 1
    },
    offset: 0.730469
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e2e3e4",
      stopOpacity: 1
    },
    offset: 0.734375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e4e4e5",
      stopOpacity: 1
    },
    offset: 0.738281
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e5e6e7",
      stopOpacity: 1
    },
    offset: 0.742188
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e6e7e8",
      stopOpacity: 1
    },
    offset: 0.746094
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e8e8e9",
      stopOpacity: 1
    },
    offset: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e9eaeb",
      stopOpacity: 1
    },
    offset: 0.753906
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ebebec",
      stopOpacity: 1
    },
    offset: 0.757812
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#eceded",
      stopOpacity: 1
    },
    offset: 0.761719
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#edeeee",
      stopOpacity: 1
    },
    offset: 0.765625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#efeff0",
      stopOpacity: 1
    },
    offset: 0.769531
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f0f1f1",
      stopOpacity: 1
    },
    offset: 0.773438
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f2f2f2",
      stopOpacity: 1
    },
    offset: 0.777344
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f3f3f4",
      stopOpacity: 1
    },
    offset: 0.78125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f4f5f5",
      stopOpacity: 1
    },
    offset: 0.785156
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f6f6f6",
      stopOpacity: 1
    },
    offset: 0.789062
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f7f7f8",
      stopOpacity: 1
    },
    offset: 0.792969
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f9f9f9",
      stopOpacity: 1
    },
    offset: 0.796875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fafafa",
      stopOpacity: 1
    },
    offset: 0.800781
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fbfbfc",
      stopOpacity: 1
    },
    offset: 0.804688
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fdfdfd",
      stopOpacity: 1
    },
    offset: 0.808594
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fefefe",
      stopOpacity: 1
    },
    offset: 0.8125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fdfdfd",
      stopOpacity: 1
    },
    offset: 0.816406
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fbfbfc",
      stopOpacity: 1
    },
    offset: 0.820312
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f9f9f9",
      stopOpacity: 1
    },
    offset: 0.824219
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f6f6f6",
      stopOpacity: 1
    },
    offset: 0.828125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f3f4f4",
      stopOpacity: 1
    },
    offset: 0.832031
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f1f1f1",
      stopOpacity: 1
    },
    offset: 0.835938
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#eeeeef",
      stopOpacity: 1
    },
    offset: 0.839844
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ececec",
      stopOpacity: 1
    },
    offset: 0.84375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e9e9e9",
      stopOpacity: 1
    },
    offset: 0.847656
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e6e6e7",
      stopOpacity: 1
    },
    offset: 0.851562
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e4e4e4",
      stopOpacity: 1
    },
    offset: 0.855469
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e1e1e2",
      stopOpacity: 1
    },
    offset: 0.859375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#dedfdf",
      stopOpacity: 1
    },
    offset: 0.863281
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#dcdcdc",
      stopOpacity: 1
    },
    offset: 0.867188
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d9d9da",
      stopOpacity: 1
    },
    offset: 0.871094
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d6d7d7",
      stopOpacity: 1
    },
    offset: 0.875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d4d4d5",
      stopOpacity: 1
    },
    offset: 0.878906
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d1d1d2",
      stopOpacity: 1
    },
    offset: 0.882812
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#cecfd0",
      stopOpacity: 1
    },
    offset: 0.886719
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#cccccd",
      stopOpacity: 1
    },
    offset: 0.890625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c9c9ca",
      stopOpacity: 1
    },
    offset: 0.894531
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c6c7c8",
      stopOpacity: 1
    },
    offset: 0.898438
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c4c4c5",
      stopOpacity: 1
    },
    offset: 0.902344
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c1c2c3",
      stopOpacity: 1
    },
    offset: 0.90625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#bebfc0",
      stopOpacity: 1
    },
    offset: 0.910156
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#bcbcbd",
      stopOpacity: 1
    },
    offset: 0.914062
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#b9babb",
      stopOpacity: 1
    },
    offset: 0.917969
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#b6b7b8",
      stopOpacity: 1
    },
    offset: 0.921875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#b4b4b6",
      stopOpacity: 1
    },
    offset: 0.925781
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#b1b2b3",
      stopOpacity: 1
    },
    offset: 0.929688
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#afafb0",
      stopOpacity: 1
    },
    offset: 0.933594
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#acadae",
      stopOpacity: 1
    },
    offset: 0.9375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#a9aaab",
      stopOpacity: 1
    },
    offset: 0.941406
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#a7a7a9",
      stopOpacity: 1
    },
    offset: 0.945312
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#a4a5a6",
      stopOpacity: 1
    },
    offset: 0.949219
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#a1a2a4",
      stopOpacity: 1
    },
    offset: 0.953125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#9f9fa1",
      stopOpacity: 1
    },
    offset: 0.957031
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#9c9d9e",
      stopOpacity: 1
    },
    offset: 0.960937
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#999a9c",
      stopOpacity: 1
    },
    offset: 0.964844
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#979899",
      stopOpacity: 1
    },
    offset: 0.96875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#949597",
      stopOpacity: 1
    },
    offset: 0.972656
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#919294",
      stopOpacity: 1
    },
    offset: 0.976562
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#8f9091",
      stopOpacity: 1
    },
    offset: 0.980469
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#8c8d8f",
      stopOpacity: 1
    },
    offset: 0.984375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#898a8c",
      stopOpacity: 1
    },
    offset: 0.988281
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#87888a",
      stopOpacity: 1
    },
    offset: 0.992188
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#848587",
      stopOpacity: 1
    },
    offset: 0.996094
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#818284",
      stopOpacity: 1
    },
    offset: 1
  })), _ref14, _ref15, /*#__PURE__*/React.createElement("linearGradient", {
    x1: 166.19999,
    gradientTransform: "matrix(1.529572,0,0,-1.5297,-0.090027,191.286603)",
    y1: 26.278,
    x2: 196.200002,
    gradientUnits: "userSpaceOnUse",
    y2: 26.278,
    id: "0e31cab358"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#bbbcbe",
      stopOpacity: 1
    },
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#bcbdbf",
      stopOpacity: 1
    },
    offset: 0.00390625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#bcbdbf",
      stopOpacity: 1
    },
    offset: 0.0078125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#bdbec0",
      stopOpacity: 1
    },
    offset: 0.0117187
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#bebfc1",
      stopOpacity: 1
    },
    offset: 0.015625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#bfc0c2",
      stopOpacity: 1
    },
    offset: 0.0195312
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c0c1c3",
      stopOpacity: 1
    },
    offset: 0.0234375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c1c2c4",
      stopOpacity: 1
    },
    offset: 0.0273437
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c2c3c4",
      stopOpacity: 1
    },
    offset: 0.03125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c3c3c5",
      stopOpacity: 1
    },
    offset: 0.0351562
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c3c4c6",
      stopOpacity: 1
    },
    offset: 0.0390625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c4c5c7",
      stopOpacity: 1
    },
    offset: 0.0429688
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c5c6c8",
      stopOpacity: 1
    },
    offset: 0.046875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c6c7c9",
      stopOpacity: 1
    },
    offset: 0.0507812
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c7c8c9",
      stopOpacity: 1
    },
    offset: 0.0546875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c8c9ca",
      stopOpacity: 1
    },
    offset: 0.0585938
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c9c9cb",
      stopOpacity: 1
    },
    offset: 0.0625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c9cacc",
      stopOpacity: 1
    },
    offset: 0.0664062
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#cacbcd",
      stopOpacity: 1
    },
    offset: 0.0703125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#cbcccd",
      stopOpacity: 1
    },
    offset: 0.0742188
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#cccdce",
      stopOpacity: 1
    },
    offset: 0.078125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#cdcecf",
      stopOpacity: 1
    },
    offset: 0.0820312
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ceced0",
      stopOpacity: 1
    },
    offset: 0.0859375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#cfcfd1",
      stopOpacity: 1
    },
    offset: 0.0898437
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#cfd0d2",
      stopOpacity: 1
    },
    offset: 0.09375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d0d1d2",
      stopOpacity: 1
    },
    offset: 0.0976562
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d1d2d3",
      stopOpacity: 1
    },
    offset: 0.101562
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d2d3d4",
      stopOpacity: 1
    },
    offset: 0.105469
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d3d4d5",
      stopOpacity: 1
    },
    offset: 0.109375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d4d4d6",
      stopOpacity: 1
    },
    offset: 0.113281
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d5d5d6",
      stopOpacity: 1
    },
    offset: 0.117187
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d5d6d7",
      stopOpacity: 1
    },
    offset: 0.121094
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d6d7d8",
      stopOpacity: 1
    },
    offset: 0.125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d7d8d9",
      stopOpacity: 1
    },
    offset: 0.128906
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d8d9da",
      stopOpacity: 1
    },
    offset: 0.132812
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d9d9db",
      stopOpacity: 1
    },
    offset: 0.136719
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#dadadb",
      stopOpacity: 1
    },
    offset: 0.140625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#dbdbdc",
      stopOpacity: 1
    },
    offset: 0.144531
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#dbdcdd",
      stopOpacity: 1
    },
    offset: 0.148438
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#dcddde",
      stopOpacity: 1
    },
    offset: 0.152344
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#dddedf",
      stopOpacity: 1
    },
    offset: 0.15625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#dedfe0",
      stopOpacity: 1
    },
    offset: 0.160156
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#dfdfe0",
      stopOpacity: 1
    },
    offset: 0.164062
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e0e0e1",
      stopOpacity: 1
    },
    offset: 0.167969
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e1e1e2",
      stopOpacity: 1
    },
    offset: 0.171875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e1e2e3",
      stopOpacity: 1
    },
    offset: 0.175781
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e2e3e4",
      stopOpacity: 1
    },
    offset: 0.179687
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e3e4e4",
      stopOpacity: 1
    },
    offset: 0.183594
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e4e4e5",
      stopOpacity: 1
    },
    offset: 0.1875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e5e5e6",
      stopOpacity: 1
    },
    offset: 0.191406
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e6e6e7",
      stopOpacity: 1
    },
    offset: 0.195312
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e7e7e8",
      stopOpacity: 1
    },
    offset: 0.199219
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e8e8e9",
      stopOpacity: 1
    },
    offset: 0.203125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e8e9e9",
      stopOpacity: 1
    },
    offset: 0.207031
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e9eaea",
      stopOpacity: 1
    },
    offset: 0.210938
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#eaeaeb",
      stopOpacity: 1
    },
    offset: 0.214844
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ebebec",
      stopOpacity: 1
    },
    offset: 0.21875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ececed",
      stopOpacity: 1
    },
    offset: 0.222656
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ededed",
      stopOpacity: 1
    },
    offset: 0.226562
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#eeeeee",
      stopOpacity: 1
    },
    offset: 0.230469
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#eeefef",
      stopOpacity: 1
    },
    offset: 0.234375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#efeff0",
      stopOpacity: 1
    },
    offset: 0.238281
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f0f0f1",
      stopOpacity: 1
    },
    offset: 0.242187
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f1f1f2",
      stopOpacity: 1
    },
    offset: 0.246094
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f2f2f2",
      stopOpacity: 1
    },
    offset: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f3f3f3",
      stopOpacity: 1
    },
    offset: 0.253906
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f4f4f4",
      stopOpacity: 1
    },
    offset: 0.257812
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f4f5f5",
      stopOpacity: 1
    },
    offset: 0.261719
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f5f5f6",
      stopOpacity: 1
    },
    offset: 0.265625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f6f6f7",
      stopOpacity: 1
    },
    offset: 0.269531
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f7f7f7",
      stopOpacity: 1
    },
    offset: 0.273438
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f8f8f8",
      stopOpacity: 1
    },
    offset: 0.277344
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f9f9f9",
      stopOpacity: 1
    },
    offset: 0.28125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fafafa",
      stopOpacity: 1
    },
    offset: 0.285156
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fafbfb",
      stopOpacity: 1
    },
    offset: 0.289062
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fbfbfb",
      stopOpacity: 1
    },
    offset: 0.292969
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fcfcfc",
      stopOpacity: 1
    },
    offset: 0.296875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fdfdfd",
      stopOpacity: 1
    },
    offset: 0.300781
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fefefe",
      stopOpacity: 1
    },
    offset: 0.304688
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fefefe",
      stopOpacity: 1
    },
    offset: 0.308594
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ffffff",
      stopOpacity: 1
    },
    offset: 0.3125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ffffff",
      stopOpacity: 1
    },
    offset: 0.375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ffffff",
      stopOpacity: 1
    },
    offset: 0.4375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ffffff",
      stopOpacity: 1
    },
    offset: 0.46875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ffffff",
      stopOpacity: 1
    },
    offset: 0.484375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ffffff",
      stopOpacity: 1
    },
    offset: 0.492187
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fcfcfd",
      stopOpacity: 1
    },
    offset: 0.496094
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fafbfb",
      stopOpacity: 1
    },
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f8f9f9",
      stopOpacity: 1
    },
    offset: 0.503906
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f6f7f7",
      stopOpacity: 1
    },
    offset: 0.507812
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f4f5f5",
      stopOpacity: 1
    },
    offset: 0.511719
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f2f3f3",
      stopOpacity: 1
    },
    offset: 0.515625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f0f1f1",
      stopOpacity: 1
    },
    offset: 0.519531
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#eeefef",
      stopOpacity: 1
    },
    offset: 0.523437
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ecedee",
      stopOpacity: 1
    },
    offset: 0.527344
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#eaebec",
      stopOpacity: 1
    },
    offset: 0.53125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e9e9ea",
      stopOpacity: 1
    },
    offset: 0.535156
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e7e7e8",
      stopOpacity: 1
    },
    offset: 0.539062
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e5e5e6",
      stopOpacity: 1
    },
    offset: 0.542969
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e3e3e4",
      stopOpacity: 1
    },
    offset: 0.546875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e1e1e2",
      stopOpacity: 1
    },
    offset: 0.550781
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#dfe0e1",
      stopOpacity: 1
    },
    offset: 0.554687
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#dddedf",
      stopOpacity: 1
    },
    offset: 0.558594
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#dbdcdd",
      stopOpacity: 1
    },
    offset: 0.5625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d9dadb",
      stopOpacity: 1
    },
    offset: 0.566406
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d7d8d9",
      stopOpacity: 1
    },
    offset: 0.570312
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d5d6d7",
      stopOpacity: 1
    },
    offset: 0.574219
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d3d4d5",
      stopOpacity: 1
    },
    offset: 0.578125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d1d2d3",
      stopOpacity: 1
    },
    offset: 0.582031
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#cfd0d2",
      stopOpacity: 1
    },
    offset: 0.585937
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#cdced0",
      stopOpacity: 1
    },
    offset: 0.589844
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#cbccce",
      stopOpacity: 1
    },
    offset: 0.59375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c9cacc",
      stopOpacity: 1
    },
    offset: 0.597656
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c7c8ca",
      stopOpacity: 1
    },
    offset: 0.601562
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c5c7c8",
      stopOpacity: 1
    },
    offset: 0.605469
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c3c5c6",
      stopOpacity: 1
    },
    offset: 0.609375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c1c3c5",
      stopOpacity: 1
    },
    offset: 0.613281
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#bfc1c3",
      stopOpacity: 1
    },
    offset: 0.617188
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#bdbfc1",
      stopOpacity: 1
    },
    offset: 0.621094
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#bbbdbf",
      stopOpacity: 1
    },
    offset: 0.625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#bcbec0",
      stopOpacity: 1
    },
    offset: 0.628906
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#bec0c2",
      stopOpacity: 1
    },
    offset: 0.632812
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#bfc1c3",
      stopOpacity: 1
    },
    offset: 0.636719
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c1c2c4",
      stopOpacity: 1
    },
    offset: 0.640625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c2c4c6",
      stopOpacity: 1
    },
    offset: 0.644531
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c3c5c7",
      stopOpacity: 1
    },
    offset: 0.648438
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c5c6c8",
      stopOpacity: 1
    },
    offset: 0.652344
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c6c8ca",
      stopOpacity: 1
    },
    offset: 0.65625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c8c9cb",
      stopOpacity: 1
    },
    offset: 0.660156
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c9cbcc",
      stopOpacity: 1
    },
    offset: 0.664063
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#cacccd",
      stopOpacity: 1
    },
    offset: 0.667969
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#cccdcf",
      stopOpacity: 1
    },
    offset: 0.671875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#cdcfd0",
      stopOpacity: 1
    },
    offset: 0.675781
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#cfd0d1",
      stopOpacity: 1
    },
    offset: 0.679688
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d0d1d3",
      stopOpacity: 1
    },
    offset: 0.683594
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d1d3d4",
      stopOpacity: 1
    },
    offset: 0.6875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d3d4d5",
      stopOpacity: 1
    },
    offset: 0.691406
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d4d5d7",
      stopOpacity: 1
    },
    offset: 0.695313
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d6d7d8",
      stopOpacity: 1
    },
    offset: 0.699219
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d7d8d9",
      stopOpacity: 1
    },
    offset: 0.703125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d8d9db",
      stopOpacity: 1
    },
    offset: 0.707031
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#dadbdc",
      stopOpacity: 1
    },
    offset: 0.710937
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#dbdcdd",
      stopOpacity: 1
    },
    offset: 0.714844
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#dddedf",
      stopOpacity: 1
    },
    offset: 0.71875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#dedfe0",
      stopOpacity: 1
    },
    offset: 0.722656
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#dfe0e1",
      stopOpacity: 1
    },
    offset: 0.726562
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e1e2e3",
      stopOpacity: 1
    },
    offset: 0.730469
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e2e3e4",
      stopOpacity: 1
    },
    offset: 0.734375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e4e4e5",
      stopOpacity: 1
    },
    offset: 0.738281
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e5e6e6",
      stopOpacity: 1
    },
    offset: 0.742187
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e6e7e8",
      stopOpacity: 1
    },
    offset: 0.746094
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e8e8e9",
      stopOpacity: 1
    },
    offset: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e9eaea",
      stopOpacity: 1
    },
    offset: 0.753906
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ebebec",
      stopOpacity: 1
    },
    offset: 0.757812
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ececed",
      stopOpacity: 1
    },
    offset: 0.761719
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#edeeee",
      stopOpacity: 1
    },
    offset: 0.765625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#efeff0",
      stopOpacity: 1
    },
    offset: 0.769531
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f0f1f1",
      stopOpacity: 1
    },
    offset: 0.773437
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f1f2f2",
      stopOpacity: 1
    },
    offset: 0.777344
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f3f3f4",
      stopOpacity: 1
    },
    offset: 0.78125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f4f5f5",
      stopOpacity: 1
    },
    offset: 0.785156
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f6f6f6",
      stopOpacity: 1
    },
    offset: 0.789062
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f7f7f8",
      stopOpacity: 1
    },
    offset: 0.792969
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f8f9f9",
      stopOpacity: 1
    },
    offset: 0.796875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fafafa",
      stopOpacity: 1
    },
    offset: 0.800781
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fbfbfc",
      stopOpacity: 1
    },
    offset: 0.804688
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fdfdfd",
      stopOpacity: 1
    },
    offset: 0.808594
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fefefe",
      stopOpacity: 1
    },
    offset: 0.8125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fdfdfd",
      stopOpacity: 1
    },
    offset: 0.816406
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fbfbfb",
      stopOpacity: 1
    },
    offset: 0.820312
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f9f9f9",
      stopOpacity: 1
    },
    offset: 0.824219
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f6f6f6",
      stopOpacity: 1
    },
    offset: 0.828125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f3f3f4",
      stopOpacity: 1
    },
    offset: 0.832031
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f1f1f1",
      stopOpacity: 1
    },
    offset: 0.835938
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#eeeeee",
      stopOpacity: 1
    },
    offset: 0.839844
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ebecec",
      stopOpacity: 1
    },
    offset: 0.84375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e9e9e9",
      stopOpacity: 1
    },
    offset: 0.847656
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e6e6e7",
      stopOpacity: 1
    },
    offset: 0.851563
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e3e4e4",
      stopOpacity: 1
    },
    offset: 0.855469
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e1e1e1",
      stopOpacity: 1
    },
    offset: 0.859375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#dededf",
      stopOpacity: 1
    },
    offset: 0.863281
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#dbdcdc",
      stopOpacity: 1
    },
    offset: 0.867188
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d9d9da",
      stopOpacity: 1
    },
    offset: 0.871094
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d6d6d7",
      stopOpacity: 1
    },
    offset: 0.875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d3d4d4",
      stopOpacity: 1
    },
    offset: 0.878906
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d1d1d2",
      stopOpacity: 1
    },
    offset: 0.882813
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#cececf",
      stopOpacity: 1
    },
    offset: 0.886719
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#cbcccd",
      stopOpacity: 1
    },
    offset: 0.890625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c9c9ca",
      stopOpacity: 1
    },
    offset: 0.894531
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c6c7c7",
      stopOpacity: 1
    },
    offset: 0.898438
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c3c4c5",
      stopOpacity: 1
    },
    offset: 0.902344
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c1c1c2",
      stopOpacity: 1
    },
    offset: 0.90625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#bebfc0",
      stopOpacity: 1
    },
    offset: 0.910156
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#bbbcbd",
      stopOpacity: 1
    },
    offset: 0.914062
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#b9b9ba",
      stopOpacity: 1
    },
    offset: 0.917969
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#b6b7b8",
      stopOpacity: 1
    },
    offset: 0.921875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#b3b4b5",
      stopOpacity: 1
    },
    offset: 0.925781
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#b1b1b3",
      stopOpacity: 1
    },
    offset: 0.929687
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#aeafb0",
      stopOpacity: 1
    },
    offset: 0.933594
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#abacad",
      stopOpacity: 1
    },
    offset: 0.9375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#a9a9ab",
      stopOpacity: 1
    },
    offset: 0.941406
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#a6a7a8",
      stopOpacity: 1
    },
    offset: 0.945312
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#a3a4a6",
      stopOpacity: 1
    },
    offset: 0.949219
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#a1a2a3",
      stopOpacity: 1
    },
    offset: 0.953125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#9e9fa0",
      stopOpacity: 1
    },
    offset: 0.957031
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#9b9c9e",
      stopOpacity: 1
    },
    offset: 0.960937
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#999a9b",
      stopOpacity: 1
    },
    offset: 0.964844
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#969799",
      stopOpacity: 1
    },
    offset: 0.96875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#939496",
      stopOpacity: 1
    },
    offset: 0.972656
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#919293",
      stopOpacity: 1
    },
    offset: 0.976562
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#8e8f91",
      stopOpacity: 1
    },
    offset: 0.980469
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#8b8c8e",
      stopOpacity: 1
    },
    offset: 0.984375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#898a8c",
      stopOpacity: 1
    },
    offset: 0.988281
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#868789",
      stopOpacity: 1
    },
    offset: 0.992188
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#838486",
      stopOpacity: 1
    },
    offset: 0.996094
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#818284",
      stopOpacity: 1
    },
    offset: 1
  })), _ref16, _ref17, /*#__PURE__*/React.createElement("linearGradient", {
    x1: 192.599982,
    gradientTransform: "matrix(1.529572,0,0,-1.5297,-0.090027,191.286603)",
    y1: 26.271,
    x2: 221.49999,
    gradientUnits: "userSpaceOnUse",
    y2: 26.271,
    id: "6a900a02e2"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#bcbdbf",
      stopOpacity: 1
    },
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#bdbec0",
      stopOpacity: 1
    },
    offset: 0.00390625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#bebec0",
      stopOpacity: 1
    },
    offset: 0.0078125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#bebfc1",
      stopOpacity: 1
    },
    offset: 0.0117188
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#bfc0c2",
      stopOpacity: 1
    },
    offset: 0.015625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c0c1c3",
      stopOpacity: 1
    },
    offset: 0.0195312
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c1c2c4",
      stopOpacity: 1
    },
    offset: 0.0234375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c2c3c5",
      stopOpacity: 1
    },
    offset: 0.0273438
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c3c4c5",
      stopOpacity: 1
    },
    offset: 0.03125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c4c4c6",
      stopOpacity: 1
    },
    offset: 0.0351562
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c4c5c7",
      stopOpacity: 1
    },
    offset: 0.0390625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c5c6c8",
      stopOpacity: 1
    },
    offset: 0.0429687
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c6c7c9",
      stopOpacity: 1
    },
    offset: 0.046875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c7c8c9",
      stopOpacity: 1
    },
    offset: 0.0507812
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c8c9ca",
      stopOpacity: 1
    },
    offset: 0.0546875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c9c9cb",
      stopOpacity: 1
    },
    offset: 0.0585937
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#cacacc",
      stopOpacity: 1
    },
    offset: 0.0625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#cacbcd",
      stopOpacity: 1
    },
    offset: 0.0664062
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#cbccce",
      stopOpacity: 1
    },
    offset: 0.0703125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#cccdce",
      stopOpacity: 1
    },
    offset: 0.0742188
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#cdcecf",
      stopOpacity: 1
    },
    offset: 0.078125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#cecfd0",
      stopOpacity: 1
    },
    offset: 0.0820312
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#cfcfd1",
      stopOpacity: 1
    },
    offset: 0.0859375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d0d0d2",
      stopOpacity: 1
    },
    offset: 0.0898437
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d0d1d3",
      stopOpacity: 1
    },
    offset: 0.09375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d1d2d3",
      stopOpacity: 1
    },
    offset: 0.0976562
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d2d3d4",
      stopOpacity: 1
    },
    offset: 0.101562
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d3d4d5",
      stopOpacity: 1
    },
    offset: 0.105469
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d4d4d6",
      stopOpacity: 1
    },
    offset: 0.109375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d5d5d7",
      stopOpacity: 1
    },
    offset: 0.113281
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d6d6d7",
      stopOpacity: 1
    },
    offset: 0.117188
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d6d7d8",
      stopOpacity: 1
    },
    offset: 0.121094
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d7d8d9",
      stopOpacity: 1
    },
    offset: 0.125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d8d9da",
      stopOpacity: 1
    },
    offset: 0.128906
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d9dadb",
      stopOpacity: 1
    },
    offset: 0.132812
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#dadadc",
      stopOpacity: 1
    },
    offset: 0.136719
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#dbdbdc",
      stopOpacity: 1
    },
    offset: 0.140625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#dcdcdd",
      stopOpacity: 1
    },
    offset: 0.144531
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#dcddde",
      stopOpacity: 1
    },
    offset: 0.148437
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#dddedf",
      stopOpacity: 1
    },
    offset: 0.152344
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#dedfe0",
      stopOpacity: 1
    },
    offset: 0.15625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#dfdfe0",
      stopOpacity: 1
    },
    offset: 0.160156
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e0e0e1",
      stopOpacity: 1
    },
    offset: 0.164062
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e1e1e2",
      stopOpacity: 1
    },
    offset: 0.167969
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e2e2e3",
      stopOpacity: 1
    },
    offset: 0.171875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e2e3e4",
      stopOpacity: 1
    },
    offset: 0.175781
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e3e4e5",
      stopOpacity: 1
    },
    offset: 0.179687
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e4e5e5",
      stopOpacity: 1
    },
    offset: 0.183594
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e5e5e6",
      stopOpacity: 1
    },
    offset: 0.1875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e6e6e7",
      stopOpacity: 1
    },
    offset: 0.191406
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e7e7e8",
      stopOpacity: 1
    },
    offset: 0.195312
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e8e8e9",
      stopOpacity: 1
    },
    offset: 0.199219
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e8e9e9",
      stopOpacity: 1
    },
    offset: 0.203125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e9eaea",
      stopOpacity: 1
    },
    offset: 0.207031
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#eaeaeb",
      stopOpacity: 1
    },
    offset: 0.210937
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ebebec",
      stopOpacity: 1
    },
    offset: 0.214844
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ececed",
      stopOpacity: 1
    },
    offset: 0.21875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ededee",
      stopOpacity: 1
    },
    offset: 0.222656
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#eeeeee",
      stopOpacity: 1
    },
    offset: 0.226562
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#eeefef",
      stopOpacity: 1
    },
    offset: 0.230469
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#eff0f0",
      stopOpacity: 1
    },
    offset: 0.234375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f0f0f1",
      stopOpacity: 1
    },
    offset: 0.238281
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f1f1f2",
      stopOpacity: 1
    },
    offset: 0.242187
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f2f2f3",
      stopOpacity: 1
    },
    offset: 0.246094
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f3f3f3",
      stopOpacity: 1
    },
    offset: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f4f4f4",
      stopOpacity: 1
    },
    offset: 0.253906
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f4f5f5",
      stopOpacity: 1
    },
    offset: 0.257812
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f5f5f6",
      stopOpacity: 1
    },
    offset: 0.261719
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f6f6f7",
      stopOpacity: 1
    },
    offset: 0.265625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f7f7f7",
      stopOpacity: 1
    },
    offset: 0.269531
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f8f8f8",
      stopOpacity: 1
    },
    offset: 0.273438
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f9f9f9",
      stopOpacity: 1
    },
    offset: 0.277344
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fafafa",
      stopOpacity: 1
    },
    offset: 0.28125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fbfbfb",
      stopOpacity: 1
    },
    offset: 0.285156
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fbfbfc",
      stopOpacity: 1
    },
    offset: 0.289062
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fcfcfc",
      stopOpacity: 1
    },
    offset: 0.292969
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fdfdfd",
      stopOpacity: 1
    },
    offset: 0.296875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fefefe",
      stopOpacity: 1
    },
    offset: 0.300781
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ffffff",
      stopOpacity: 1
    },
    offset: 0.304688
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ffffff",
      stopOpacity: 1
    },
    offset: 0.3125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ffffff",
      stopOpacity: 1
    },
    offset: 0.375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ffffff",
      stopOpacity: 1
    },
    offset: 0.4375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ffffff",
      stopOpacity: 1
    },
    offset: 0.46875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ffffff",
      stopOpacity: 1
    },
    offset: 0.484375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fefefe",
      stopOpacity: 1
    },
    offset: 0.488281
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fcfcfd",
      stopOpacity: 1
    },
    offset: 0.492188
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fafbfb",
      stopOpacity: 1
    },
    offset: 0.496094
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f8f9f9",
      stopOpacity: 1
    },
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f6f7f7",
      stopOpacity: 1
    },
    offset: 0.503906
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f4f5f5",
      stopOpacity: 1
    },
    offset: 0.507812
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f2f3f3",
      stopOpacity: 1
    },
    offset: 0.511719
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f0f1f1",
      stopOpacity: 1
    },
    offset: 0.515625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#eeefef",
      stopOpacity: 1
    },
    offset: 0.519531
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ecedee",
      stopOpacity: 1
    },
    offset: 0.523438
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ebebec",
      stopOpacity: 1
    },
    offset: 0.527344
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e9e9ea",
      stopOpacity: 1
    },
    offset: 0.53125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e7e7e8",
      stopOpacity: 1
    },
    offset: 0.535156
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e5e5e6",
      stopOpacity: 1
    },
    offset: 0.539063
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e3e3e4",
      stopOpacity: 1
    },
    offset: 0.542969
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e1e2e2",
      stopOpacity: 1
    },
    offset: 0.546875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#dfe0e1",
      stopOpacity: 1
    },
    offset: 0.550781
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#dddedf",
      stopOpacity: 1
    },
    offset: 0.554688
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#dbdcdd",
      stopOpacity: 1
    },
    offset: 0.558594
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d9dadb",
      stopOpacity: 1
    },
    offset: 0.5625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d7d8d9",
      stopOpacity: 1
    },
    offset: 0.566406
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d5d6d7",
      stopOpacity: 1
    },
    offset: 0.570312
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d3d4d5",
      stopOpacity: 1
    },
    offset: 0.574219
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d1d2d4",
      stopOpacity: 1
    },
    offset: 0.578125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#cfd0d2",
      stopOpacity: 1
    },
    offset: 0.582031
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#cdced0",
      stopOpacity: 1
    },
    offset: 0.585938
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#cbccce",
      stopOpacity: 1
    },
    offset: 0.589844
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c9cacc",
      stopOpacity: 1
    },
    offset: 0.59375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c7c9ca",
      stopOpacity: 1
    },
    offset: 0.597656
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c5c7c8",
      stopOpacity: 1
    },
    offset: 0.601562
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c3c5c6",
      stopOpacity: 1
    },
    offset: 0.605469
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c1c3c5",
      stopOpacity: 1
    },
    offset: 0.609375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#bfc1c3",
      stopOpacity: 1
    },
    offset: 0.613281
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#bdbfc1",
      stopOpacity: 1
    },
    offset: 0.617188
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#bdbfc1",
      stopOpacity: 1
    },
    offset: 0.621094
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#bcbec0",
      stopOpacity: 1
    },
    offset: 0.625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#bec0c2",
      stopOpacity: 1
    },
    offset: 0.628906
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#bfc1c3",
      stopOpacity: 1
    },
    offset: 0.632813
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c0c2c4",
      stopOpacity: 1
    },
    offset: 0.636719
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c2c4c6",
      stopOpacity: 1
    },
    offset: 0.640625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c3c5c7",
      stopOpacity: 1
    },
    offset: 0.644531
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c5c6c8",
      stopOpacity: 1
    },
    offset: 0.648438
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c6c8c9",
      stopOpacity: 1
    },
    offset: 0.652344
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c7c9cb",
      stopOpacity: 1
    },
    offset: 0.65625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c9cacc",
      stopOpacity: 1
    },
    offset: 0.660156
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#cacccd",
      stopOpacity: 1
    },
    offset: 0.664062
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#cccdcf",
      stopOpacity: 1
    },
    offset: 0.667969
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#cdcfd0",
      stopOpacity: 1
    },
    offset: 0.671875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ced0d1",
      stopOpacity: 1
    },
    offset: 0.675781
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d0d1d3",
      stopOpacity: 1
    },
    offset: 0.679688
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d1d3d4",
      stopOpacity: 1
    },
    offset: 0.683594
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d3d4d5",
      stopOpacity: 1
    },
    offset: 0.6875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d4d5d7",
      stopOpacity: 1
    },
    offset: 0.691406
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d5d7d8",
      stopOpacity: 1
    },
    offset: 0.695312
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d7d8d9",
      stopOpacity: 1
    },
    offset: 0.699219
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d8d9db",
      stopOpacity: 1
    },
    offset: 0.703125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#dadbdc",
      stopOpacity: 1
    },
    offset: 0.707031
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#dbdcdd",
      stopOpacity: 1
    },
    offset: 0.710938
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#dcddde",
      stopOpacity: 1
    },
    offset: 0.714844
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#dedfe0",
      stopOpacity: 1
    },
    offset: 0.71875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#dfe0e1",
      stopOpacity: 1
    },
    offset: 0.722656
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e1e1e2",
      stopOpacity: 1
    },
    offset: 0.726563
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e2e3e4",
      stopOpacity: 1
    },
    offset: 0.730469
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e3e4e5",
      stopOpacity: 1
    },
    offset: 0.734375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e5e6e6",
      stopOpacity: 1
    },
    offset: 0.738281
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e6e7e8",
      stopOpacity: 1
    },
    offset: 0.742188
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e8e8e9",
      stopOpacity: 1
    },
    offset: 0.746094
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e9eaea",
      stopOpacity: 1
    },
    offset: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#eaebec",
      stopOpacity: 1
    },
    offset: 0.753906
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ececed",
      stopOpacity: 1
    },
    offset: 0.757812
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#edeeee",
      stopOpacity: 1
    },
    offset: 0.761719
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#efeff0",
      stopOpacity: 1
    },
    offset: 0.765625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f0f0f1",
      stopOpacity: 1
    },
    offset: 0.769531
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f1f2f2",
      stopOpacity: 1
    },
    offset: 0.773437
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f3f3f3",
      stopOpacity: 1
    },
    offset: 0.777344
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f4f4f5",
      stopOpacity: 1
    },
    offset: 0.78125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f6f6f6",
      stopOpacity: 1
    },
    offset: 0.785156
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f7f7f7",
      stopOpacity: 1
    },
    offset: 0.789062
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f8f9f9",
      stopOpacity: 1
    },
    offset: 0.792969
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fafafa",
      stopOpacity: 1
    },
    offset: 0.796875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fbfbfb",
      stopOpacity: 1
    },
    offset: 0.800781
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fdfdfd",
      stopOpacity: 1
    },
    offset: 0.804688
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fdfdfe",
      stopOpacity: 1
    },
    offset: 0.808594
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fefefe",
      stopOpacity: 1
    },
    offset: 0.8125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fcfcfc",
      stopOpacity: 1
    },
    offset: 0.816406
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f9f9f9",
      stopOpacity: 1
    },
    offset: 0.820312
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f6f6f7",
      stopOpacity: 1
    },
    offset: 0.824219
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f4f4f4",
      stopOpacity: 1
    },
    offset: 0.828125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f1f1f1",
      stopOpacity: 1
    },
    offset: 0.832031
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#eeefef",
      stopOpacity: 1
    },
    offset: 0.835938
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ececec",
      stopOpacity: 1
    },
    offset: 0.839844
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e9e9ea",
      stopOpacity: 1
    },
    offset: 0.84375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e6e7e7",
      stopOpacity: 1
    },
    offset: 0.847656
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e4e4e4",
      stopOpacity: 1
    },
    offset: 0.851562
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e1e1e2",
      stopOpacity: 1
    },
    offset: 0.855469
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#dedfdf",
      stopOpacity: 1
    },
    offset: 0.859375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#dcdcdd",
      stopOpacity: 1
    },
    offset: 0.863281
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d9d9da",
      stopOpacity: 1
    },
    offset: 0.867187
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d6d7d7",
      stopOpacity: 1
    },
    offset: 0.871094
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d4d4d5",
      stopOpacity: 1
    },
    offset: 0.875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d1d1d2",
      stopOpacity: 1
    },
    offset: 0.878906
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#cecfd0",
      stopOpacity: 1
    },
    offset: 0.882812
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#cccccd",
      stopOpacity: 1
    },
    offset: 0.886719
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c9caca",
      stopOpacity: 1
    },
    offset: 0.890625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c6c7c8",
      stopOpacity: 1
    },
    offset: 0.894531
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c4c4c5",
      stopOpacity: 1
    },
    offset: 0.898438
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c1c2c3",
      stopOpacity: 1
    },
    offset: 0.902344
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#bebfc0",
      stopOpacity: 1
    },
    offset: 0.90625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#bcbcbd",
      stopOpacity: 1
    },
    offset: 0.910156
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#b9babb",
      stopOpacity: 1
    },
    offset: 0.914062
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#b7b7b8",
      stopOpacity: 1
    },
    offset: 0.917969
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#b4b4b6",
      stopOpacity: 1
    },
    offset: 0.921875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#b1b2b3",
      stopOpacity: 1
    },
    offset: 0.925781
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#afafb0",
      stopOpacity: 1
    },
    offset: 0.929688
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#acadae",
      stopOpacity: 1
    },
    offset: 0.933594
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#a9aaab",
      stopOpacity: 1
    },
    offset: 0.9375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#a7a7a9",
      stopOpacity: 1
    },
    offset: 0.941406
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#a4a5a6",
      stopOpacity: 1
    },
    offset: 0.945312
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#a1a2a3",
      stopOpacity: 1
    },
    offset: 0.949219
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#9f9fa1",
      stopOpacity: 1
    },
    offset: 0.953125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#9c9d9e",
      stopOpacity: 1
    },
    offset: 0.957031
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#999a9c",
      stopOpacity: 1
    },
    offset: 0.960937
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#979799",
      stopOpacity: 1
    },
    offset: 0.964844
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#949596",
      stopOpacity: 1
    },
    offset: 0.96875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#919294",
      stopOpacity: 1
    },
    offset: 0.972656
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#8f8f91",
      stopOpacity: 1
    },
    offset: 0.976562
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#8c8d8f",
      stopOpacity: 1
    },
    offset: 0.980469
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#898a8c",
      stopOpacity: 1
    },
    offset: 0.984375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#878889",
      stopOpacity: 1
    },
    offset: 0.988281
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#848587",
      stopOpacity: 1
    },
    offset: 0.992188
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#828385",
      stopOpacity: 1
    },
    offset: 0.996094
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#808183",
      stopOpacity: 1
    },
    offset: 1
  })), _ref18, _ref19, /*#__PURE__*/React.createElement("linearGradient", {
    x1: 217.899971,
    gradientTransform: "matrix(1.529572,0,0,-1.5297,-0.090027,191.286603)",
    y1: 18.351999,
    x2: 223.29999,
    gradientUnits: "userSpaceOnUse",
    y2: 18.351999,
    id: "c79acd08dd"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#bbbcbe",
      stopOpacity: 1
    },
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#bcbdbf",
      stopOpacity: 1
    },
    offset: 0.00390625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#bdbec0",
      stopOpacity: 1
    },
    offset: 0.0078125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#bebfc1",
      stopOpacity: 1
    },
    offset: 0.0117187
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#bfc0c2",
      stopOpacity: 1
    },
    offset: 0.015625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c0c1c3",
      stopOpacity: 1
    },
    offset: 0.0195312
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c1c2c4",
      stopOpacity: 1
    },
    offset: 0.0234375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c2c3c4",
      stopOpacity: 1
    },
    offset: 0.0273437
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c3c4c5",
      stopOpacity: 1
    },
    offset: 0.03125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c4c4c6",
      stopOpacity: 1
    },
    offset: 0.0351562
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c4c5c7",
      stopOpacity: 1
    },
    offset: 0.0390625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c5c6c8",
      stopOpacity: 1
    },
    offset: 0.0429687
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c6c7c9",
      stopOpacity: 1
    },
    offset: 0.046875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c7c8ca",
      stopOpacity: 1
    },
    offset: 0.0507812
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c8c9ca",
      stopOpacity: 1
    },
    offset: 0.0546875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c9cacb",
      stopOpacity: 1
    },
    offset: 0.0585937
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#cacbcc",
      stopOpacity: 1
    },
    offset: 0.0625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#cbcccd",
      stopOpacity: 1
    },
    offset: 0.0664063
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ccccce",
      stopOpacity: 1
    },
    offset: 0.0703125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#cdcdcf",
      stopOpacity: 1
    },
    offset: 0.0742188
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#cdced0",
      stopOpacity: 1
    },
    offset: 0.078125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#cecfd1",
      stopOpacity: 1
    },
    offset: 0.0820312
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#cfd0d1",
      stopOpacity: 1
    },
    offset: 0.0859375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d0d1d2",
      stopOpacity: 1
    },
    offset: 0.0898438
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d1d2d3",
      stopOpacity: 1
    },
    offset: 0.09375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d2d3d4",
      stopOpacity: 1
    },
    offset: 0.0976562
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d3d3d5",
      stopOpacity: 1
    },
    offset: 0.101562
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d4d4d6",
      stopOpacity: 1
    },
    offset: 0.105469
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d5d5d7",
      stopOpacity: 1
    },
    offset: 0.109375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d6d6d7",
      stopOpacity: 1
    },
    offset: 0.113281
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d6d7d8",
      stopOpacity: 1
    },
    offset: 0.117187
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d7d8d9",
      stopOpacity: 1
    },
    offset: 0.121094
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d8d9da",
      stopOpacity: 1
    },
    offset: 0.125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d9dadb",
      stopOpacity: 1
    },
    offset: 0.128906
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#dadbdc",
      stopOpacity: 1
    },
    offset: 0.132812
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#dbdbdd",
      stopOpacity: 1
    },
    offset: 0.136719
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#dcdcdd",
      stopOpacity: 1
    },
    offset: 0.140625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ddddde",
      stopOpacity: 1
    },
    offset: 0.144531
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#dededf",
      stopOpacity: 1
    },
    offset: 0.148437
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#dfdfe0",
      stopOpacity: 1
    },
    offset: 0.152344
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#dfe0e1",
      stopOpacity: 1
    },
    offset: 0.15625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e0e1e2",
      stopOpacity: 1
    },
    offset: 0.160156
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e1e2e3",
      stopOpacity: 1
    },
    offset: 0.164062
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e2e3e3",
      stopOpacity: 1
    },
    offset: 0.167969
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e3e3e4",
      stopOpacity: 1
    },
    offset: 0.171875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e4e4e5",
      stopOpacity: 1
    },
    offset: 0.175781
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e5e5e6",
      stopOpacity: 1
    },
    offset: 0.179687
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e6e6e7",
      stopOpacity: 1
    },
    offset: 0.183594
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e7e7e8",
      stopOpacity: 1
    },
    offset: 0.1875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e8e8e9",
      stopOpacity: 1
    },
    offset: 0.191406
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e8e9e9",
      stopOpacity: 1
    },
    offset: 0.195312
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e9eaea",
      stopOpacity: 1
    },
    offset: 0.199219
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#eaebeb",
      stopOpacity: 1
    },
    offset: 0.203125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ebebec",
      stopOpacity: 1
    },
    offset: 0.207031
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ececed",
      stopOpacity: 1
    },
    offset: 0.210938
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ededee",
      stopOpacity: 1
    },
    offset: 0.214844
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#eeeeef",
      stopOpacity: 1
    },
    offset: 0.21875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#efefef",
      stopOpacity: 1
    },
    offset: 0.222656
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f0f0f0",
      stopOpacity: 1
    },
    offset: 0.226562
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f1f1f1",
      stopOpacity: 1
    },
    offset: 0.230469
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f1f2f2",
      stopOpacity: 1
    },
    offset: 0.234375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f2f3f3",
      stopOpacity: 1
    },
    offset: 0.238281
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f3f3f4",
      stopOpacity: 1
    },
    offset: 0.242188
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f4f4f5",
      stopOpacity: 1
    },
    offset: 0.246094
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f5f5f5",
      stopOpacity: 1
    },
    offset: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f6f6f6",
      stopOpacity: 1
    },
    offset: 0.253906
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f7f7f7",
      stopOpacity: 1
    },
    offset: 0.257812
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f8f8f8",
      stopOpacity: 1
    },
    offset: 0.261719
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f9f9f9",
      stopOpacity: 1
    },
    offset: 0.265625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fafafa",
      stopOpacity: 1
    },
    offset: 0.269531
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fafbfb",
      stopOpacity: 1
    },
    offset: 0.273438
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fbfbfc",
      stopOpacity: 1
    },
    offset: 0.277344
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fcfcfc",
      stopOpacity: 1
    },
    offset: 0.28125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fdfdfd",
      stopOpacity: 1
    },
    offset: 0.285156
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fefefe",
      stopOpacity: 1
    },
    offset: 0.289062
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ffffff",
      stopOpacity: 1
    },
    offset: 0.296875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ffffff",
      stopOpacity: 1
    },
    offset: 0.3125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ffffff",
      stopOpacity: 1
    },
    offset: 0.375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ffffff",
      stopOpacity: 1
    },
    offset: 0.4375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ffffff",
      stopOpacity: 1
    },
    offset: 0.453125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ffffff",
      stopOpacity: 1
    },
    offset: 0.460938
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fefefe",
      stopOpacity: 1
    },
    offset: 0.464844
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fefefe",
      stopOpacity: 1
    },
    offset: 0.46875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fcfcfc",
      stopOpacity: 1
    },
    offset: 0.472656
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fafafa",
      stopOpacity: 1
    },
    offset: 0.476562
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f7f8f8",
      stopOpacity: 1
    },
    offset: 0.480469
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f5f6f6",
      stopOpacity: 1
    },
    offset: 0.484375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f3f4f4",
      stopOpacity: 1
    },
    offset: 0.488281
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f1f2f2",
      stopOpacity: 1
    },
    offset: 0.492188
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#eff0f0",
      stopOpacity: 1
    },
    offset: 0.496094
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#edeeee",
      stopOpacity: 1
    },
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ebecec",
      stopOpacity: 1
    },
    offset: 0.503906
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e9eaea",
      stopOpacity: 1
    },
    offset: 0.507812
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e7e8e8",
      stopOpacity: 1
    },
    offset: 0.511719
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e5e6e6",
      stopOpacity: 1
    },
    offset: 0.515625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e3e4e4",
      stopOpacity: 1
    },
    offset: 0.519531
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e1e2e2",
      stopOpacity: 1
    },
    offset: 0.523438
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#dfe0e0",
      stopOpacity: 1
    },
    offset: 0.527344
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#dcdedf",
      stopOpacity: 1
    },
    offset: 0.53125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#dadbdd",
      stopOpacity: 1
    },
    offset: 0.535156
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d8d9db",
      stopOpacity: 1
    },
    offset: 0.539062
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d6d7d9",
      stopOpacity: 1
    },
    offset: 0.542969
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d4d5d7",
      stopOpacity: 1
    },
    offset: 0.546875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d2d3d5",
      stopOpacity: 1
    },
    offset: 0.550781
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d0d1d3",
      stopOpacity: 1
    },
    offset: 0.554688
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#cecfd1",
      stopOpacity: 1
    },
    offset: 0.558594
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#cccdcf",
      stopOpacity: 1
    },
    offset: 0.5625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#cacbcd",
      stopOpacity: 1
    },
    offset: 0.566406
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c8c9cb",
      stopOpacity: 1
    },
    offset: 0.570312
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c6c7c9",
      stopOpacity: 1
    },
    offset: 0.574219
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c4c5c7",
      stopOpacity: 1
    },
    offset: 0.578125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c1c3c5",
      stopOpacity: 1
    },
    offset: 0.582031
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#bfc1c3",
      stopOpacity: 1
    },
    offset: 0.585938
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#bdbfc1",
      stopOpacity: 1
    },
    offset: 0.589844
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#bbbdbf",
      stopOpacity: 1
    },
    offset: 0.59375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#bcbec0",
      stopOpacity: 1
    },
    offset: 0.597656
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#bec0c2",
      stopOpacity: 1
    },
    offset: 0.601562
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#bfc1c3",
      stopOpacity: 1
    },
    offset: 0.605469
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c1c2c4",
      stopOpacity: 1
    },
    offset: 0.609375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c2c4c6",
      stopOpacity: 1
    },
    offset: 0.613281
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c3c5c7",
      stopOpacity: 1
    },
    offset: 0.617188
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c5c7c8",
      stopOpacity: 1
    },
    offset: 0.621094
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c6c8ca",
      stopOpacity: 1
    },
    offset: 0.625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c8c9cb",
      stopOpacity: 1
    },
    offset: 0.628906
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c9cbcd",
      stopOpacity: 1
    },
    offset: 0.632812
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#cbccce",
      stopOpacity: 1
    },
    offset: 0.636719
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#cccecf",
      stopOpacity: 1
    },
    offset: 0.640625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#cecfd1",
      stopOpacity: 1
    },
    offset: 0.644531
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#cfd1d2",
      stopOpacity: 1
    },
    offset: 0.648437
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d1d2d3",
      stopOpacity: 1
    },
    offset: 0.652344
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d2d3d5",
      stopOpacity: 1
    },
    offset: 0.65625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d4d5d6",
      stopOpacity: 1
    },
    offset: 0.660156
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d5d6d8",
      stopOpacity: 1
    },
    offset: 0.664062
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d6d8d9",
      stopOpacity: 1
    },
    offset: 0.667969
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d8d9da",
      stopOpacity: 1
    },
    offset: 0.671875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d9dbdc",
      stopOpacity: 1
    },
    offset: 0.675781
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#dbdcdd",
      stopOpacity: 1
    },
    offset: 0.679687
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#dcddde",
      stopOpacity: 1
    },
    offset: 0.683594
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#dedfe0",
      stopOpacity: 1
    },
    offset: 0.6875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#dfe0e1",
      stopOpacity: 1
    },
    offset: 0.691406
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e1e2e3",
      stopOpacity: 1
    },
    offset: 0.695312
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e2e3e4",
      stopOpacity: 1
    },
    offset: 0.699219
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e4e4e5",
      stopOpacity: 1
    },
    offset: 0.703125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e5e6e7",
      stopOpacity: 1
    },
    offset: 0.707031
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e7e7e8",
      stopOpacity: 1
    },
    offset: 0.710937
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e8e9e9",
      stopOpacity: 1
    },
    offset: 0.714844
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#eaeaeb",
      stopOpacity: 1
    },
    offset: 0.71875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ebecec",
      stopOpacity: 1
    },
    offset: 0.722656
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ecedee",
      stopOpacity: 1
    },
    offset: 0.726562
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#eeeeef",
      stopOpacity: 1
    },
    offset: 0.730469
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#eff0f0",
      stopOpacity: 1
    },
    offset: 0.734375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f1f1f2",
      stopOpacity: 1
    },
    offset: 0.738281
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f2f3f3",
      stopOpacity: 1
    },
    offset: 0.742187
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f4f4f4",
      stopOpacity: 1
    },
    offset: 0.746094
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f5f6f6",
      stopOpacity: 1
    },
    offset: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f7f7f7",
      stopOpacity: 1
    },
    offset: 0.753906
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f8f8f9",
      stopOpacity: 1
    },
    offset: 0.757813
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fafafa",
      stopOpacity: 1
    },
    offset: 0.761719
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fbfbfb",
      stopOpacity: 1
    },
    offset: 0.765625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fdfdfd",
      stopOpacity: 1
    },
    offset: 0.769531
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fefefe",
      stopOpacity: 1
    },
    offset: 0.773438
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fdfdfd",
      stopOpacity: 1
    },
    offset: 0.777344
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fbfbfb",
      stopOpacity: 1
    },
    offset: 0.78125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f8f9f9",
      stopOpacity: 1
    },
    offset: 0.785156
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f6f6f6",
      stopOpacity: 1
    },
    offset: 0.789063
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f3f3f3",
      stopOpacity: 1
    },
    offset: 0.792969
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f0f0f0",
      stopOpacity: 1
    },
    offset: 0.796875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ededee",
      stopOpacity: 1
    },
    offset: 0.800781
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ebebeb",
      stopOpacity: 1
    },
    offset: 0.804688
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e8e8e8",
      stopOpacity: 1
    },
    offset: 0.808594
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e5e5e6",
      stopOpacity: 1
    },
    offset: 0.8125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e2e2e3",
      stopOpacity: 1
    },
    offset: 0.816406
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#dfe0e0",
      stopOpacity: 1
    },
    offset: 0.820313
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#dddddd",
      stopOpacity: 1
    },
    offset: 0.824219
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#dadadb",
      stopOpacity: 1
    },
    offset: 0.828125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d7d7d8",
      stopOpacity: 1
    },
    offset: 0.832031
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d4d5d5",
      stopOpacity: 1
    },
    offset: 0.835938
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d1d2d3",
      stopOpacity: 1
    },
    offset: 0.839844
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#cfcfd0",
      stopOpacity: 1
    },
    offset: 0.84375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#cccccd",
      stopOpacity: 1
    },
    offset: 0.847656
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c9caca",
      stopOpacity: 1
    },
    offset: 0.851563
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c6c7c8",
      stopOpacity: 1
    },
    offset: 0.855469
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c3c4c5",
      stopOpacity: 1
    },
    offset: 0.859375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c1c1c2",
      stopOpacity: 1
    },
    offset: 0.863281
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#bebebf",
      stopOpacity: 1
    },
    offset: 0.867188
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#bbbcbd",
      stopOpacity: 1
    },
    offset: 0.871094
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#b8b9ba",
      stopOpacity: 1
    },
    offset: 0.875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#b6b6b7",
      stopOpacity: 1
    },
    offset: 0.878906
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#b3b3b5",
      stopOpacity: 1
    },
    offset: 0.882812
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#b0b1b2",
      stopOpacity: 1
    },
    offset: 0.886719
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#adaeaf",
      stopOpacity: 1
    },
    offset: 0.890625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#aaabac",
      stopOpacity: 1
    },
    offset: 0.894531
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#a8a8aa",
      stopOpacity: 1
    },
    offset: 0.898438
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#a5a6a7",
      stopOpacity: 1
    },
    offset: 0.902344
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#a2a3a4",
      stopOpacity: 1
    },
    offset: 0.90625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#9fa0a2",
      stopOpacity: 1
    },
    offset: 0.910156
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#9c9d9f",
      stopOpacity: 1
    },
    offset: 0.914062
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#9a9a9c",
      stopOpacity: 1
    },
    offset: 0.917969
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#979899",
      stopOpacity: 1
    },
    offset: 0.921875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#949597",
      stopOpacity: 1
    },
    offset: 0.925781
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#919294",
      stopOpacity: 1
    },
    offset: 0.929688
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#8e8f91",
      stopOpacity: 1
    },
    offset: 0.933594
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#8c8d8e",
      stopOpacity: 1
    },
    offset: 0.9375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#898a8c",
      stopOpacity: 1
    },
    offset: 0.941406
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#868789",
      stopOpacity: 1
    },
    offset: 0.945312
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#838486",
      stopOpacity: 1
    },
    offset: 0.949219
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#818284",
      stopOpacity: 1
    },
    offset: 0.953125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#808183",
      stopOpacity: 1
    },
    offset: 0.96875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#808183",
      stopOpacity: 1
    },
    offset: 1
  })), _ref20, _ref21, /*#__PURE__*/React.createElement("linearGradient", {
    x1: 224.69999,
    gradientTransform: "matrix(1.529572,0,0,-1.5297,-0.090027,191.286603)",
    y1: 26.294001,
    x2: 254.699999,
    gradientUnits: "userSpaceOnUse",
    y2: 26.294001,
    id: "3228f735eb"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#bbbcbe",
      stopOpacity: 1
    },
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#bcbdbf",
      stopOpacity: 1
    },
    offset: 0.00390625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#bdbec0",
      stopOpacity: 1
    },
    offset: 0.0078125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#bebfc1",
      stopOpacity: 1
    },
    offset: 0.0117188
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#bfc0c2",
      stopOpacity: 1
    },
    offset: 0.015625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#bfc0c2",
      stopOpacity: 1
    },
    offset: 0.0195312
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c0c1c3",
      stopOpacity: 1
    },
    offset: 0.0234375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c1c2c4",
      stopOpacity: 1
    },
    offset: 0.0273438
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c2c3c5",
      stopOpacity: 1
    },
    offset: 0.03125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c3c4c6",
      stopOpacity: 1
    },
    offset: 0.0351562
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c4c5c6",
      stopOpacity: 1
    },
    offset: 0.0390625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c5c6c7",
      stopOpacity: 1
    },
    offset: 0.0429687
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c6c6c8",
      stopOpacity: 1
    },
    offset: 0.046875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c6c7c9",
      stopOpacity: 1
    },
    offset: 0.0507812
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c7c8ca",
      stopOpacity: 1
    },
    offset: 0.0546875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c8c9cb",
      stopOpacity: 1
    },
    offset: 0.0585937
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c9cacb",
      stopOpacity: 1
    },
    offset: 0.0625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#cacbcc",
      stopOpacity: 1
    },
    offset: 0.0664062
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#cbcbcd",
      stopOpacity: 1
    },
    offset: 0.0703125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ccccce",
      stopOpacity: 1
    },
    offset: 0.0742187
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#cccdcf",
      stopOpacity: 1
    },
    offset: 0.078125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#cdcecf",
      stopOpacity: 1
    },
    offset: 0.0820312
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#cecfd0",
      stopOpacity: 1
    },
    offset: 0.0859375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#cfd0d1",
      stopOpacity: 1
    },
    offset: 0.0898437
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d0d1d2",
      stopOpacity: 1
    },
    offset: 0.09375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d1d1d3",
      stopOpacity: 1
    },
    offset: 0.0976562
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d2d2d4",
      stopOpacity: 1
    },
    offset: 0.101562
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d2d3d4",
      stopOpacity: 1
    },
    offset: 0.105469
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d3d4d5",
      stopOpacity: 1
    },
    offset: 0.109375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d4d5d6",
      stopOpacity: 1
    },
    offset: 0.113281
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d5d6d7",
      stopOpacity: 1
    },
    offset: 0.117187
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d6d6d8",
      stopOpacity: 1
    },
    offset: 0.121094
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d7d7d9",
      stopOpacity: 1
    },
    offset: 0.125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d8d8d9",
      stopOpacity: 1
    },
    offset: 0.128906
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d8d9da",
      stopOpacity: 1
    },
    offset: 0.132812
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d9dadb",
      stopOpacity: 1
    },
    offset: 0.136719
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#dadbdc",
      stopOpacity: 1
    },
    offset: 0.140625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#dbdcdd",
      stopOpacity: 1
    },
    offset: 0.144531
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#dcdcdd",
      stopOpacity: 1
    },
    offset: 0.148438
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ddddde",
      stopOpacity: 1
    },
    offset: 0.152344
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#dededf",
      stopOpacity: 1
    },
    offset: 0.15625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#dedfe0",
      stopOpacity: 1
    },
    offset: 0.160156
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#dfe0e1",
      stopOpacity: 1
    },
    offset: 0.164062
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e0e1e2",
      stopOpacity: 1
    },
    offset: 0.167969
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e1e1e2",
      stopOpacity: 1
    },
    offset: 0.171875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e2e2e3",
      stopOpacity: 1
    },
    offset: 0.175781
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e3e3e4",
      stopOpacity: 1
    },
    offset: 0.179688
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e4e4e5",
      stopOpacity: 1
    },
    offset: 0.183594
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e4e5e6",
      stopOpacity: 1
    },
    offset: 0.1875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e5e6e6",
      stopOpacity: 1
    },
    offset: 0.191406
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e6e7e7",
      stopOpacity: 1
    },
    offset: 0.195312
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e7e7e8",
      stopOpacity: 1
    },
    offset: 0.199219
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e8e8e9",
      stopOpacity: 1
    },
    offset: 0.203125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e9e9ea",
      stopOpacity: 1
    },
    offset: 0.207031
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#eaeaeb",
      stopOpacity: 1
    },
    offset: 0.210938
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#eaebeb",
      stopOpacity: 1
    },
    offset: 0.214844
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ebecec",
      stopOpacity: 1
    },
    offset: 0.21875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ececed",
      stopOpacity: 1
    },
    offset: 0.222656
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ededee",
      stopOpacity: 1
    },
    offset: 0.226562
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#eeeeef",
      stopOpacity: 1
    },
    offset: 0.230469
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#efeff0",
      stopOpacity: 1
    },
    offset: 0.234375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f0f0f0",
      stopOpacity: 1
    },
    offset: 0.238281
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f1f1f1",
      stopOpacity: 1
    },
    offset: 0.242188
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f1f2f2",
      stopOpacity: 1
    },
    offset: 0.246094
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f2f2f3",
      stopOpacity: 1
    },
    offset: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f3f3f4",
      stopOpacity: 1
    },
    offset: 0.253906
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f4f4f4",
      stopOpacity: 1
    },
    offset: 0.257813
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f5f5f5",
      stopOpacity: 1
    },
    offset: 0.261719
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f6f6f6",
      stopOpacity: 1
    },
    offset: 0.265625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f7f7f7",
      stopOpacity: 1
    },
    offset: 0.269531
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f7f8f8",
      stopOpacity: 1
    },
    offset: 0.273438
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f8f8f9",
      stopOpacity: 1
    },
    offset: 0.277344
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f9f9f9",
      stopOpacity: 1
    },
    offset: 0.28125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fafafa",
      stopOpacity: 1
    },
    offset: 0.285156
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fbfbfb",
      stopOpacity: 1
    },
    offset: 0.289062
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fcfcfc",
      stopOpacity: 1
    },
    offset: 0.292969
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fdfdfd",
      stopOpacity: 1
    },
    offset: 0.296875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fdfdfd",
      stopOpacity: 1
    },
    offset: 0.300781
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fefefe",
      stopOpacity: 1
    },
    offset: 0.304688
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ffffff",
      stopOpacity: 1
    },
    offset: 0.3125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ffffff",
      stopOpacity: 1
    },
    offset: 0.375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ffffff",
      stopOpacity: 1
    },
    offset: 0.4375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ffffff",
      stopOpacity: 1
    },
    offset: 0.46875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ffffff",
      stopOpacity: 1
    },
    offset: 0.484375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fefefe",
      stopOpacity: 1
    },
    offset: 0.488281
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fdfdfe",
      stopOpacity: 1
    },
    offset: 0.492188
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fbfcfc",
      stopOpacity: 1
    },
    offset: 0.496094
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f9fafa",
      stopOpacity: 1
    },
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f7f8f8",
      stopOpacity: 1
    },
    offset: 0.503906
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f5f6f6",
      stopOpacity: 1
    },
    offset: 0.507812
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f4f4f4",
      stopOpacity: 1
    },
    offset: 0.511719
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f2f2f2",
      stopOpacity: 1
    },
    offset: 0.515625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f0f0f0",
      stopOpacity: 1
    },
    offset: 0.519531
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#eeeeef",
      stopOpacity: 1
    },
    offset: 0.523438
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ececed",
      stopOpacity: 1
    },
    offset: 0.527344
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#eaeaeb",
      stopOpacity: 1
    },
    offset: 0.53125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e8e8e9",
      stopOpacity: 1
    },
    offset: 0.535156
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e6e6e7",
      stopOpacity: 1
    },
    offset: 0.539062
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e4e4e5",
      stopOpacity: 1
    },
    offset: 0.542969
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e2e3e3",
      stopOpacity: 1
    },
    offset: 0.546875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e0e1e2",
      stopOpacity: 1
    },
    offset: 0.550781
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#dedfe0",
      stopOpacity: 1
    },
    offset: 0.554688
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#dcddde",
      stopOpacity: 1
    },
    offset: 0.558594
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#dadbdc",
      stopOpacity: 1
    },
    offset: 0.5625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d8d9da",
      stopOpacity: 1
    },
    offset: 0.566406
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d6d7d8",
      stopOpacity: 1
    },
    offset: 0.570312
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d4d5d6",
      stopOpacity: 1
    },
    offset: 0.574219
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d2d3d4",
      stopOpacity: 1
    },
    offset: 0.578125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d0d1d3",
      stopOpacity: 1
    },
    offset: 0.582031
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#cecfd1",
      stopOpacity: 1
    },
    offset: 0.585938
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#cccdcf",
      stopOpacity: 1
    },
    offset: 0.589844
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#cacbcd",
      stopOpacity: 1
    },
    offset: 0.59375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c8cacb",
      stopOpacity: 1
    },
    offset: 0.597656
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c6c8c9",
      stopOpacity: 1
    },
    offset: 0.601562
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c4c6c7",
      stopOpacity: 1
    },
    offset: 0.605469
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c2c4c6",
      stopOpacity: 1
    },
    offset: 0.609375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c0c2c4",
      stopOpacity: 1
    },
    offset: 0.613281
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#bec0c2",
      stopOpacity: 1
    },
    offset: 0.617188
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#bdbfc1",
      stopOpacity: 1
    },
    offset: 0.621094
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#bcbec0",
      stopOpacity: 1
    },
    offset: 0.625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#bdbfc1",
      stopOpacity: 1
    },
    offset: 0.628906
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#bec0c2",
      stopOpacity: 1
    },
    offset: 0.632812
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c0c2c4",
      stopOpacity: 1
    },
    offset: 0.636719
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c1c3c5",
      stopOpacity: 1
    },
    offset: 0.640625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c3c4c6",
      stopOpacity: 1
    },
    offset: 0.644531
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c4c6c7",
      stopOpacity: 1
    },
    offset: 0.648438
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c5c7c9",
      stopOpacity: 1
    },
    offset: 0.652344
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c7c8ca",
      stopOpacity: 1
    },
    offset: 0.65625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c8cacb",
      stopOpacity: 1
    },
    offset: 0.660156
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#cacbcd",
      stopOpacity: 1
    },
    offset: 0.664062
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#cbcdce",
      stopOpacity: 1
    },
    offset: 0.667969
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#cccecf",
      stopOpacity: 1
    },
    offset: 0.671875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#cecfd1",
      stopOpacity: 1
    },
    offset: 0.675781
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#cfd1d2",
      stopOpacity: 1
    },
    offset: 0.679688
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d1d2d3",
      stopOpacity: 1
    },
    offset: 0.683594
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d2d3d5",
      stopOpacity: 1
    },
    offset: 0.6875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d3d5d6",
      stopOpacity: 1
    },
    offset: 0.691406
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d5d6d7",
      stopOpacity: 1
    },
    offset: 0.695312
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d6d7d9",
      stopOpacity: 1
    },
    offset: 0.699219
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d8d9da",
      stopOpacity: 1
    },
    offset: 0.703125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d9dadb",
      stopOpacity: 1
    },
    offset: 0.707031
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#dadbdd",
      stopOpacity: 1
    },
    offset: 0.710938
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#dcddde",
      stopOpacity: 1
    },
    offset: 0.714844
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#dddedf",
      stopOpacity: 1
    },
    offset: 0.71875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#dfe0e0",
      stopOpacity: 1
    },
    offset: 0.722656
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e0e1e2",
      stopOpacity: 1
    },
    offset: 0.726562
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e1e2e3",
      stopOpacity: 1
    },
    offset: 0.730469
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e3e4e4",
      stopOpacity: 1
    },
    offset: 0.734375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e4e5e6",
      stopOpacity: 1
    },
    offset: 0.738281
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e6e6e7",
      stopOpacity: 1
    },
    offset: 0.742188
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e7e8e8",
      stopOpacity: 1
    },
    offset: 0.746094
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e8e9ea",
      stopOpacity: 1
    },
    offset: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#eaeaeb",
      stopOpacity: 1
    },
    offset: 0.753906
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ebecec",
      stopOpacity: 1
    },
    offset: 0.757812
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ededee",
      stopOpacity: 1
    },
    offset: 0.761719
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#eeeeef",
      stopOpacity: 1
    },
    offset: 0.765625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#eff0f0",
      stopOpacity: 1
    },
    offset: 0.769531
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f1f1f2",
      stopOpacity: 1
    },
    offset: 0.773438
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f2f3f3",
      stopOpacity: 1
    },
    offset: 0.777344
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f4f4f4",
      stopOpacity: 1
    },
    offset: 0.78125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f5f5f6",
      stopOpacity: 1
    },
    offset: 0.785156
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f6f7f7",
      stopOpacity: 1
    },
    offset: 0.789062
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f8f8f8",
      stopOpacity: 1
    },
    offset: 0.792969
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f9f9f9",
      stopOpacity: 1
    },
    offset: 0.796875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fbfbfb",
      stopOpacity: 1
    },
    offset: 0.800781
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fcfcfc",
      stopOpacity: 1
    },
    offset: 0.804688
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fdfdfd",
      stopOpacity: 1
    },
    offset: 0.808594
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ffffff",
      stopOpacity: 1
    },
    offset: 0.8125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fcfcfd",
      stopOpacity: 1
    },
    offset: 0.816406
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fafafa",
      stopOpacity: 1
    },
    offset: 0.820312
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f8f8f8",
      stopOpacity: 1
    },
    offset: 0.824219
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f5f5f5",
      stopOpacity: 1
    },
    offset: 0.828125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f2f2f3",
      stopOpacity: 1
    },
    offset: 0.832031
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f0f0f0",
      stopOpacity: 1
    },
    offset: 0.835938
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ededed",
      stopOpacity: 1
    },
    offset: 0.839844
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#eaeaeb",
      stopOpacity: 1
    },
    offset: 0.84375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e8e8e8",
      stopOpacity: 1
    },
    offset: 0.847656
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e5e5e6",
      stopOpacity: 1
    },
    offset: 0.851562
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e2e2e3",
      stopOpacity: 1
    },
    offset: 0.855469
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e0e0e0",
      stopOpacity: 1
    },
    offset: 0.859375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ddddde",
      stopOpacity: 1
    },
    offset: 0.863281
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#dadbdb",
      stopOpacity: 1
    },
    offset: 0.867188
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d8d8d9",
      stopOpacity: 1
    },
    offset: 0.871094
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d5d5d6",
      stopOpacity: 1
    },
    offset: 0.875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d2d3d3",
      stopOpacity: 1
    },
    offset: 0.878906
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d0d0d1",
      stopOpacity: 1
    },
    offset: 0.882812
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#cdcdce",
      stopOpacity: 1
    },
    offset: 0.886719
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#cacbcc",
      stopOpacity: 1
    },
    offset: 0.890625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c8c8c9",
      stopOpacity: 1
    },
    offset: 0.894531
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c5c5c6",
      stopOpacity: 1
    },
    offset: 0.898438
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c2c3c4",
      stopOpacity: 1
    },
    offset: 0.902344
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c0c0c1",
      stopOpacity: 1
    },
    offset: 0.90625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#bdbdbf",
      stopOpacity: 1
    },
    offset: 0.910156
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#babbbc",
      stopOpacity: 1
    },
    offset: 0.914062
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#b8b8b9",
      stopOpacity: 1
    },
    offset: 0.917969
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#b5b6b7",
      stopOpacity: 1
    },
    offset: 0.921875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#b2b3b4",
      stopOpacity: 1
    },
    offset: 0.925781
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#b0b0b2",
      stopOpacity: 1
    },
    offset: 0.929688
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#adaeaf",
      stopOpacity: 1
    },
    offset: 0.933594
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#aaabac",
      stopOpacity: 1
    },
    offset: 0.9375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#a8a8aa",
      stopOpacity: 1
    },
    offset: 0.941406
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#a5a6a7",
      stopOpacity: 1
    },
    offset: 0.945312
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#a2a3a4",
      stopOpacity: 1
    },
    offset: 0.949219
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#a0a0a2",
      stopOpacity: 1
    },
    offset: 0.953125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#9d9e9f",
      stopOpacity: 1
    },
    offset: 0.957031
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#9a9b9d",
      stopOpacity: 1
    },
    offset: 0.960938
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#98989a",
      stopOpacity: 1
    },
    offset: 0.964844
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#959697",
      stopOpacity: 1
    },
    offset: 0.96875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#929395",
      stopOpacity: 1
    },
    offset: 0.972656
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#909192",
      stopOpacity: 1
    },
    offset: 0.976562
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#8d8e90",
      stopOpacity: 1
    },
    offset: 0.980469
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#8a8b8d",
      stopOpacity: 1
    },
    offset: 0.984375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#88898a",
      stopOpacity: 1
    },
    offset: 0.988281
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#858688",
      stopOpacity: 1
    },
    offset: 0.992188
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#828385",
      stopOpacity: 1
    },
    offset: 0.996094
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#808183",
      stopOpacity: 1
    },
    offset: 1
  })), _ref22, _ref23, /*#__PURE__*/React.createElement("linearGradient", {
    x1: 250.999989,
    gradientTransform: "matrix(1.529572,0,0,-1.5297,-0.090027,191.286603)",
    y1: 26.271,
    x2: 271.499988,
    gradientUnits: "userSpaceOnUse",
    y2: 26.271,
    id: "6b7122c52f"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#bbbcbe",
      stopOpacity: 1
    },
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#bcbdbf",
      stopOpacity: 1
    },
    offset: 0.00390625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#bdbec0",
      stopOpacity: 1
    },
    offset: 0.0078125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#bebfc1",
      stopOpacity: 1
    },
    offset: 0.0117187
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#bfc0c2",
      stopOpacity: 1
    },
    offset: 0.015625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#bfc0c2",
      stopOpacity: 1
    },
    offset: 0.0195312
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c0c1c3",
      stopOpacity: 1
    },
    offset: 0.0234375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c1c2c4",
      stopOpacity: 1
    },
    offset: 0.0273438
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c2c3c5",
      stopOpacity: 1
    },
    offset: 0.03125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c3c4c6",
      stopOpacity: 1
    },
    offset: 0.0351562
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c4c5c6",
      stopOpacity: 1
    },
    offset: 0.0390625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c5c6c7",
      stopOpacity: 1
    },
    offset: 0.0429688
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c6c6c8",
      stopOpacity: 1
    },
    offset: 0.046875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c6c7c9",
      stopOpacity: 1
    },
    offset: 0.0507812
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c7c8ca",
      stopOpacity: 1
    },
    offset: 0.0546875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c8c9cb",
      stopOpacity: 1
    },
    offset: 0.0585938
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c9cacb",
      stopOpacity: 1
    },
    offset: 0.0625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#cacbcc",
      stopOpacity: 1
    },
    offset: 0.0664062
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#cbcbcd",
      stopOpacity: 1
    },
    offset: 0.0703125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ccccce",
      stopOpacity: 1
    },
    offset: 0.0742188
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#cccdcf",
      stopOpacity: 1
    },
    offset: 0.078125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#cdcecf",
      stopOpacity: 1
    },
    offset: 0.0820312
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#cecfd0",
      stopOpacity: 1
    },
    offset: 0.0859375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#cfd0d1",
      stopOpacity: 1
    },
    offset: 0.0898438
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d0d0d2",
      stopOpacity: 1
    },
    offset: 0.09375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d1d1d3",
      stopOpacity: 1
    },
    offset: 0.0976562
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d2d2d4",
      stopOpacity: 1
    },
    offset: 0.101562
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d2d3d4",
      stopOpacity: 1
    },
    offset: 0.105469
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d3d4d5",
      stopOpacity: 1
    },
    offset: 0.109375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d4d5d6",
      stopOpacity: 1
    },
    offset: 0.113281
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d5d6d7",
      stopOpacity: 1
    },
    offset: 0.117188
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d6d6d8",
      stopOpacity: 1
    },
    offset: 0.121094
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d7d7d8",
      stopOpacity: 1
    },
    offset: 0.125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d8d8d9",
      stopOpacity: 1
    },
    offset: 0.128906
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d8d9da",
      stopOpacity: 1
    },
    offset: 0.132812
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d9dadb",
      stopOpacity: 1
    },
    offset: 0.136719
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#dadbdc",
      stopOpacity: 1
    },
    offset: 0.140625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#dbdbdd",
      stopOpacity: 1
    },
    offset: 0.144531
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#dcdcdd",
      stopOpacity: 1
    },
    offset: 0.148438
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ddddde",
      stopOpacity: 1
    },
    offset: 0.152344
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#dededf",
      stopOpacity: 1
    },
    offset: 0.15625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#dedfe0",
      stopOpacity: 1
    },
    offset: 0.160156
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#dfe0e1",
      stopOpacity: 1
    },
    offset: 0.164063
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e0e1e1",
      stopOpacity: 1
    },
    offset: 0.167969
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e1e1e2",
      stopOpacity: 1
    },
    offset: 0.171875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e2e2e3",
      stopOpacity: 1
    },
    offset: 0.175781
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e3e3e4",
      stopOpacity: 1
    },
    offset: 0.179688
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e4e4e5",
      stopOpacity: 1
    },
    offset: 0.183594
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e4e5e6",
      stopOpacity: 1
    },
    offset: 0.1875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e5e6e6",
      stopOpacity: 1
    },
    offset: 0.191406
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e6e6e7",
      stopOpacity: 1
    },
    offset: 0.195313
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e7e7e8",
      stopOpacity: 1
    },
    offset: 0.199219
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e8e8e9",
      stopOpacity: 1
    },
    offset: 0.203125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e9e9ea",
      stopOpacity: 1
    },
    offset: 0.207031
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#eaeaea",
      stopOpacity: 1
    },
    offset: 0.210938
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#eaebeb",
      stopOpacity: 1
    },
    offset: 0.214844
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ebecec",
      stopOpacity: 1
    },
    offset: 0.21875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ececed",
      stopOpacity: 1
    },
    offset: 0.222656
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ededee",
      stopOpacity: 1
    },
    offset: 0.226563
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#eeeeef",
      stopOpacity: 1
    },
    offset: 0.230469
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#efefef",
      stopOpacity: 1
    },
    offset: 0.234375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f0f0f0",
      stopOpacity: 1
    },
    offset: 0.238281
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f0f1f1",
      stopOpacity: 1
    },
    offset: 0.242188
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f1f1f2",
      stopOpacity: 1
    },
    offset: 0.246094
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f2f2f3",
      stopOpacity: 1
    },
    offset: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f3f3f3",
      stopOpacity: 1
    },
    offset: 0.253906
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f4f4f4",
      stopOpacity: 1
    },
    offset: 0.257813
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f5f5f5",
      stopOpacity: 1
    },
    offset: 0.261719
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f6f6f6",
      stopOpacity: 1
    },
    offset: 0.265625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f6f7f7",
      stopOpacity: 1
    },
    offset: 0.269531
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f7f7f8",
      stopOpacity: 1
    },
    offset: 0.273438
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f8f8f8",
      stopOpacity: 1
    },
    offset: 0.277344
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f9f9f9",
      stopOpacity: 1
    },
    offset: 0.28125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fafafa",
      stopOpacity: 1
    },
    offset: 0.285156
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fbfbfb",
      stopOpacity: 1
    },
    offset: 0.289062
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fcfcfc",
      stopOpacity: 1
    },
    offset: 0.292969
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fcfcfd",
      stopOpacity: 1
    },
    offset: 0.296875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fdfdfd",
      stopOpacity: 1
    },
    offset: 0.300781
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fefefe",
      stopOpacity: 1
    },
    offset: 0.304688
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ffffff",
      stopOpacity: 1
    },
    offset: 0.3125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ffffff",
      stopOpacity: 1
    },
    offset: 0.375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ffffff",
      stopOpacity: 1
    },
    offset: 0.4375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ffffff",
      stopOpacity: 1
    },
    offset: 0.46875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ffffff",
      stopOpacity: 1
    },
    offset: 0.484375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ffffff",
      stopOpacity: 1
    },
    offset: 0.492188
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fcfcfc",
      stopOpacity: 1
    },
    offset: 0.496094
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fafafa",
      stopOpacity: 1
    },
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f8f8f9",
      stopOpacity: 1
    },
    offset: 0.503906
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f6f6f7",
      stopOpacity: 1
    },
    offset: 0.507812
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f4f5f5",
      stopOpacity: 1
    },
    offset: 0.511719
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f2f3f3",
      stopOpacity: 1
    },
    offset: 0.515625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f0f1f1",
      stopOpacity: 1
    },
    offset: 0.519531
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#eeefef",
      stopOpacity: 1
    },
    offset: 0.523438
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#eceded",
      stopOpacity: 1
    },
    offset: 0.527344
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#eaebec",
      stopOpacity: 1
    },
    offset: 0.53125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e8e9ea",
      stopOpacity: 1
    },
    offset: 0.535156
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e6e7e8",
      stopOpacity: 1
    },
    offset: 0.539062
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e4e5e6",
      stopOpacity: 1
    },
    offset: 0.542969
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e2e3e4",
      stopOpacity: 1
    },
    offset: 0.546875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e0e1e2",
      stopOpacity: 1
    },
    offset: 0.550781
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#dedfe0",
      stopOpacity: 1
    },
    offset: 0.554688
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#dddedf",
      stopOpacity: 1
    },
    offset: 0.558594
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#dbdcdd",
      stopOpacity: 1
    },
    offset: 0.5625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d9dadb",
      stopOpacity: 1
    },
    offset: 0.566406
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d7d8d9",
      stopOpacity: 1
    },
    offset: 0.570312
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d5d6d7",
      stopOpacity: 1
    },
    offset: 0.574219
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d3d4d5",
      stopOpacity: 1
    },
    offset: 0.578125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d1d2d3",
      stopOpacity: 1
    },
    offset: 0.582031
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#cfd0d2",
      stopOpacity: 1
    },
    offset: 0.585937
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#cdced0",
      stopOpacity: 1
    },
    offset: 0.589844
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#cbccce",
      stopOpacity: 1
    },
    offset: 0.59375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c9cacc",
      stopOpacity: 1
    },
    offset: 0.597656
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c7c8ca",
      stopOpacity: 1
    },
    offset: 0.601562
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c5c7c8",
      stopOpacity: 1
    },
    offset: 0.605469
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c3c5c6",
      stopOpacity: 1
    },
    offset: 0.609375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c1c3c5",
      stopOpacity: 1
    },
    offset: 0.613281
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#bfc1c3",
      stopOpacity: 1
    },
    offset: 0.617188
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#bdbfc1",
      stopOpacity: 1
    },
    offset: 0.621094
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#bbbdbf",
      stopOpacity: 1
    },
    offset: 0.625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#bcbec0",
      stopOpacity: 1
    },
    offset: 0.628906
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#bec0c2",
      stopOpacity: 1
    },
    offset: 0.632813
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#bfc1c3",
      stopOpacity: 1
    },
    offset: 0.636719
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c1c2c4",
      stopOpacity: 1
    },
    offset: 0.640625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c2c4c6",
      stopOpacity: 1
    },
    offset: 0.644531
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c3c5c7",
      stopOpacity: 1
    },
    offset: 0.648438
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c5c6c8",
      stopOpacity: 1
    },
    offset: 0.652344
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c6c8c9",
      stopOpacity: 1
    },
    offset: 0.65625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c7c9cb",
      stopOpacity: 1
    },
    offset: 0.660156
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c9cacc",
      stopOpacity: 1
    },
    offset: 0.664062
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#cacccd",
      stopOpacity: 1
    },
    offset: 0.667969
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#cccdcf",
      stopOpacity: 1
    },
    offset: 0.671875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#cdcfd0",
      stopOpacity: 1
    },
    offset: 0.675781
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ced0d1",
      stopOpacity: 1
    },
    offset: 0.679688
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d0d1d3",
      stopOpacity: 1
    },
    offset: 0.683594
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d1d3d4",
      stopOpacity: 1
    },
    offset: 0.6875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d3d4d5",
      stopOpacity: 1
    },
    offset: 0.691406
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d4d5d7",
      stopOpacity: 1
    },
    offset: 0.695312
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d5d7d8",
      stopOpacity: 1
    },
    offset: 0.699219
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d7d8d9",
      stopOpacity: 1
    },
    offset: 0.703125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d8d9db",
      stopOpacity: 1
    },
    offset: 0.707031
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#dadbdc",
      stopOpacity: 1
    },
    offset: 0.710938
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#dbdcdd",
      stopOpacity: 1
    },
    offset: 0.714844
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#dcddde",
      stopOpacity: 1
    },
    offset: 0.71875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#dedfe0",
      stopOpacity: 1
    },
    offset: 0.722656
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#dfe0e1",
      stopOpacity: 1
    },
    offset: 0.726563
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e1e1e2",
      stopOpacity: 1
    },
    offset: 0.730469
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e2e3e4",
      stopOpacity: 1
    },
    offset: 0.734375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e3e4e5",
      stopOpacity: 1
    },
    offset: 0.738281
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e5e6e6",
      stopOpacity: 1
    },
    offset: 0.742188
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e6e7e8",
      stopOpacity: 1
    },
    offset: 0.746094
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e8e8e9",
      stopOpacity: 1
    },
    offset: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e9eaea",
      stopOpacity: 1
    },
    offset: 0.753906
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#eaebec",
      stopOpacity: 1
    },
    offset: 0.757812
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ececed",
      stopOpacity: 1
    },
    offset: 0.761719
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#edeeee",
      stopOpacity: 1
    },
    offset: 0.765625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#efeff0",
      stopOpacity: 1
    },
    offset: 0.769531
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f0f0f1",
      stopOpacity: 1
    },
    offset: 0.773438
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f1f2f2",
      stopOpacity: 1
    },
    offset: 0.777344
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f3f3f3",
      stopOpacity: 1
    },
    offset: 0.78125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f4f4f5",
      stopOpacity: 1
    },
    offset: 0.785156
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f6f6f6",
      stopOpacity: 1
    },
    offset: 0.789062
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f7f7f7",
      stopOpacity: 1
    },
    offset: 0.792969
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f8f8f9",
      stopOpacity: 1
    },
    offset: 0.796875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fafafa",
      stopOpacity: 1
    },
    offset: 0.800781
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fbfbfb",
      stopOpacity: 1
    },
    offset: 0.804688
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fcfdfd",
      stopOpacity: 1
    },
    offset: 0.808594
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fefefe",
      stopOpacity: 1
    },
    offset: 0.8125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fdfdfd",
      stopOpacity: 1
    },
    offset: 0.816406
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fcfcfc",
      stopOpacity: 1
    },
    offset: 0.820313
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f9f9f9",
      stopOpacity: 1
    },
    offset: 0.824219
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f7f7f7",
      stopOpacity: 1
    },
    offset: 0.828125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f4f4f4",
      stopOpacity: 1
    },
    offset: 0.832031
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f1f1f2",
      stopOpacity: 1
    },
    offset: 0.835938
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#efefef",
      stopOpacity: 1
    },
    offset: 0.839844
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ececec",
      stopOpacity: 1
    },
    offset: 0.84375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e9e9ea",
      stopOpacity: 1
    },
    offset: 0.847656
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e7e7e7",
      stopOpacity: 1
    },
    offset: 0.851563
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e4e4e5",
      stopOpacity: 1
    },
    offset: 0.855469
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e1e1e2",
      stopOpacity: 1
    },
    offset: 0.859375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#dfdfdf",
      stopOpacity: 1
    },
    offset: 0.863281
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#dcdcdd",
      stopOpacity: 1
    },
    offset: 0.867188
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d9dada",
      stopOpacity: 1
    },
    offset: 0.871094
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d7d7d8",
      stopOpacity: 1
    },
    offset: 0.875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d4d4d5",
      stopOpacity: 1
    },
    offset: 0.878906
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d1d2d2",
      stopOpacity: 1
    },
    offset: 0.882812
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#cfcfd0",
      stopOpacity: 1
    },
    offset: 0.886719
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#cccccd",
      stopOpacity: 1
    },
    offset: 0.890625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c9cacb",
      stopOpacity: 1
    },
    offset: 0.894531
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c7c7c8",
      stopOpacity: 1
    },
    offset: 0.898438
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c4c5c5",
      stopOpacity: 1
    },
    offset: 0.902344
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c1c2c3",
      stopOpacity: 1
    },
    offset: 0.90625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#bfbfc0",
      stopOpacity: 1
    },
    offset: 0.910156
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#bcbdbe",
      stopOpacity: 1
    },
    offset: 0.914062
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#b9babb",
      stopOpacity: 1
    },
    offset: 0.917969
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#b7b7b8",
      stopOpacity: 1
    },
    offset: 0.921875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#b4b5b6",
      stopOpacity: 1
    },
    offset: 0.925781
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#b1b2b3",
      stopOpacity: 1
    },
    offset: 0.929687
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#afafb1",
      stopOpacity: 1
    },
    offset: 0.933594
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#acadae",
      stopOpacity: 1
    },
    offset: 0.9375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#a9aaac",
      stopOpacity: 1
    },
    offset: 0.941406
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#a7a8a9",
      stopOpacity: 1
    },
    offset: 0.945312
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#a4a5a6",
      stopOpacity: 1
    },
    offset: 0.949219
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#a1a2a4",
      stopOpacity: 1
    },
    offset: 0.953125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#9fa0a1",
      stopOpacity: 1
    },
    offset: 0.957031
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#9c9d9f",
      stopOpacity: 1
    },
    offset: 0.960938
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#9a9a9c",
      stopOpacity: 1
    },
    offset: 0.964844
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#979899",
      stopOpacity: 1
    },
    offset: 0.96875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#949597",
      stopOpacity: 1
    },
    offset: 0.972656
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#929294",
      stopOpacity: 1
    },
    offset: 0.976562
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#8f9092",
      stopOpacity: 1
    },
    offset: 0.980469
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#8c8d8f",
      stopOpacity: 1
    },
    offset: 0.984375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#8a8b8c",
      stopOpacity: 1
    },
    offset: 0.988281
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#87888a",
      stopOpacity: 1
    },
    offset: 0.992188
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#848587",
      stopOpacity: 1
    },
    offset: 0.996094
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#828385",
      stopOpacity: 1
    },
    offset: 1
  })), _ref24, _ref25, /*#__PURE__*/React.createElement("linearGradient", {
    x1: 19.700004,
    gradientTransform: "matrix(1.529572,0,0,-1.5297,-0.090027,191.286603)",
    y1: 29.732,
    x2: 271.200028,
    gradientUnits: "userSpaceOnUse",
    y2: 29.732,
    id: "0a124d597e"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#bbbcbe",
      stopOpacity: 1
    },
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#b9babc",
      stopOpacity: 1
    },
    offset: 0.00390625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#b8b9bb",
      stopOpacity: 1
    },
    offset: 0.0078125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#b6b7b9",
      stopOpacity: 1
    },
    offset: 0.0117188
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#b5b6b8",
      stopOpacity: 1
    },
    offset: 0.015625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#b3b4b6",
      stopOpacity: 1
    },
    offset: 0.0195312
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#b2b3b5",
      stopOpacity: 1
    },
    offset: 0.0234375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#b0b1b3",
      stopOpacity: 1
    },
    offset: 0.0273438
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#aeb0b2",
      stopOpacity: 1
    },
    offset: 0.03125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#adaeb0",
      stopOpacity: 1
    },
    offset: 0.0351563
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#abadaf",
      stopOpacity: 1
    },
    offset: 0.0390625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#aaabad",
      stopOpacity: 1
    },
    offset: 0.0429688
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#a8aaac",
      stopOpacity: 1
    },
    offset: 0.046875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#a7a8aa",
      stopOpacity: 1
    },
    offset: 0.0507812
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#a5a7a9",
      stopOpacity: 1
    },
    offset: 0.0546875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#a4a5a7",
      stopOpacity: 1
    },
    offset: 0.0585938
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#a2a4a6",
      stopOpacity: 1
    },
    offset: 0.0625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#a1a2a4",
      stopOpacity: 1
    },
    offset: 0.0664062
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#9fa0a3",
      stopOpacity: 1
    },
    offset: 0.0703125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#9d9fa1",
      stopOpacity: 1
    },
    offset: 0.0742188
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#9c9d9f",
      stopOpacity: 1
    },
    offset: 0.078125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#9a9c9e",
      stopOpacity: 1
    },
    offset: 0.0820312
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#999a9c",
      stopOpacity: 1
    },
    offset: 0.0859375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#97999b",
      stopOpacity: 1
    },
    offset: 0.0898437
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#969799",
      stopOpacity: 1
    },
    offset: 0.09375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#949698",
      stopOpacity: 1
    },
    offset: 0.0976562
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#939496",
      stopOpacity: 1
    },
    offset: 0.101562
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#919395",
      stopOpacity: 1
    },
    offset: 0.105469
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#909193",
      stopOpacity: 1
    },
    offset: 0.109375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#8e9092",
      stopOpacity: 1
    },
    offset: 0.113281
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#8c8e90",
      stopOpacity: 1
    },
    offset: 0.117187
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#8b8d8f",
      stopOpacity: 1
    },
    offset: 0.121094
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#898b8d",
      stopOpacity: 1
    },
    offset: 0.125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#888a8c",
      stopOpacity: 1
    },
    offset: 0.128906
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#86888a",
      stopOpacity: 1
    },
    offset: 0.132812
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#858789",
      stopOpacity: 1
    },
    offset: 0.136719
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#838587",
      stopOpacity: 1
    },
    offset: 0.140625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#828486",
      stopOpacity: 1
    },
    offset: 0.144531
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#808284",
      stopOpacity: 1
    },
    offset: 0.148437
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#838587",
      stopOpacity: 1
    },
    offset: 0.152344
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#86888a",
      stopOpacity: 1
    },
    offset: 0.15625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#898b8d",
      stopOpacity: 1
    },
    offset: 0.160156
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#8c8e90",
      stopOpacity: 1
    },
    offset: 0.164062
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#8f9193",
      stopOpacity: 1
    },
    offset: 0.167969
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#929496",
      stopOpacity: 1
    },
    offset: 0.171875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#959799",
      stopOpacity: 1
    },
    offset: 0.175781
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#999a9c",
      stopOpacity: 1
    },
    offset: 0.179688
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#9c9d9f",
      stopOpacity: 1
    },
    offset: 0.183594
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#9fa0a2",
      stopOpacity: 1
    },
    offset: 0.1875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#a2a3a5",
      stopOpacity: 1
    },
    offset: 0.191406
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#a5a6a8",
      stopOpacity: 1
    },
    offset: 0.195312
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#a8a9ab",
      stopOpacity: 1
    },
    offset: 0.199219
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#abadae",
      stopOpacity: 1
    },
    offset: 0.203125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#aeb0b1",
      stopOpacity: 1
    },
    offset: 0.207031
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#b1b3b4",
      stopOpacity: 1
    },
    offset: 0.210938
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#b4b6b7",
      stopOpacity: 1
    },
    offset: 0.214844
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#b8b9ba",
      stopOpacity: 1
    },
    offset: 0.21875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#bbbcbd",
      stopOpacity: 1
    },
    offset: 0.222656
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#bebfc0",
      stopOpacity: 1
    },
    offset: 0.226562
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c1c2c3",
      stopOpacity: 1
    },
    offset: 0.230469
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c4c5c6",
      stopOpacity: 1
    },
    offset: 0.234375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c7c8c9",
      stopOpacity: 1
    },
    offset: 0.238281
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#cacbcc",
      stopOpacity: 1
    },
    offset: 0.242188
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#cdcecf",
      stopOpacity: 1
    },
    offset: 0.246094
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d0d1d2",
      stopOpacity: 1
    },
    offset: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d3d4d5",
      stopOpacity: 1
    },
    offset: 0.253906
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d7d7d8",
      stopOpacity: 1
    },
    offset: 0.257812
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#dadadb",
      stopOpacity: 1
    },
    offset: 0.261719
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ddddde",
      stopOpacity: 1
    },
    offset: 0.265625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e0e0e1",
      stopOpacity: 1
    },
    offset: 0.269531
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e3e3e4",
      stopOpacity: 1
    },
    offset: 0.273438
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e6e6e7",
      stopOpacity: 1
    },
    offset: 0.277344
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e9eaea",
      stopOpacity: 1
    },
    offset: 0.28125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#eceded",
      stopOpacity: 1
    },
    offset: 0.285156
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#eff0f0",
      stopOpacity: 1
    },
    offset: 0.289063
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f2f3f3",
      stopOpacity: 1
    },
    offset: 0.292969
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f6f6f6",
      stopOpacity: 1
    },
    offset: 0.296875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f9f9f9",
      stopOpacity: 1
    },
    offset: 0.300781
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fcfcfc",
      stopOpacity: 1
    },
    offset: 0.304688
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fdfdfd",
      stopOpacity: 1
    },
    offset: 0.308594
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ffffff",
      stopOpacity: 1
    },
    offset: 0.3125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ffffff",
      stopOpacity: 1
    },
    offset: 0.375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ffffff",
      stopOpacity: 1
    },
    offset: 0.4375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ffffff",
      stopOpacity: 1
    },
    offset: 0.46875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ffffff",
      stopOpacity: 1
    },
    offset: 0.484375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fefefe",
      stopOpacity: 1
    },
    offset: 0.488281
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fdfdfd",
      stopOpacity: 1
    },
    offset: 0.492188
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fafafb",
      stopOpacity: 1
    },
    offset: 0.496094
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f8f8f8",
      stopOpacity: 1
    },
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f5f5f5",
      stopOpacity: 1
    },
    offset: 0.503906
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f2f2f2",
      stopOpacity: 1
    },
    offset: 0.507812
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#efeff0",
      stopOpacity: 1
    },
    offset: 0.511719
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ececed",
      stopOpacity: 1
    },
    offset: 0.515625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e9eaea",
      stopOpacity: 1
    },
    offset: 0.519531
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e6e7e7",
      stopOpacity: 1
    },
    offset: 0.523438
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e4e4e5",
      stopOpacity: 1
    },
    offset: 0.527344
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e1e1e2",
      stopOpacity: 1
    },
    offset: 0.53125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#dededf",
      stopOpacity: 1
    },
    offset: 0.535156
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#dbdbdc",
      stopOpacity: 1
    },
    offset: 0.539062
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d8d9da",
      stopOpacity: 1
    },
    offset: 0.542969
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d5d6d7",
      stopOpacity: 1
    },
    offset: 0.546875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d2d3d4",
      stopOpacity: 1
    },
    offset: 0.550781
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d0d0d1",
      stopOpacity: 1
    },
    offset: 0.554688
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#cdcdcf",
      stopOpacity: 1
    },
    offset: 0.558594
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#cacacc",
      stopOpacity: 1
    },
    offset: 0.5625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c7c8c9",
      stopOpacity: 1
    },
    offset: 0.566406
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c4c5c6",
      stopOpacity: 1
    },
    offset: 0.570312
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c1c2c4",
      stopOpacity: 1
    },
    offset: 0.574219
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#bebfc1",
      stopOpacity: 1
    },
    offset: 0.578125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#bcbcbe",
      stopOpacity: 1
    },
    offset: 0.582031
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#b9babc",
      stopOpacity: 1
    },
    offset: 0.585937
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#b6b7b9",
      stopOpacity: 1
    },
    offset: 0.589844
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#b3b4b6",
      stopOpacity: 1
    },
    offset: 0.59375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#b0b1b3",
      stopOpacity: 1
    },
    offset: 0.597656
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#adaeb1",
      stopOpacity: 1
    },
    offset: 0.601562
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ababae",
      stopOpacity: 1
    },
    offset: 0.605469
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#a8a9ab",
      stopOpacity: 1
    },
    offset: 0.609375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#a5a6a8",
      stopOpacity: 1
    },
    offset: 0.613281
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#a2a3a6",
      stopOpacity: 1
    },
    offset: 0.617187
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#a0a1a4",
      stopOpacity: 1
    },
    offset: 0.621094
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#9e9fa1",
      stopOpacity: 1
    },
    offset: 0.625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#a0a1a3",
      stopOpacity: 1
    },
    offset: 0.628906
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#a2a3a5",
      stopOpacity: 1
    },
    offset: 0.632812
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#a4a5a7",
      stopOpacity: 1
    },
    offset: 0.636719
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#a6a7a9",
      stopOpacity: 1
    },
    offset: 0.640625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#a8a9ab",
      stopOpacity: 1
    },
    offset: 0.644531
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#aaabad",
      stopOpacity: 1
    },
    offset: 0.648437
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#acadaf",
      stopOpacity: 1
    },
    offset: 0.652344
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#aeafb1",
      stopOpacity: 1
    },
    offset: 0.65625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#b0b1b3",
      stopOpacity: 1
    },
    offset: 0.660156
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#b2b3b5",
      stopOpacity: 1
    },
    offset: 0.664062
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#b4b5b7",
      stopOpacity: 1
    },
    offset: 0.667969
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#b6b7b9",
      stopOpacity: 1
    },
    offset: 0.671875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#b8b9bb",
      stopOpacity: 1
    },
    offset: 0.675781
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#babbbd",
      stopOpacity: 1
    },
    offset: 0.679687
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#bcbdbe",
      stopOpacity: 1
    },
    offset: 0.683594
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#bebfc0",
      stopOpacity: 1
    },
    offset: 0.6875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c0c1c2",
      stopOpacity: 1
    },
    offset: 0.691406
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c2c3c4",
      stopOpacity: 1
    },
    offset: 0.695312
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c4c5c6",
      stopOpacity: 1
    },
    offset: 0.699219
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c6c7c8",
      stopOpacity: 1
    },
    offset: 0.703125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c8c8ca",
      stopOpacity: 1
    },
    offset: 0.707031
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#cacacc",
      stopOpacity: 1
    },
    offset: 0.710938
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ccccce",
      stopOpacity: 1
    },
    offset: 0.714844
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ceced0",
      stopOpacity: 1
    },
    offset: 0.71875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d0d0d2",
      stopOpacity: 1
    },
    offset: 0.722656
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d2d2d4",
      stopOpacity: 1
    },
    offset: 0.726562
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d4d4d6",
      stopOpacity: 1
    },
    offset: 0.730469
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d6d6d8",
      stopOpacity: 1
    },
    offset: 0.734375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d8d8da",
      stopOpacity: 1
    },
    offset: 0.738281
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#dadadb",
      stopOpacity: 1
    },
    offset: 0.742187
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#dcdcdd",
      stopOpacity: 1
    },
    offset: 0.746094
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#dededf",
      stopOpacity: 1
    },
    offset: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e0e0e1",
      stopOpacity: 1
    },
    offset: 0.753906
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e2e2e3",
      stopOpacity: 1
    },
    offset: 0.757812
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e4e4e5",
      stopOpacity: 1
    },
    offset: 0.761719
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e6e6e7",
      stopOpacity: 1
    },
    offset: 0.765625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e8e8e9",
      stopOpacity: 1
    },
    offset: 0.769531
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#eaeaeb",
      stopOpacity: 1
    },
    offset: 0.773437
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ececed",
      stopOpacity: 1
    },
    offset: 0.777344
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#eeeeef",
      stopOpacity: 1
    },
    offset: 0.78125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f0f0f1",
      stopOpacity: 1
    },
    offset: 0.785156
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f2f2f3",
      stopOpacity: 1
    },
    offset: 0.789062
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f4f4f5",
      stopOpacity: 1
    },
    offset: 0.792969
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f6f6f7",
      stopOpacity: 1
    },
    offset: 0.796875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f8f8f8",
      stopOpacity: 1
    },
    offset: 0.800781
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fafafa",
      stopOpacity: 1
    },
    offset: 0.804687
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fcfcfc",
      stopOpacity: 1
    },
    offset: 0.808594
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fefefe",
      stopOpacity: 1
    },
    offset: 0.8125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fcfcfd",
      stopOpacity: 1
    },
    offset: 0.816406
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fbfbfb",
      stopOpacity: 1
    },
    offset: 0.820312
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f8f8f8",
      stopOpacity: 1
    },
    offset: 0.824219
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f5f5f6",
      stopOpacity: 1
    },
    offset: 0.828125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f3f3f3",
      stopOpacity: 1
    },
    offset: 0.832031
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f0f0f0",
      stopOpacity: 1
    },
    offset: 0.835938
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ededee",
      stopOpacity: 1
    },
    offset: 0.839844
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ebebeb",
      stopOpacity: 1
    },
    offset: 0.84375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e8e8e9",
      stopOpacity: 1
    },
    offset: 0.847656
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e5e6e6",
      stopOpacity: 1
    },
    offset: 0.851562
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e3e3e3",
      stopOpacity: 1
    },
    offset: 0.855469
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e0e0e1",
      stopOpacity: 1
    },
    offset: 0.859375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#dddede",
      stopOpacity: 1
    },
    offset: 0.863281
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#dbdbdc",
      stopOpacity: 1
    },
    offset: 0.867188
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d8d8d9",
      stopOpacity: 1
    },
    offset: 0.871094
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d5d6d6",
      stopOpacity: 1
    },
    offset: 0.875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d3d3d4",
      stopOpacity: 1
    },
    offset: 0.878906
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d0d0d1",
      stopOpacity: 1
    },
    offset: 0.882812
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#cdcecf",
      stopOpacity: 1
    },
    offset: 0.886719
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#cbcbcc",
      stopOpacity: 1
    },
    offset: 0.890625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c8c8c9",
      stopOpacity: 1
    },
    offset: 0.894531
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c5c6c7",
      stopOpacity: 1
    },
    offset: 0.898437
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c3c3c4",
      stopOpacity: 1
    },
    offset: 0.902344
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c0c0c2",
      stopOpacity: 1
    },
    offset: 0.90625
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#bdbebf",
      stopOpacity: 1
    },
    offset: 0.910156
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#bbbbbc",
      stopOpacity: 1
    },
    offset: 0.914062
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#b8b9ba",
      stopOpacity: 1
    },
    offset: 0.917969
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#b5b6b7",
      stopOpacity: 1
    },
    offset: 0.921875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#b3b3b5",
      stopOpacity: 1
    },
    offset: 0.925781
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#b0b1b2",
      stopOpacity: 1
    },
    offset: 0.929687
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#adaeaf",
      stopOpacity: 1
    },
    offset: 0.933594
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ababad",
      stopOpacity: 1
    },
    offset: 0.9375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#a8a9aa",
      stopOpacity: 1
    },
    offset: 0.941406
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#a5a6a7",
      stopOpacity: 1
    },
    offset: 0.945313
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#a3a3a5",
      stopOpacity: 1
    },
    offset: 0.949219
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#a0a1a2",
      stopOpacity: 1
    },
    offset: 0.953125
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#9d9ea0",
      stopOpacity: 1
    },
    offset: 0.957031
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#9b9b9d",
      stopOpacity: 1
    },
    offset: 0.960938
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#98999a",
      stopOpacity: 1
    },
    offset: 0.964844
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#959698",
      stopOpacity: 1
    },
    offset: 0.96875
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#939495",
      stopOpacity: 1
    },
    offset: 0.972656
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#909193",
      stopOpacity: 1
    },
    offset: 0.976562
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#8d8e90",
      stopOpacity: 1
    },
    offset: 0.980469
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#8b8c8d",
      stopOpacity: 1
    },
    offset: 0.984375
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#88898b",
      stopOpacity: 1
    },
    offset: 0.988281
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#858688",
      stopOpacity: 1
    },
    offset: 0.992188
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#838486",
      stopOpacity: 1
    },
    offset: 0.996094
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#808183",
      stopOpacity: 1
    },
    offset: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "ea4b805a47"
  }, /*#__PURE__*/React.createElement("g", {
    clipRule: "nonzero",
    clipPath: "url(#b09ed15fb0)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 4.077,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "url(#3bcd24afde)",
      strokeMiterlimit: 10
    },
    d: "M 269.200795 40.400582 L 13.599209 40.400582 C 10.700624 40.400582 9.198978 38.000193 10.399273 35.099298 L 17.601044 16.899758 C 18.798786 13.998863 22.100874 11.601028 25.099059 11.601028 L 280.700644 11.601028 C 283.59923 11.601028 285.100875 13.998863 283.90058 16.899758 L 276.59921 34.999708 C 275.501068 38.000193 272.09938 40.400582 269.200795 40.400582 Z M 269.200795 40.400582 ",
    transform: "matrix(1.529572,0,0,1.5297,-0.090027,111.742184)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#1e1e1c",
      fillOpacity: 1
    },
    d: "M 411.671875 173.542969 L 20.710938 173.542969 C 16.277344 173.542969 13.980469 169.871094 15.816406 165.433594 L 26.832031 137.59375 C 28.664062 133.15625 33.714844 129.488281 38.300781 129.488281 L 429.261719 129.488281 C 433.695312 129.488281 435.992188 133.15625 434.15625 137.59375 L 422.988281 165.28125 C 421.308594 169.871094 416.105469 173.542969 411.671875 173.542969 Z M 411.671875 173.542969 "
  }), /*#__PURE__*/React.createElement("g", {
    clipRule: "nonzero",
    clipPath: "url(#5e5447b013)"
  }, /*#__PURE__*/React.createElement("g", {
    clipRule: "nonzero",
    clipPath: "url(#3d6f053119)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#6aea4d3e9e)"
    },
    d: "M 30.65625 165.894531 L 30.65625 136.0625 L 74.859375 136.0625 L 74.859375 165.894531 Z M 30.65625 165.894531 "
  }))), /*#__PURE__*/React.createElement("g", {
    clipRule: "nonzero",
    clipPath: "url(#51e6853c6d)"
  }, /*#__PURE__*/React.createElement("g", {
    clipRule: "nonzero",
    clipPath: "url(#13271a3d2e)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#74c834b79e)"
    },
    d: "M 70.730469 166.046875 L 70.730469 136.21875 L 113.558594 136.21875 L 113.558594 166.046875 Z M 70.730469 166.046875 "
  }))), /*#__PURE__*/React.createElement("g", {
    clipRule: "nonzero",
    clipPath: "url(#2cb828fedd)"
  }, /*#__PURE__*/React.createElement("g", {
    clipRule: "nonzero",
    clipPath: "url(#70324f9bad)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#ebc20216d8)"
    },
    d: "M 105.601562 166.046875 L 105.601562 136.21875 L 147.207031 136.21875 L 147.207031 166.046875 Z M 105.601562 166.046875 "
  }))), /*#__PURE__*/React.createElement("g", {
    clipRule: "nonzero",
    clipPath: "url(#a34f084429)"
  }, /*#__PURE__*/React.createElement("g", {
    clipRule: "nonzero",
    clipPath: "url(#aed4fe9ae2)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#4bad9911d6)"
    },
    d: "M 149.042969 165.742188 L 149.042969 136.21875 L 186.210938 136.21875 L 186.210938 165.742188 Z M 149.042969 165.742188 "
  }))), /*#__PURE__*/React.createElement("g", {
    clipRule: "nonzero",
    clipPath: "url(#b487f8b6f2)"
  }, /*#__PURE__*/React.createElement("g", {
    clipRule: "nonzero",
    clipPath: "url(#9058095b13)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#d7e46bac44)"
    },
    d: "M 179.328125 166.046875 L 179.328125 136.21875 L 210.683594 136.21875 L 210.683594 166.046875 Z M 179.328125 166.046875 "
  }))), /*#__PURE__*/React.createElement("g", {
    clipRule: "nonzero",
    clipPath: "url(#801b189420)"
  }, /*#__PURE__*/React.createElement("g", {
    clipRule: "nonzero",
    clipPath: "url(#da47b4f212)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#bc861fd656)"
    },
    d: "M 210.378906 165.894531 L 210.378906 136.0625 L 251.984375 136.0625 L 251.984375 165.894531 Z M 210.378906 165.894531 "
  }))), /*#__PURE__*/React.createElement("g", {
    clipRule: "nonzero",
    clipPath: "url(#a6910d5dfa)"
  }, /*#__PURE__*/React.createElement("g", {
    clipRule: "nonzero",
    clipPath: "url(#28b8425382)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#0e31cab358)"
    },
    d: "M 254.125 165.742188 L 254.125 136.0625 L 300.011719 136.0625 L 300.011719 165.742188 Z M 254.125 165.742188 "
  }))), /*#__PURE__*/React.createElement("g", {
    clipRule: "nonzero",
    clipPath: "url(#6145e385b9)"
  }, /*#__PURE__*/React.createElement("g", {
    clipRule: "nonzero",
    clipPath: "url(#f584461bc2)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#6a900a02e2)"
    },
    d: "M 294.503906 165.894531 L 294.503906 136.21875 L 338.710938 136.21875 L 338.710938 165.894531 Z M 294.503906 165.894531 "
  }))), /*#__PURE__*/React.createElement("g", {
    clipRule: "nonzero",
    clipPath: "url(#ab8afdcead)"
  }, /*#__PURE__*/React.createElement("g", {
    clipRule: "nonzero",
    clipPath: "url(#c5692db180)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#c79acd08dd)"
    },
    d: "M 333.203125 166.199219 L 333.203125 160.234375 L 341.464844 160.234375 L 341.464844 166.199219 Z M 333.203125 166.199219 "
  }))), /*#__PURE__*/React.createElement("g", {
    clipRule: "nonzero",
    clipPath: "url(#3232ad0dd5)"
  }, /*#__PURE__*/React.createElement("g", {
    clipRule: "nonzero",
    clipPath: "url(#f0c5dd7ad1)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#3228f735eb)"
    },
    d: "M 343.605469 166.046875 L 343.605469 136.21875 L 389.492188 136.21875 L 389.492188 166.046875 Z M 343.605469 166.046875 "
  }))), /*#__PURE__*/React.createElement("g", {
    clipRule: "nonzero",
    clipPath: "url(#698a7754b8)"
  }, /*#__PURE__*/React.createElement("g", {
    clipRule: "nonzero",
    clipPath: "url(#1a0ca03e65)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#6b7122c52f)"
    },
    d: "M 383.832031 165.894531 L 383.832031 136.371094 L 415.1875 136.371094 L 415.1875 165.894531 Z M 383.832031 165.894531 "
  }))), /*#__PURE__*/React.createElement("g", {
    clipRule: "nonzero",
    clipPath: "url(#c7bf9c132b)"
  }, /*#__PURE__*/React.createElement("g", {
    clipRule: "nonzero",
    clipPath: "url(#7700d17572)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#0a124d597e)"
    },
    d: "M 30.042969 164.976562 L 30.042969 126.582031 L 414.730469 126.582031 L 414.730469 164.976562 Z M 30.042969 164.976562 "
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusiness2);
export default __webpack_public_path__ + "static/media/business-2.492844eec93383c0dac6618b41bb6357.svg";
export { ForwardRef as ReactComponent };